
document.addEventListener('algolia.hooks.initialize', function() {

  
  algoliaShopify.hooks.registerHook('beforeAutocompleteFiltersString', function(_defaultFilter) {
    // Don't return the default filter and return a custom filter
    return 'product_type:Part OR product_type:NLA';
    // return 'NOT product_type:Model';
      // return 'NOT product_type:Model OR product_type:"Part with Model"';

});

  algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function(_defaultFilter) {
    // Don't return the default filter and return a custom filter
    // console.log("defaultFilter",_defaultFilter);
    if (window.location.pathname.startsWith('/search')) {
      //console.log("defaultFilter>>>",_defaultFilter);
    return 'product_type:Part OR product_type:NLA OR product_type:Model';
  }

  // Return the default filter for other pages like collections
  //return _defaultFilter;
   if(_defaultFilter) {
      // console.log("filterstring1",_defaultFilter);
      return _defaultFilter + ' AND NOT product_type:"Part with model"  AND NOT product_type:"Part with model NLA"'
    }
    // if(defaultFilter) {
    //   return defaultFilter + ' AND product_type:Part'
    // }
    // else {
    //   return 'product_type:Part';
    // }
    //return 'product_type:Part';
    // return 'NOT product_type:Model';
      // return 'NOT product_type:Model OR product_type:"Part with Model"';

});
  
    algoliaShopify.hooks.registerHook('beforeInstantSearchFacetLimitNumber', function(limit) {
    // Modify default limit, then return a number
    return 100;
  });

algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
  // Change the placeholder text of the autocomplete menu
  options.placeholder = "Enter Models# , Parts# or Keywords";
  
  return options;
});

//   algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function(options) {
//   // Change the placeholder text of the autocomplete menu
//   options.placeholder = "Search by model number / Part number";
  
//   return options;
// });


  
  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    const { html, state } = templateOptions;

const collectionElement = document.querySelector('.namedcollections .aa-Source');
const collectionId = collectionElement ? collectionElement.getAttribute('data-autocomplete-source-id') : null;

if (collectionId === 'collections') {
  // Select the .aa-SourceHeader element within the collectionElement
  const sourceHeader = collectionElement.querySelector('.aa-SourceHeader');

  // Add the class to the .aa-SourceHeader
  if (sourceHeader) {
    sourceHeader.classList.add('SourceHeader_part_none');
  }

  const togglePlus = document.querySelector('.toggle_sign_plus');
  const toggleMinus = document.querySelector('.toggle-sign_minus');

  if (togglePlus) {
    togglePlus.classList.add('part_toggle_plus'); // Add class to the toggle_sign_plus
  }

  if (toggleMinus) {
    toggleMinus.classList.add('part_toggle_minus'); // Add class to the toggle_sign_minus
  }
}
    
const collectionElement_product = document.querySelector('.aa-PanelSection--right .aa-Source');
const collectionId_product = collectionElement_product ? collectionElement_product.getAttribute('data-autocomplete-source-id') : null;

if (collectionId_product === 'products') {
  const sourceHeader_product = collectionElement_product.querySelector('.aa-SourceHeader');

  // Add the class to the .aa-SourceHeader
  if (sourceHeader_product) {
    sourceHeader_product.classList.add('SourceHeader_part_none_product');
  }
}
const collectionElement_model = document.querySelector('.aa-PanelSection--right .pluginmodels .aa-Source');
const collectionId_model = collectionElement_model ? collectionElement_model.getAttribute('data-autocomplete-source-id') : null;

if (collectionId_model === 'modelItems') {
  const sourceHeader_model = collectionElement_model.querySelector('.aa-SourceHeader');

  // Add the class to the .aa-SourceHeader
  if (sourceHeader_model) {
    sourceHeader_model.classList.add('SourceHeader_part_none_model');
  }
}

document.querySelector('.aa-PanelSection--left .aa-SourceHeader').addEventListener('click', function() {
    const panelSections = this.closest('.aa-PanelSections');
    if (panelSections) {
        panelSections.className = 'aa-PanelSections add_Active_class_suggest';
    }
});


 document.querySelector('.aa-PanelSection--right .defaultparts .aa-SourceHeader').addEventListener('click', function() {
    const panelSections = this.closest('.aa-PanelSections');
    if (panelSections) {
        panelSections.className = 'aa-PanelSections add_Active_class_parts';
    }
});   

   
 document.querySelector('.aa-PanelSection--right .pluginmodels .aa-SourceHeader').addEventListener('click', function() {
    const panelSections = this.closest('.aa-PanelSections');
    if (panelSections) {
        panelSections.className = 'aa-PanelSections add_Active_class_model';
    }
});

    
    
    return html`
      <div class="aa-SourceHeader accordian_item">
        <span class="aa-SourceHeaderTitle">
         Parts
        </span>
        <div class="accordian-toggle">
        <span class="toggle-sign toggle_sign_plus">+</span>
        <span class="toggle-sign toggle-sign_minus" style="display:none">-</span>
        </div>
        <div class="aa-SourceHeaderLine" />
      </div>
    `;

  });




  

  // Add the custom plugin to the Autocomplete.
  algoliaShopify.hooks.registerHook("beforeAutocompleteOptions", function (options) {
    const { searchClient } = window.algoliaShopify;
    const { getAlgoliaResults } = window.algoliaShopify.externals;
    options.placeholder = "Search by Model Number/Part Number";



    
        const modelItemsPlugin = {
      name: 'custom-sale-items-plugin',
      //plugins: [tagsPlugin],
      getSources({ query }) {
         return [
          {
            sourceId: "modelItems",
            getItems() {
              return getAlgoliaResults({
                searchClient,
                queries: [{
                  indexName: "shopifyps_products",
                  query,
                  filters: 'product_type:Model',
                  analyticsTags: ["section:models"],
                  clickAnalytics: true,
                  params: {
                  facetQuery: query,
                  maxFacetHits: 10,
                  hitsPerPage: 15, // Set the maximum number of products here
                },
                }]
        // return [
        //   {
        //     sourceId: "saleItems",
        //     getItems() {
        //       return getAlgoliaFacets({
        //         searchClient,
        //         queries: [{
        //           indexName: "shopifyps_products",
        //           facet: 'vendor',
        //           //query,
        //           params: {
        //           facetQuery: query,
        //           maxFacetHits: 10,
        //         },
        //         }]
              }) 
            },
            templates: {
              header({ html, state }) {
                return html`
                  <div class="aa-SourceHeader accordian_item">
                   
                   <span>Models</span>
                     <div class="accordian-toggle">
                    <span class="toggle-sign modelIncre">+</span>
            <span class="toggle-sign modelDecre" style="display:none">-</span>
            </div>
                  </div>`;
              },
              item({ item, components, html }) {
                //console.log("item",item.handle);
               var Brand_json = [
                    {
                      "Brand": "3M Filtrete Products",
                      "lineCode": "MMM"
                    },
                    {
                      "Brand": "Abu Garcia",
                      "lineCode": "ABU"
                    },
                    {
                      "Brand": "Accu Sharp",
                      "lineCode": "ACU"
                    },
                    {
                      "Brand": "Accutemp",
                      "lineCode": "ATP"
                    },
                    {
                      "Brand": "Acer",
                      "lineCode": "ACR"
                    },
                    {
                      "Brand": "Acer Refurb",
                      "lineCode": "ACX"
                    },
                    {
                      "Brand": "Acp",
                      "lineCode": "ACP"
                    },
                    {
                      "Brand": "Acros",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "AeonAir",
                      "lineCode": "ANR"
                    },
                    {
                      "Brand": "Affresh",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "Aga Marvel",
                      "lineCode": "AGA"
                    },
                    {
                      "Brand": "Aiphone",
                      "lineCode": "AIP"
                    },
                    {
                      "Brand": "Air King",
                      "lineCode": "ARK"
                    },
                    {
                      "Brand": "Airmaster",
                      "lineCode": "AMT"
                    },
                    {
                      "Brand": "AIRSLED",
                      "lineCode": "AIR"
                    },
                    {
                      "Brand": "Airtouch",
                      "lineCode": "ACE"
                    },
                    {
                      "Brand": "Aiwa",
                      "lineCode": "AIW"
                    },
                    {
                      "Brand": "Akai",
                      "lineCode": "AKI"
                    },
                    {
                      "Brand": "All Filters",
                      "lineCode": "ACF"
                    },
                    {
                      "Brand": "Alpha",
                      "lineCode": "ALH"
                    },
                    {
                      "Brand": "Alpine",
                      "lineCode": "ALP"
                    },
                    {
                      "Brand": "Alto Shaam",
                      "lineCode": "ATL"
                    },
                    {
                      "Brand": "Amana",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "Amana Commerical",
                      "lineCode": "AMA"
                    },
                    {
                      "Brand": "Amana Menumaster",
                      "lineCode": "AMR"
                    },
                    {
                      "Brand": "Amana Ptac",
                      "lineCode": "AMN"
                    },
                    {
                      "Brand": "American Hakko",
                      "lineCode": "HAK"
                    },
                    {
                      "Brand": "American Metal Filte",
                      "lineCode": "AMF"
                    },
                    {
                      "Brand": "American Range",
                      "lineCode": "ARE"
                    },
                    {
                      "Brand": "American Standard",
                      "lineCode": "AMS"
                    },
                    {
                      "Brand": "Anderic",
                      "lineCode": "NPS"
                    },
                    {
                      "Brand": "Andis",
                      "lineCode": "AND"
                    },
                    {
                      "Brand": "Anets",
                      "lineCode": "ANE"
                    },
                    {
                      "Brand": "ANTUNES",
                      "lineCode": "ANT"
                    },
                    {
                      "Brand": "Aoc/epi",
                      "lineCode": "AOC"
                    },
                    {
                      "Brand": "Apex",
                      "lineCode": "APX"
                    },
                    {
                      "Brand": "Apple",
                      "lineCode": "APL"
                    },
                    {
                      "Brand": "Apple Replacement",
                      "lineCode": "APA"
                    },
                    {
                      "Brand": "APPLI PARTS",
                      "lineCode": "GAL"
                    },
                    {
                      "Brand": "Appliance Parts",
                      "lineCode": "KIT"
                    },
                    {
                      "Brand": "Appliance Parts",
                      "lineCode": "ERP"
                    },
                    {
                      "Brand": "APW Wyott",
                      "lineCode": "AWT"
                    },
                    {
                      "Brand": "Apw Wyott",
                      "lineCode": "APW"
                    },
                    {
                      "Brand": "Arclyte Technologies",
                      "lineCode": "ARC"
                    },
                    {
                      "Brand": "Arctic Air C",
                      "lineCode": "AAC"
                    },
                    {
                      "Brand": "Ariens",
                      "lineCode": "ARI"
                    },
                    {
                      "Brand": "Armstrong",
                      "lineCode": "ARM"
                    },
                    {
                      "Brand": "Asko",
                      "lineCode": "ASK"
                    },
                    {
                      "Brand": "Asti",
                      "lineCode": "AST"
                    },
                    {
                      "Brand": "Astra",
                      "lineCode": "ATR"
                    },
                    {
                      "Brand": "Asus",
                      "lineCode": "ASU"
                    },
                    {
                      "Brand": "Asus Refurb",
                      "lineCode": "ASR"
                    },
                    {
                      "Brand": "Avanti",
                      "lineCode": "AVA"
                    },
                    {
                      "Brand": "Avent",
                      "lineCode": "AVT"
                    },
                    {
                      "Brand": "Axis",
                      "lineCode": "AXI"
                    },
                    {
                      "Brand": "Ayp Craftsman",
                      "lineCode": "HOP"
                    },
                    {
                      "Brand": "B-air",
                      "lineCode": "BAR"
                    },
                    {
                      "Brand": "Backer Ehp",
                      "lineCode": "BAC"
                    },
                    {
                      "Brand": "Bad Part Number",
                      "lineCode": "BAD"
                    },
                    {
                      "Brand": "Bakers Pride",
                      "lineCode": "BAK"
                    },
                    {
                      "Brand": "Baratza",
                      "lineCode": "BTZ"
                    },
                    {
                      "Brand": "Barranca Diamond",
                      "lineCode": "BRD"
                    },
                    {
                      "Brand": "Barry Restore It All",
                      "lineCode": "BRY"
                    },
                    {
                      "Brand": "Bauknecht",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "Baxter",
                      "lineCode": "BAX"
                    },
                    {
                      "Brand": "Baystate Pool",
                      "lineCode": "SPA"
                    },
                    {
                      "Brand": "Beckman Industrial",
                      "lineCode": "BEC"
                    },
                    {
                      "Brand": "Beko",
                      "lineCode": "BEK"
                    },
                    {
                      "Brand": "Belt And Vcr Acc.",
                      "lineCode": "PRB"
                    },
                    {
                      "Brand": "Benq Usa",
                      "lineCode": "BEN"
                    },
                    {
                      "Brand": "Berkel",
                      "lineCode": "BKL"
                    },
                    {
                      "Brand": "Bertazzoni",
                      "lineCode": "BRT"
                    },
                    {
                      "Brand": "Beverage Air",
                      "lineCode": "BEV"
                    },
                    {
                      "Brand": "Binatone Electronics",
                      "lineCode": "BQN"
                    },
                    {
                      "Brand": "Bionaire",
                      "lineCode": "BIO"
                    },
                    {
                      "Brand": "Bissell",
                      "lineCode": "BIS"
                    },
                    {
                      "Brand": "Bizerba",
                      "lineCode": "BIZ"
                    },
                    {
                      "Brand": "BK Precision",
                      "lineCode": "BKP"
                    },
                    {
                      "Brand": "BKI",
                      "lineCode": "BKI"
                    },
                    {
                      "Brand": "Black & Decker",
                      "lineCode": "BLA"
                    },
                    {
                      "Brand": "Blodgett",
                      "lineCode": "BGT"
                    },
                    {
                      "Brand": "Blomberg",
                      "lineCode": "BLM"
                    },
                    {
                      "Brand": "Blue Ember",
                      "lineCode": "BER"
                    },
                    {
                      "Brand": "Bluebird",
                      "lineCode": "BBD"
                    },
                    {
                      "Brand": "Bluedri",
                      "lineCode": "BDR"
                    },
                    {
                      "Brand": "Bolens",
                      "lineCode": "BOL"
                    },
                    {
                      "Brand": "Bosch",
                      "lineCode": "BCH"
                    },
                    {
                      "Brand": "Bosch Tools",
                      "lineCode": "BSH"
                    },
                    {
                      "Brand": "Bostitch",
                      "lineCode": "BTH"
                    },
                    {
                      "Brand": "Boston Acoustics",
                      "lineCode": "BSA"
                    },
                    {
                      "Brand": "Bowers &Wilkins",
                      "lineCode": "BWL"
                    },
                    {
                      "Brand": "Boxes",
                      "lineCode": "BOX"
                    },
                    {
                      "Brand": "Brastemp",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "Braun",
                      "lineCode": "BRA"
                    },
                    {
                      "Brand": "Braun",
                      "lineCode": "BBN"
                    },
                    {
                      "Brand": "Breville",
                      "lineCode": "BRE"
                    },
                    {
                      "Brand": "Briggs Power",
                      "lineCode": "BSG"
                    },
                    {
                      "Brand": "Briggs Stratton",
                      "lineCode": "BSP"
                    },
                    {
                      "Brand": "Britelite Refurbish",
                      "lineCode": "BLR"
                    },
                    {
                      "Brand": "Broan",
                      "lineCode": "BRN"
                    },
                    {
                      "Brand": "Broil King",
                      "lineCode": "BLK"
                    },
                    {
                      "Brand": "Broil-mate",
                      "lineCode": "BRM"
                    },
                    {
                      "Brand": "Broilmaster",
                      "lineCode": "BMR"
                    },
                    {
                      "Brand": "Broksonic",
                      "lineCode": "BRK"
                    },
                    {
                      "Brand": "Brookstone",
                      "lineCode": "BKS"
                    },
                    {
                      "Brand": "Brother",
                      "lineCode": "BRO"
                    },
                    {
                      "Brand": "Brother Refurb",
                      "lineCode": "BRR"
                    },
                    {
                      "Brand": "Brown Stove",
                      "lineCode": "BRS"
                    },
                    {
                      "Brand": "Bunn",
                      "lineCode": "BUN"
                    },
                    {
                      "Brand": "Caloric",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "Calphalon",
                      "lineCode": "CAL"
                    },
                    {
                      "Brand": "Calspa",
                      "lineCode": "CLP"
                    },
                    {
                      "Brand": "Camp Chef",
                      "lineCode": "CCF"
                    },
                    {
                      "Brand": "Campbell Hausfeld",
                      "lineCode": "CHD"
                    },
                    {
                      "Brand": "Canon",
                      "lineCode": "CAN"
                    },
                    {
                      "Brand": "Canon Camera",
                      "lineCode": "CA2"
                    },
                    {
                      "Brand": "Canon Consumer",
                      "lineCode": "CA1"
                    },
                    {
                      "Brand": "Carrier",
                      "lineCode": "CAR"
                    },
                    {
                      "Brand": "Carter-Hoffmann",
                      "lineCode": "CHN"
                    },
                    {
                      "Brand": "CCS",
                      "lineCode": "CCS"
                    },
                    {
                      "Brand": "CELL PHONE PARTS",
                      "lineCode": "SAM"
                    },
                    {
                      "Brand": "CELL PHONE PARTS",
                      "lineCode": "HTC"
                    },
                    {
                      "Brand": "Chamberlain",
                      "lineCode": "CHL"
                    },
                    {
                      "Brand": "Champion",
                      "lineCode": "CHA"
                    },
                    {
                      "Brand": "Champion Moyer Diebel",
                      "lineCode": "CML"
                    },
                    {
                      "Brand": "Chapin",
                      "lineCode": "CPN"
                    },
                    {
                      "Brand": "Char-broil",
                      "lineCode": "CBL"
                    },
                    {
                      "Brand": "Chemicals",
                      "lineCode": "RAW"
                    },
                    {
                      "Brand": "Chemtronics",
                      "lineCode": "CHE"
                    },
                    {
                      "Brand": "Chicago Pneumatic",
                      "lineCode": "CPC"
                    },
                    {
                      "Brand": "Chipquik",
                      "lineCode": "CHI"
                    },
                    {
                      "Brand": "Cielo",
                      "lineCode": "CLO"
                    },
                    {
                      "Brand": "Clarion",
                      "lineCode": "CLR"
                    },
                    {
                      "Brand": "Classen",
                      "lineCode": "CLA"
                    },
                    {
                      "Brand": "Cleco",
                      "lineCode": "CLC"
                    },
                    {
                      "Brand": "Cleveland",
                      "lineCode": "CLE"
                    },
                    {
                      "Brand": "Climate Master",
                      "lineCode": "CLI"
                    },
                    {
                      "Brand": "CMA Dish Machines",
                      "lineCode": "CMA"
                    },
                    {
                      "Brand": "Coleman",
                      "lineCode": "COL"
                    },
                    {
                      "Brand": "Commercial cooking",
                      "lineCode": "CEL"
                    },
                    {
                      "Brand": "Compaq",
                      "lineCode": "CPQ"
                    },
                    {
                      "Brand": "Compaq Refurb",
                      "lineCode": "CPX"
                    },
                    {
                      "Brand": "Computer and Mobile",
                      "lineCode": "COM"
                    },
                    {
                      "Brand": "Computer Parts",
                      "lineCode": "IMT"
                    },
                    {
                      "Brand": "Computer Software",
                      "lineCode": "QUE"
                    },
                    {
                      "Brand": "Consul",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "Continental Fan",
                      "lineCode": "CON"
                    },
                    {
                      "Brand": "Continental Refrigeration",
                      "lineCode": "CRN"
                    },
                    {
                      "Brand": "Convotherm",
                      "lineCode": "CNV"
                    },
                    {
                      "Brand": "Cooper",
                      "lineCode": "COO"
                    },
                    {
                      "Brand": "Cornelius",
                      "lineCode": "COR"
                    },
                    {
                      "Brand": "Craftsman",
                      "lineCode": "CRA"
                    },
                    {
                      "Brand": "Crary Bear Cat",
                      "lineCode": "CBC"
                    },
                    {
                      "Brand": "Crc America",
                      "lineCode": "FBT"
                    },
                    {
                      "Brand": "Cres Cor",
                      "lineCode": "CRC"
                    },
                    {
                      "Brand": "Criterion Appliance",
                      "lineCode": "CRI"
                    },
                    {
                      "Brand": "Crock Pot",
                      "lineCode": "CRP"
                    },
                    {
                      "Brand": "Crown Electronics",
                      "lineCode": "CRO"
                    },
                    {
                      "Brand": "Crown Steam",
                      "lineCode": "CSM"
                    },
                    {
                      "Brand": "Cub Cadet",
                      "lineCode": "CUB"
                    },
                    {
                      "Brand": "Cuisinart",
                      "lineCode": "CUI"
                    },
                    {
                      "Brand": "Curlin",
                      "lineCode": "CUR"
                    },
                    {
                      "Brand": "Cybex",
                      "lineCode": "CYB"
                    },
                    {
                      "Brand": "D&r Associates Inc.",
                      "lineCode": "DRA"
                    },
                    {
                      "Brand": "Dacor",
                      "lineCode": "DAC"
                    },
                    {
                      "Brand": "Daewoo",
                      "lineCode": "DAE"
                    },
                    {
                      "Brand": "Daikin",
                      "lineCode": "DAI"
                    },
                    {
                      "Brand": "Danby",
                      "lineCode": "DBY"
                    },
                    {
                      "Brand": "Dantona Industries",
                      "lineCode": "DAN"
                    },
                    {
                      "Brand": "Deflect-0",
                      "lineCode": "DEF"
                    },
                    {
                      "Brand": "Delfield",
                      "lineCode": "DFD"
                    },
                    {
                      "Brand": "Dell",
                      "lineCode": "DEL"
                    },
                    {
                      "Brand": "Dell Refurb",
                      "lineCode": "DER"
                    },
                    {
                      "Brand": "Delonghi",
                      "lineCode": "DEI"
                    },
                    {
                      "Brand": "Delta",
                      "lineCode": "DTL"
                    },
                    {
                      "Brand": "Delta Faucet",
                      "lineCode": "DTF"
                    },
                    {
                      "Brand": "Denon",
                      "lineCode": "DEN"
                    },
                    {
                      "Brand": "Devilbiss",
                      "lineCode": "DEV"
                    },
                    {
                      "Brand": "Dewalt",
                      "lineCode": "DEW"
                    },
                    {
                      "Brand": "Dex Refurbished",
                      "lineCode": "DXR"
                    },
                    {
                      "Brand": "Digitenna",
                      "lineCode": "DIG"
                    },
                    {
                      "Brand": "Dirt Devil",
                      "lineCode": "DIR"
                    },
                    {
                      "Brand": "Diversitech Inc",
                      "lineCode": "DIV"
                    },
                    {
                      "Brand": "Dngo International",
                      "lineCode": "DNG"
                    },
                    {
                      "Brand": "Dormont",
                      "lineCode": "DRM"
                    },
                    {
                      "Brand": "Dormont Manufacturin",
                      "lineCode": "DOR"
                    },
                    {
                      "Brand": "Dotco",
                      "lineCode": "DOT"
                    },
                    {
                      "Brand": "DR Power Equipment",
                      "lineCode": "DRE"
                    },
                    {
                      "Brand": "Dremel",
                      "lineCode": "DML"
                    },
                    {
                      "Brand": "DSS",
                      "lineCode": "DSS"
                    },
                    {
                      "Brand": "Duke",
                      "lineCode": "DUK"
                    },
                    {
                      "Brand": "Dundas Jafine Inc",
                      "lineCode": "DUN"
                    },
                    {
                      "Brand": "Duracell U.S.A.",
                      "lineCode": "DUR"
                    },
                    {
                      "Brand": "Dustless",
                      "lineCode": "DUS"
                    },
                    {
                      "Brand": "Dynabrade",
                      "lineCode": "DYB"
                    },
                    {
                      "Brand": "Dyson",
                      "lineCode": "DYS"
                    },
                    {
                      "Brand": "E-machine",
                      "lineCode": "EMA"
                    },
                    {
                      "Brand": "Echo",
                      "lineCode": "ECH"
                    },
                    {
                      "Brand": "Eclipse",
                      "lineCode": "ECL"
                    },
                    {
                      "Brand": "Edic",
                      "lineCode": "EDI"
                    },
                    {
                      "Brand": "Edlund",
                      "lineCode": "EDL"
                    },
                    {
                      "Brand": "Ego",
                      "lineCode": "EGO"
                    },
                    {
                      "Brand": "Electrolux",
                      "lineCode": "FRI"
                    },
                    {
                      "Brand": "Electrolux Pro",
                      "lineCode": "ELX"
                    },
                    {
                      "Brand": "Electronic Resources",
                      "lineCode": "ELR"
                    },
                    {
                      "Brand": "Electrosound",
                      "lineCode": "ELS"
                    },
                    {
                      "Brand": "Elica",
                      "lineCode": "ELI"
                    },
                    {
                      "Brand": "Emachines Refurb",
                      "lineCode": "EMR"
                    },
                    {
                      "Brand": "Emerson",
                      "lineCode": "EME"
                    },
                    {
                      "Brand": "Empire Video",
                      "lineCode": "EMP"
                    },
                    {
                      "Brand": "Encompass",
                      "lineCode": "VBI"
                    },
                    {
                      "Brand": "Encompass Parts",
                      "lineCode": "EPD"
                    },
                    {
                      "Brand": "Encompass Service",
                      "lineCode": "ESS"
                    },
                    {
                      "Brand": "Envision",
                      "lineCode": "ENV"
                    },
                    {
                      "Brand": "Envision Refurbished",
                      "lineCode": "ENR"
                    },
                    {
                      "Brand": "Epson",
                      "lineCode": "EPS"
                    },
                    {
                      "Brand": "Epson Refurb",
                      "lineCode": "EPR"
                    },
                    {
                      "Brand": "Escort",
                      "lineCode": "ESC"
                    },
                    {
                      "Brand": "Espresso Accessories",
                      "lineCode": "ESP"
                    },
                    {
                      "Brand": "Eureka",
                      "lineCode": "ERK"
                    },
                    {
                      "Brand": "Eveready Battery Co.",
                      "lineCode": "EVE"
                    },
                    {
                      "Brand": "Everpure",
                      "lineCode": "EVP"
                    },
                    {
                      "Brand": "Exmark",
                      "lineCode": "EXM"
                    },
                    {
                      "Brand": "Ez-flo",
                      "lineCode": "EZF"
                    },
                    {
                      "Brand": "Famous Entreprises",
                      "lineCode": "FAM"
                    },
                    {
                      "Brand": "Fantom",
                      "lineCode": "FAN"
                    },
                    {
                      "Brand": "Fasco",
                      "lineCode": "FAS"
                    },
                    {
                      "Brand": "FBD",
                      "lineCode": "FBD"
                    },
                    {
                      "Brand": "Federal Industries",
                      "lineCode": "FED"
                    },
                    {
                      "Brand": "Fein",
                      "lineCode": "FEI"
                    },
                    {
                      "Brand": "Fiesta",
                      "lineCode": "FIE"
                    },
                    {
                      "Brand": "Filters",
                      "lineCode": "ECO"
                    },
                    {
                      "Brand": "Fisher / Paykel",
                      "lineCode": "FAP"
                    },
                    {
                      "Brand": "Flex",
                      "lineCode": "FLE"
                    },
                    {
                      "Brand": "Flotec",
                      "lineCode": "FLO"
                    },
                    {
                      "Brand": "Fluke",
                      "lineCode": "FLU"
                    },
                    {
                      "Brand": "Follett",
                      "lineCode": "FOL"
                    },
                    {
                      "Brand": "Freemotion",
                      "lineCode": "FMN"
                    },
                    {
                      "Brand": "Freudenberg Filtrati",
                      "lineCode": "FRE"
                    },
                    {
                      "Brand": "Fri-Jado",
                      "lineCode": "FJD"
                    },
                    {
                      "Brand": "Friedrich",
                      "lineCode": "FCH"
                    },
                    {
                      "Brand": "Frigidaire",
                      "lineCode": "FRI"
                    },
                    {
                      "Brand": "Front Projector Lamp",
                      "lineCode": "FPL"
                    },
                    {
                      "Brand": "Frs Radio",
                      "lineCode": "TKK"
                    },
                    {
                      "Brand": "Frymaster",
                      "lineCode": "FRY"
                    },
                    {
                      "Brand": "Fuji-xerox Artermark",
                      "lineCode": "FXA"
                    },
                    {
                      "Brand": "Funai",
                      "lineCode": "FUN"
                    },
                    {
                      "Brand": "Gaggenau",
                      "lineCode": "BCH"
                    },
                    {
                      "Brand": "Gaming Parts",
                      "lineCode": "GAM"
                    },
                    {
                      "Brand": "Gardner",
                      "lineCode": "GDN"
                    },
                    {
                      "Brand": "Garland",
                      "lineCode": "GLN"
                    },
                    {
                      "Brand": "Garmin",
                      "lineCode": "GAR"
                    },
                    {
                      "Brand": "Gateway",
                      "lineCode": "GAT"
                    },
                    {
                      "Brand": "Gateway Refurb",
                      "lineCode": "GTW"
                    },
                    {
                      "Brand": "Gaylord",
                      "lineCode": "GAY"
                    },
                    {
                      "Brand": "Gc-thorsen",
                      "lineCode": "GCE"
                    },
                    {
                      "Brand": "GE",
                      "lineCode": "HOT"
                    },
                    {
                      "Brand": "GE Small Appliance",
                      "lineCode": "GSA"
                    },
                    {
                      "Brand": "Generac Delco",
                      "lineCode": "GEN"
                    },
                    {
                      "Brand": "Generic",
                      "lineCode": "LPU"
                    },
                    {
                      "Brand": "Generic Computer",
                      "lineCode": "KAS"
                    },
                    {
                      "Brand": "Genie",
                      "lineCode": "GNE"
                    },
                    {
                      "Brand": "Get It Clean",
                      "lineCode": "GIC"
                    },
                    {
                      "Brand": "Gibson",
                      "lineCode": "FRI"
                    },
                    {
                      "Brand": "Giles",
                      "lineCode": "GLS"
                    },
                    {
                      "Brand": "Gillette",
                      "lineCode": "GIL"
                    },
                    {
                      "Brand": "Gladiator",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "Globe",
                      "lineCode": "GLO"
                    },
                    {
                      "Brand": "Go Plus Lighting",
                      "lineCode": "GOP"
                    },
                    {
                      "Brand": "Go Video",
                      "lineCode": "GOV"
                    },
                    {
                      "Brand": "Golds Gym",
                      "lineCode": "GDG"
                    },
                    {
                      "Brand": "Goliath Smart Phones",
                      "lineCode": "GOL"
                    },
                    {
                      "Brand": "GoLite",
                      "lineCode": "GLT"
                    },
                    {
                      "Brand": "Goodman",
                      "lineCode": "GOO"
                    },
                    {
                      "Brand": "Google",
                      "lineCode": "GGL"
                    },
                    {
                      "Brand": "Gps Batteries",
                      "lineCode": "GPS"
                    },
                    {
                      "Brand": "Gpx Remotes",
                      "lineCode": "GPX"
                    },
                    {
                      "Brand": "Graco",
                      "lineCode": "GRA"
                    },
                    {
                      "Brand": "GREEN CHOICE",
                      "lineCode": "SOH"
                    },
                    {
                      "Brand": "Green Choice",
                      "lineCode": "SJP"
                    },
                    {
                      "Brand": "Green Choice",
                      "lineCode": "REB"
                    },
                    {
                      "Brand": "Green Choice",
                      "lineCode": "CGI"
                    },
                    {
                      "Brand": "Green Choice Parts",
                      "lineCode": "PPP"
                    },
                    {
                      "Brand": "Green Choice Parts",
                      "lineCode": "GCP"
                    },
                    {
                      "Brand": "Green Choice Parts",
                      "lineCode": "CKP"
                    },
                    {
                      "Brand": "Greenworks",
                      "lineCode": "GRN"
                    },
                    {
                      "Brand": "Grindmaster",
                      "lineCode": "GRI"
                    },
                    {
                      "Brand": "Grindmaster Cecilware",
                      "lineCode": "GMC"
                    },
                    {
                      "Brand": "Grip-rite",
                      "lineCode": "GPR"
                    },
                    {
                      "Brand": "Groen",
                      "lineCode": "GRO"
                    },
                    {
                      "Brand": "Haier",
                      "lineCode": "HAI"
                    },
                    {
                      "Brand": "Haier Literature",
                      "lineCode": "HSL"
                    },
                    {
                      "Brand": "Hamilton Beach",
                      "lineCode": "HAM"
                    },
                    {
                      "Brand": "Hannspree Refurb",
                      "lineCode": "HNS"
                    },
                    {
                      "Brand": "Harmon Kardon",
                      "lineCode": "HAR"
                    },
                    {
                      "Brand": "Hatco",
                      "lineCode": "HAT"
                    },
                    {
                      "Brand": "Hayward",
                      "lineCode": "HAY"
                    },
                    {
                      "Brand": "Health Rider",
                      "lineCode": "HRD"
                    },
                    {
                      "Brand": "Heat Hog",
                      "lineCode": "HHG"
                    },
                    {
                      "Brand": "Heat Stream",
                      "lineCode": "HSR"
                    },
                    {
                      "Brand": "Heat Tools",
                      "lineCode": "DRG"
                    },
                    {
                      "Brand": "Heat Wagon",
                      "lineCode": "HWN"
                    },
                    {
                      "Brand": "Heatcraft",
                      "lineCode": "HCT"
                    },
                    {
                      "Brand": "Heatstar",
                      "lineCode": "HEA"
                    },
                    {
                      "Brand": "Henny Penny",
                      "lineCode": "HNP"
                    },
                    {
                      "Brand": "Hewlett Packard Refu",
                      "lineCode": "HPR"
                    },
                    {
                      "Brand": "High Capacity",
                      "lineCode": "BAT"
                    },
                    {
                      "Brand": "Hisense",
                      "lineCode": "HIS"
                    },
                    {
                      "Brand": "Hitachi",
                      "lineCode": "HIT"
                    },
                    {
                      "Brand": "Hiteker",
                      "lineCode": "HTK"
                    },
                    {
                      "Brand": "Hkc Digital",
                      "lineCode": "HKC"
                    },
                    {
                      "Brand": "Hobart",
                      "lineCode": "HOB"
                    },
                    {
                      "Brand": "Holman",
                      "lineCode": "HOL"
                    },
                    {
                      "Brand": "Homelite",
                      "lineCode": "HOM"
                    },
                    {
                      "Brand": "Honda",
                      "lineCode": "HON"
                    },
                    {
                      "Brand": "Honda Marine",
                      "lineCode": "HAD"
                    },
                    {
                      "Brand": "Honeywell",
                      "lineCode": "HWL"
                    },
                    {
                      "Brand": "Hoover",
                      "lineCode": "HOO"
                    },
                    {
                      "Brand": "Horizon Fitness",
                      "lineCode": "HZN"
                    },
                    {
                      "Brand": "Horton Valves",
                      "lineCode": "HOR"
                    },
                    {
                      "Brand": "Hoshizaki",
                      "lineCode": "HZK"
                    },
                    {
                      "Brand": "Hospira",
                      "lineCode": "HOS"
                    },
                    {
                      "Brand": "Hotpoint",
                      "lineCode": "HOT"
                    },
                    {
                      "Brand": "HP",
                      "lineCode": "HEW"
                    },
                    {
                      "Brand": "HP/Canon",
                      "lineCode": "HPC"
                    },
                    {
                      "Brand": "Hughes",
                      "lineCode": "HUG"
                    },
                    {
                      "Brand": "Hunter",
                      "lineCode": "HUN"
                    },
                    {
                      "Brand": "Huntington",
                      "lineCode": "HTG"
                    },
                    {
                      "Brand": "Husky",
                      "lineCode": "HKY"
                    },
                    {
                      "Brand": "Husqvarna",
                      "lineCode": "HUS"
                    },
                    {
                      "Brand": "Hussmann",
                      "lineCode": "HSN"
                    },
                    {
                      "Brand": "HVAC",
                      "lineCode": "SPC"
                    },
                    {
                      "Brand": "Hvac Parts",
                      "lineCode": "GEM"
                    },
                    {
                      "Brand": "Hydra Kool",
                      "lineCode": "HDK"
                    },
                    {
                      "Brand": "Hydrotech",
                      "lineCode": "HYD"
                    },
                    {
                      "Brand": "Hyundai Corporation",
                      "lineCode": "HCU"
                    },
                    {
                      "Brand": "I-symphony",
                      "lineCode": "ISY"
                    },
                    {
                      "Brand": "Ibm Refurb",
                      "lineCode": "IBX"
                    },
                    {
                      "Brand": "Ice-o-matic",
                      "lineCode": "ICE"
                    },
                    {
                      "Brand": "IKEA",
                      "lineCode": "IKE"
                    },
                    {
                      "Brand": "Ilo",
                      "lineCode": "ILO"
                    },
                    {
                      "Brand": "Imperial",
                      "lineCode": "IPL"
                    },
                    {
                      "Brand": "Import",
                      "lineCode": "IMP"
                    },
                    {
                      "Brand": "Impression",
                      "lineCode": "IPR"
                    },
                    {
                      "Brand": "Indesit",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "Industrial Air",
                      "lineCode": "IND"
                    },
                    {
                      "Brand": "Infocus",
                      "lineCode": "INF"
                    },
                    {
                      "Brand": "Infratech",
                      "lineCode": "INH"
                    },
                    {
                      "Brand": "Ingersoll Rand",
                      "lineCode": "ING"
                    },
                    {
                      "Brand": "Inglis",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "Innolux",
                      "lineCode": "ILX"
                    },
                    {
                      "Brand": "Inovate",
                      "lineCode": "INO"
                    },
                    {
                      "Brand": "Insignia",
                      "lineCode": "ISG"
                    },
                    {
                      "Brand": "Intel",
                      "lineCode": "INT"
                    },
                    {
                      "Brand": "Intermetro",
                      "lineCode": "IMO"
                    },
                    {
                      "Brand": "International Comfort Products",
                      "lineCode": "ICP"
                    },
                    {
                      "Brand": "International Environmental Corporation",
                      "lineCode": "IEC"
                    },
                    {
                      "Brand": "J.w. Harris",
                      "lineCode": "JWH"
                    },
                    {
                      "Brand": "Jackson",
                      "lineCode": "JCN"
                    },
                    {
                      "Brand": "Jacques Ebert",
                      "lineCode": "JAC"
                    },
                    {
                      "Brand": "Jacuzzi",
                      "lineCode": "JZI"
                    },
                    {
                      "Brand": "Jade",
                      "lineCode": "JDE"
                    },
                    {
                      "Brand": "Jancy",
                      "lineCode": "JAN"
                    },
                    {
                      "Brand": "Japanese Semi's",
                      "lineCode": "JAP"
                    },
                    {
                      "Brand": "Jason Illinois Inc",
                      "lineCode": "JAS"
                    },
                    {
                      "Brand": "JBL",
                      "lineCode": "JBL"
                    },
                    {
                      "Brand": "JBT",
                      "lineCode": "JBT"
                    },
                    {
                      "Brand": "Jenn-air",
                      "lineCode": "JEN"
                    },
                    {
                      "Brand": "Jennair",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "Jenny",
                      "lineCode": "JNY"
                    },
                    {
                      "Brand": "Jet",
                      "lineCode": "JET"
                    },
                    {
                      "Brand": "Jet Tech",
                      "lineCode": "JTT"
                    },
                    {
                      "Brand": "John Guest",
                      "lineCode": "JOG"
                    },
                    {
                      "Brand": "Jonsered",
                      "lineCode": "JON"
                    },
                    {
                      "Brand": "JVC",
                      "lineCode": "JVC"
                    },
                    {
                      "Brand": "Jvc/amtran",
                      "lineCode": "JVA"
                    },
                    {
                      "Brand": "Kairak",
                      "lineCode": "KAI"
                    },
                    {
                      "Brand": "Karcher",
                      "lineCode": "KAR"
                    },
                    {
                      "Brand": "Kason",
                      "lineCode": "KSN"
                    },
                    {
                      "Brand": "Kawasaki",
                      "lineCode": "KAW"
                    },
                    {
                      "Brand": "Kds Monitors",
                      "lineCode": "KDS"
                    },
                    {
                      "Brand": "Kdsusa Inc Refurb",
                      "lineCode": "KDX"
                    },
                    {
                      "Brand": "Kef Audio",
                      "lineCode": "KEF"
                    },
                    {
                      "Brand": "Kelon",
                      "lineCode": "KEL"
                    },
                    {
                      "Brand": "Kelvinator",
                      "lineCode": "FRI"
                    },
                    {
                      "Brand": "Kendall",
                      "lineCode": "KNL"
                    },
                    {
                      "Brand": "Kenmore",
                      "lineCode": "KMR"
                    },
                    {
                      "Brand": "Kenwood",
                      "lineCode": "KEW"
                    },
                    {
                      "Brand": "Kenwood",
                      "lineCode": "KEN"
                    },
                    {
                      "Brand": "Kirby",
                      "lineCode": "KIR"
                    },
                    {
                      "Brand": "KitchenAid",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "Knaack",
                      "lineCode": "KNA"
                    },
                    {
                      "Brand": "Kobalt",
                      "lineCode": "KOB"
                    },
                    {
                      "Brand": "Kodak Refurb",
                      "lineCode": "KOR"
                    },
                    {
                      "Brand": "Kohler",
                      "lineCode": "KOH"
                    },
                    {
                      "Brand": "Kolpak",
                      "lineCode": "KOL"
                    },
                    {
                      "Brand": "Konka",
                      "lineCode": "KON"
                    },
                    {
                      "Brand": "Kool It",
                      "lineCode": "KOO"
                    },
                    {
                      "Brand": "KOVA",
                      "lineCode": "KAT"
                    },
                    {
                      "Brand": "Krowne",
                      "lineCode": "KRO"
                    },
                    {
                      "Brand": "Krups",
                      "lineCode": "KRU"
                    },
                    {
                      "Brand": "Kyocera Mita",
                      "lineCode": "KYO"
                    },
                    {
                      "Brand": "L&lsquo;OR Barista",
                      "lineCode": "LOR"
                    },
                    {
                      "Brand": "Lamp Only",
                      "lineCode": "LMP"
                    },
                    {
                      "Brand": "Lancer",
                      "lineCode": "LCR"
                    },
                    {
                      "Brand": "Lang",
                      "lineCode": "LAN"
                    },
                    {
                      "Brand": "Lasko",
                      "lineCode": "LAS"
                    },
                    {
                      "Brand": "Lawn Boy",
                      "lineCode": "LAW"
                    },
                    {
                      "Brand": "Lelit",
                      "lineCode": "LEL"
                    },
                    {
                      "Brand": "Lennox",
                      "lineCode": "LNX"
                    },
                    {
                      "Brand": "Lenovo",
                      "lineCode": "LEN"
                    },
                    {
                      "Brand": "Lenovo Recertified",
                      "lineCode": "LEH"
                    },
                    {
                      "Brand": "Lexmark",
                      "lineCode": "LEX"
                    },
                    {
                      "Brand": "Lexmark Refurb",
                      "lineCode": "LXR"
                    },
                    {
                      "Brand": "LG",
                      "lineCode": "ZEN"
                    },
                    {
                      "Brand": "LG",
                      "lineCode": "LGE"
                    },
                    {
                      "Brand": "Liebherr",
                      "lineCode": "LIE"
                    },
                    {
                      "Brand": "Liftmaster",
                      "lineCode": "LIF"
                    },
                    {
                      "Brand": "Lincoln",
                      "lineCode": "LCN"
                    },
                    {
                      "Brand": "Linksys",
                      "lineCode": "LIN"
                    },
                    {
                      "Brand": "Liquid Video Refurb",
                      "lineCode": "LVR"
                    },
                    {
                      "Brand": "Little Wonder",
                      "lineCode": "LTW"
                    },
                    {
                      "Brand": "Littlefuse",
                      "lineCode": "LIT"
                    },
                    {
                      "Brand": "Lmb Heeger",
                      "lineCode": "LMB"
                    },
                    {
                      "Brand": "Lobb",
                      "lineCode": "LOB"
                    },
                    {
                      "Brand": "Lokring Appliance",
                      "lineCode": "LOK"
                    },
                    {
                      "Brand": "Lowell",
                      "lineCode": "LOW"
                    },
                    {
                      "Brand": "LPS",
                      "lineCode": "LPS"
                    },
                    {
                      "Brand": "Luxor",
                      "lineCode": "LUX"
                    },
                    {
                      "Brand": "Lynx",
                      "lineCode": "LYN"
                    },
                    {
                      "Brand": "Ma-line",
                      "lineCode": "MAE"
                    },
                    {
                      "Brand": "Magic Chef",
                      "lineCode": "MAC"
                    },
                    {
                      "Brand": "Magnavox",
                      "lineCode": "MAG"
                    },
                    {
                      "Brand": "Majestic",
                      "lineCode": "MAJ"
                    },
                    {
                      "Brand": "Makita",
                      "lineCode": "MAK"
                    },
                    {
                      "Brand": "Mallory",
                      "lineCode": "MAL"
                    },
                    {
                      "Brand": "Manitowoc Ice",
                      "lineCode": "MIC"
                    },
                    {
                      "Brand": "Mantis",
                      "lineCode": "MAN"
                    },
                    {
                      "Brand": "Marantz",
                      "lineCode": "MAR"
                    },
                    {
                      "Brand": "Margaritaville",
                      "lineCode": "MGT"
                    },
                    {
                      "Brand": "Market Forge",
                      "lineCode": "MKF"
                    },
                    {
                      "Brand": "Marquis",
                      "lineCode": "MRQ"
                    },
                    {
                      "Brand": "Marshall Air",
                      "lineCode": "MSA"
                    },
                    {
                      "Brand": "Mass Integrated",
                      "lineCode": "MIS"
                    },
                    {
                      "Brand": "Master",
                      "lineCode": "MAS"
                    },
                    {
                      "Brand": "Master-Bilt",
                      "lineCode": "MLT"
                    },
                    {
                      "Brand": "Matrix Fitness",
                      "lineCode": "MAT"
                    },
                    {
                      "Brand": "Matsushita",
                      "lineCode": "MSL"
                    },
                    {
                      "Brand": "Matv/catv Acc",
                      "lineCode": "PCO"
                    },
                    {
                      "Brand": "Max",
                      "lineCode": "MXX"
                    },
                    {
                      "Brand": "Max Professional",
                      "lineCode": "MXP"
                    },
                    {
                      "Brand": "Maxell",
                      "lineCode": "MAX"
                    },
                    {
                      "Brand": "Maytag",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "Maytag",
                      "lineCode": "MAY"
                    },
                    {
                      "Brand": "MCM",
                      "lineCode": "MCM"
                    },
                    {
                      "Brand": "Medex",
                      "lineCode": "MDM"
                    },
                    {
                      "Brand": "Memory Products",
                      "lineCode": "PAR"
                    },
                    {
                      "Brand": "Merco",
                      "lineCode": "MEO"
                    },
                    {
                      "Brand": "Merrychef",
                      "lineCode": "MER"
                    },
                    {
                      "Brand": "Metabo HPT",
                      "lineCode": "MET"
                    },
                    {
                      "Brand": "Metabo Hpt",
                      "lineCode": "HPT"
                    },
                    {
                      "Brand": "Mi-t-m",
                      "lineCode": "MIM"
                    },
                    {
                      "Brand": "Miami Parts",
                      "lineCode": "MIA"
                    },
                    {
                      "Brand": "Microsoft",
                      "lineCode": "MCS"
                    },
                    {
                      "Brand": "Middleby",
                      "lineCode": "MBY"
                    },
                    {
                      "Brand": "Midea",
                      "lineCode": "MID"
                    },
                    {
                      "Brand": "Midland Metal",
                      "lineCode": "MLM"
                    },
                    {
                      "Brand": "Miele",
                      "lineCode": "MIE"
                    },
                    {
                      "Brand": "Milnor",
                      "lineCode": "MNR"
                    },
                    {
                      "Brand": "Milwaukee",
                      "lineCode": "MIL"
                    },
                    {
                      "Brand": "Minn Kota",
                      "lineCode": "MKA"
                    },
                    {
                      "Brand": "Miracle Remote",
                      "lineCode": "MIR"
                    },
                    {
                      "Brand": "Mirro",
                      "lineCode": "MRO"
                    },
                    {
                      "Brand": "Mitsubishi",
                      "lineCode": "MIT"
                    },
                    {
                      "Brand": "Mitsubishi Refurb",
                      "lineCode": "MTR"
                    },
                    {
                      "Brand": "Mk Diamond",
                      "lineCode": "MKD"
                    },
                    {
                      "Brand": "Moen",
                      "lineCode": "MOE"
                    },
                    {
                      "Brand": "Moffat",
                      "lineCode": "MOF"
                    },
                    {
                      "Brand": "Monessen",
                      "lineCode": "MNN"
                    },
                    {
                      "Brand": "Monogram",
                      "lineCode": "HOT"
                    },
                    {
                      "Brand": "Montague",
                      "lineCode": "MNU"
                    },
                    {
                      "Brand": "Motorola Refurb",
                      "lineCode": "MRX"
                    },
                    {
                      "Brand": "Motors & Armatures",
                      "lineCode": "MAA"
                    },
                    {
                      "Brand": "Moyer Diebel",
                      "lineCode": "CMD"
                    },
                    {
                      "Brand": "Mr Coffee",
                      "lineCode": "MRF"
                    },
                    {
                      "Brand": "Mr Heater",
                      "lineCode": "MRH"
                    },
                    {
                      "Brand": "MRCOOL",
                      "lineCode": "MRC"
                    },
                    {
                      "Brand": "MSI",
                      "lineCode": "MSI"
                    },
                    {
                      "Brand": "Mst",
                      "lineCode": "MST"
                    },
                    {
                      "Brand": "Mtx Speakers",
                      "lineCode": "MTX"
                    },
                    {
                      "Brand": "Muratec",
                      "lineCode": "MUR"
                    },
                    {
                      "Brand": "Murray",
                      "lineCode": "BSM"
                    },
                    {
                      "Brand": "Nady",
                      "lineCode": "NAD"
                    },
                    {
                      "Brand": "Napoleon",
                      "lineCode": "NPL"
                    },
                    {
                      "Brand": "NEC",
                      "lineCode": "NEC"
                    },
                    {
                      "Brand": "Nespresso",
                      "lineCode": "NES"
                    },
                    {
                      "Brand": "New Wave Sales",
                      "lineCode": "NWS"
                    },
                    {
                      "Brand": "Nexgrill",
                      "lineCode": "NGL"
                    },
                    {
                      "Brand": "Nextbook Usa",
                      "lineCode": "NEX"
                    },
                    {
                      "Brand": "Nexxtech",
                      "lineCode": "NXX"
                    },
                    {
                      "Brand": "Nieco",
                      "lineCode": "NIE"
                    },
                    {
                      "Brand": "Nikon",
                      "lineCode": "NKN"
                    },
                    {
                      "Brand": "Nordictrack",
                      "lineCode": "NDT"
                    },
                    {
                      "Brand": "Norelco",
                      "lineCode": "NOR"
                    },
                    {
                      "Brand": "Norelco",
                      "lineCode": "NCR"
                    },
                    {
                      "Brand": "NORLAKE",
                      "lineCode": "NRK"
                    },
                    {
                      "Brand": "Nortek",
                      "lineCode": "NTK"
                    },
                    {
                      "Brand": "NOT FOR RESALE",
                      "lineCode": "HEM"
                    },
                    {
                      "Brand": "Novatek",
                      "lineCode": "NOV"
                    },
                    {
                      "Brand": "Nte Electronics",
                      "lineCode": "NTE"
                    },
                    {
                      "Brand": "Nu-Vu",
                      "lineCode": "NUV"
                    },
                    {
                      "Brand": "Nukote",
                      "lineCode": "NUK"
                    },
                    {
                      "Brand": "Numerex",
                      "lineCode": "NUM"
                    },
                    {
                      "Brand": "Nuova Simonelli",
                      "lineCode": "NUO"
                    },
                    {
                      "Brand": "Nutone",
                      "lineCode": "NUT"
                    },
                    {
                      "Brand": "Oem Compatible",
                      "lineCode": "HPA"
                    },
                    {
                      "Brand": "Office Supplies",
                      "lineCode": "OFC"
                    },
                    {
                      "Brand": "Okidata Refurb",
                      "lineCode": "OKR"
                    },
                    {
                      "Brand": "Olevia",
                      "lineCode": "OLE"
                    },
                    {
                      "Brand": "Olympus",
                      "lineCode": "OLY"
                    },
                    {
                      "Brand": "Onkyo",
                      "lineCode": "ONK"
                    },
                    {
                      "Brand": "Opal Icemakers",
                      "lineCode": "OPL"
                    },
                    {
                      "Brand": "Optoma",
                      "lineCode": "OPT"
                    },
                    {
                      "Brand": "Oral-B",
                      "lineCode": "ORB"
                    },
                    {
                      "Brand": "Orbit",
                      "lineCode": "OBT"
                    },
                    {
                      "Brand": "Oreck",
                      "lineCode": "ORE"
                    },
                    {
                      "Brand": "Oregon",
                      "lineCode": "ORG"
                    },
                    {
                      "Brand": "Orion",
                      "lineCode": "ORI"
                    },
                    {
                      "Brand": "OSRAM",
                      "lineCode": "OSR"
                    },
                    {
                      "Brand": "Osram Neolux",
                      "lineCode": "NEO"
                    },
                    {
                      "Brand": "Oster",
                      "lineCode": "OST"
                    },
                    {
                      "Brand": "Packaging",
                      "lineCode": "PKG"
                    },
                    {
                      "Brand": "Packard Inc",
                      "lineCode": "PAK"
                    },
                    {
                      "Brand": "Panasonic",
                      "lineCode": "MSC"
                    },
                    {
                      "Brand": "Panasonic Refurb",
                      "lineCode": "MSR"
                    },
                    {
                      "Brand": "Panduit",
                      "lineCode": "PDT"
                    },
                    {
                      "Brand": "Patio Comfort",
                      "lineCode": "PAT"
                    },
                    {
                      "Brand": "Peerless Premier",
                      "lineCode": "PPA"
                    },
                    {
                      "Brand": "Peg Perego",
                      "lineCode": "PEG"
                    },
                    {
                      "Brand": "Penn",
                      "lineCode": "PEN"
                    },
                    {
                      "Brand": "Pentair",
                      "lineCode": "PTR"
                    },
                    {
                      "Brand": "Perlick",
                      "lineCode": "PLC"
                    },
                    {
                      "Brand": "Petra",
                      "lineCode": "PTA"
                    },
                    {
                      "Brand": "Pflueger",
                      "lineCode": "PFL"
                    },
                    {
                      "Brand": "Pgs Grill",
                      "lineCode": "PGS"
                    },
                    {
                      "Brand": "Philco",
                      "lineCode": "FRI"
                    },
                    {
                      "Brand": "Philips",
                      "lineCode": "PNF"
                    },
                    {
                      "Brand": "Philips",
                      "lineCode": "PCL"
                    },
                    {
                      "Brand": "Philips",
                      "lineCode": "NAP"
                    },
                    {
                      "Brand": "PHILIPS GARMENT CARE",
                      "lineCode": "PGC"
                    },
                    {
                      "Brand": "Philips Health Solut",
                      "lineCode": "PHS"
                    },
                    {
                      "Brand": "Philips Healthy Cook",
                      "lineCode": "PHC"
                    },
                    {
                      "Brand": "Philips Hospitality",
                      "lineCode": "PBS"
                    },
                    {
                      "Brand": "Philips Lighting",
                      "lineCode": "PHL"
                    },
                    {
                      "Brand": "Philips Pet Care",
                      "lineCode": "PPC"
                    },
                    {
                      "Brand": "Philips Product",
                      "lineCode": "PAF"
                    },
                    {
                      "Brand": "Philips Purifiers",
                      "lineCode": "PPH"
                    },
                    {
                      "Brand": "Philmore",
                      "lineCode": "PHI"
                    },
                    {
                      "Brand": "Phoenix Lamp",
                      "lineCode": "PHX"
                    },
                    {
                      "Brand": "Pinnacle Sales",
                      "lineCode": "PIN"
                    },
                    {
                      "Brand": "Pioneer",
                      "lineCode": "PIO"
                    },
                    {
                      "Brand": "Pitco",
                      "lineCode": "PIT"
                    },
                    {
                      "Brand": "Plasmair",
                      "lineCode": "PLA"
                    },
                    {
                      "Brand": "Polk",
                      "lineCode": "PLK"
                    },
                    {
                      "Brand": "Polti Refurbished",
                      "lineCode": "POR"
                    },
                    {
                      "Brand": "Porter Cable",
                      "lineCode": "PTC"
                    },
                    {
                      "Brand": "Poulan",
                      "lineCode": "POU"
                    },
                    {
                      "Brand": "Power Cords",
                      "lineCode": "WEB"
                    },
                    {
                      "Brand": "Power Soak Systems",
                      "lineCode": "PSS"
                    },
                    {
                      "Brand": "Power Wheels",
                      "lineCode": "PWS"
                    },
                    {
                      "Brand": "Powermate",
                      "lineCode": "PWM"
                    },
                    {
                      "Brand": "Powermatic",
                      "lineCode": "PMT"
                    },
                    {
                      "Brand": "Powersonic",
                      "lineCode": "POW"
                    },
                    {
                      "Brand": "Premier Range Co.",
                      "lineCode": "PER"
                    },
                    {
                      "Brand": "Presto",
                      "lineCode": "PRE"
                    },
                    {
                      "Brand": "Prima Worldwide",
                      "lineCode": "PWW"
                    },
                    {
                      "Brand": "Primo",
                      "lineCode": "PMO"
                    },
                    {
                      "Brand": "Prince Castle",
                      "lineCode": "PRI"
                    },
                    {
                      "Brand": "Pro Temp",
                      "lineCode": "PRP"
                    },
                    {
                      "Brand": "Proctor Silex",
                      "lineCode": "PSX"
                    },
                    {
                      "Brand": "Proform",
                      "lineCode": "PRF"
                    },
                    {
                      "Brand": "Proscan",
                      "lineCode": "PCN"
                    },
                    {
                      "Brand": "Protective Coating",
                      "lineCode": "PRT"
                    },
                    {
                      "Brand": "Proview",
                      "lineCode": "PRV"
                    },
                    {
                      "Brand": "Pts Modules",
                      "lineCode": "PTS"
                    },
                    {
                      "Brand": "QST",
                      "lineCode": "QST"
                    },
                    {
                      "Brand": "Quam",
                      "lineCode": "QUA"
                    },
                    {
                      "Brand": "Quantum View",
                      "lineCode": "QTM"
                    },
                    {
                      "Brand": "Rain Bird",
                      "lineCode": "RAI"
                    },
                    {
                      "Brand": "Randell",
                      "lineCode": "RAN"
                    },
                    {
                      "Brand": "Rational",
                      "lineCode": "RAT"
                    },
                    {
                      "Brand": "Raypak",
                      "lineCode": "RAY"
                    },
                    {
                      "Brand": "Razor",
                      "lineCode": "RAZ"
                    },
                    {
                      "Brand": "RCA",
                      "lineCode": "RCA"
                    },
                    {
                      "Brand": "Rechargeable Battery",
                      "lineCode": "USP"
                    },
                    {
                      "Brand": "Rectorseal",
                      "lineCode": "REC"
                    },
                    {
                      "Brand": "Redmax",
                      "lineCode": "RED"
                    },
                    {
                      "Brand": "Remington",
                      "lineCode": "REM"
                    },
                    {
                      "Brand": "Replacement Transist",
                      "lineCode": "REP"
                    },
                    {
                      "Brand": "Reznor",
                      "lineCode": "REZ"
                    },
                    {
                      "Brand": "Rheem",
                      "lineCode": "RHE"
                    },
                    {
                      "Brand": "Ricoh Refurbished",
                      "lineCode": "RCX"
                    },
                    {
                      "Brand": "Ridgid",
                      "lineCode": "RID"
                    },
                    {
                      "Brand": "Rikon",
                      "lineCode": "RIK"
                    },
                    {
                      "Brand": "Ritchie Engineering",
                      "lineCode": "RIE"
                    },
                    {
                      "Brand": "Rite Off",
                      "lineCode": "RIT"
                    },
                    {
                      "Brand": "Robertshaw",
                      "lineCode": "ROB"
                    },
                    {
                      "Brand": "Robinair Divison",
                      "lineCode": "ROD"
                    },
                    {
                      "Brand": "Robot Coupe",
                      "lineCode": "RCE"
                    },
                    {
                      "Brand": "Rockwell",
                      "lineCode": "ROC"
                    },
                    {
                      "Brand": "Rolair",
                      "lineCode": "ROL"
                    },
                    {
                      "Brand": "Rotozip",
                      "lineCode": "RTZ"
                    },
                    {
                      "Brand": "Rowenta",
                      "lineCode": "ROW"
                    },
                    {
                      "Brand": "Royal",
                      "lineCode": "ROY"
                    },
                    {
                      "Brand": "Runco",
                      "lineCode": "RUN"
                    },
                    {
                      "Brand": "Ruud",
                      "lineCode": "RUU"
                    },
                    {
                      "Brand": "Ryobi",
                      "lineCode": "TTI"
                    },
                    {
                      "Brand": "Saeco",
                      "lineCode": "SAE"
                    },
                    {
                      "Brand": "Salvajor",
                      "lineCode": "SAL"
                    },
                    {
                      "Brand": "Samsung",
                      "lineCode": "SMG"
                    },
                    {
                      "Brand": "Sanitaire",
                      "lineCode": "SAN"
                    },
                    {
                      "Brand": "Sanyo",
                      "lineCode": "SFS"
                    },
                    {
                      "Brand": "Schaerer",
                      "lineCode": "SCH"
                    },
                    {
                      "Brand": "Scopes & Power Supp.",
                      "lineCode": "KWD"
                    },
                    {
                      "Brand": "Scotsman",
                      "lineCode": "SCO"
                    },
                    {
                      "Brand": "Sears Commerical",
                      "lineCode": "SEA"
                    },
                    {
                      "Brand": "SEB",
                      "lineCode": "SEB"
                    },
                    {
                      "Brand": "Senco",
                      "lineCode": "SNC"
                    },
                    {
                      "Brand": "Senseo",
                      "lineCode": "SEN"
                    },
                    {
                      "Brand": "Sensible Products",
                      "lineCode": "SEP"
                    },
                    {
                      "Brand": "Server",
                      "lineCode": "SER"
                    },
                    {
                      "Brand": "Shakespeare",
                      "lineCode": "SHK"
                    },
                    {
                      "Brand": "Shark",
                      "lineCode": "SRK"
                    },
                    {
                      "Brand": "Sharp",
                      "lineCode": "SHA"
                    },
                    {
                      "Brand": "Shimano",
                      "lineCode": "SHM"
                    },
                    {
                      "Brand": "Shindaiwa",
                      "lineCode": "SHI"
                    },
                    {
                      "Brand": "Shopvac",
                      "lineCode": "SHO"
                    },
                    {
                      "Brand": "Sierra",
                      "lineCode": "SIE"
                    },
                    {
                      "Brand": "Sigmac Usa",
                      "lineCode": "SGM"
                    },
                    {
                      "Brand": "Silhouette",
                      "lineCode": "SIL"
                    },
                    {
                      "Brand": "Silver King",
                      "lineCode": "SVK"
                    },
                    {
                      "Brand": "Simer",
                      "lineCode": "SME"
                    },
                    {
                      "Brand": "Simplicity",
                      "lineCode": "SIM"
                    },
                    {
                      "Brand": "Skil",
                      "lineCode": "SKI"
                    },
                    {
                      "Brand": "Skuttle",
                      "lineCode": "SKU"
                    },
                    {
                      "Brand": "Small Appliance Product",
                      "lineCode": "GEA"
                    },
                    {
                      "Brand": "SMART TECHNOLOGIES",
                      "lineCode": "SMT"
                    },
                    {
                      "Brand": "Smeg",
                      "lineCode": "SGG"
                    },
                    {
                      "Brand": "Smudgetip",
                      "lineCode": "SMD"
                    },
                    {
                      "Brand": "Snapper",
                      "lineCode": "SNA"
                    },
                    {
                      "Brand": "Sonicare",
                      "lineCode": "SCR"
                    },
                    {
                      "Brand": "Sony",
                      "lineCode": "SON"
                    },
                    {
                      "Brand": "Soundlier",
                      "lineCode": "SOU"
                    },
                    {
                      "Brand": "Southbend",
                      "lineCode": "SBD"
                    },
                    {
                      "Brand": "Southbend Range",
                      "lineCode": "SOR"
                    },
                    {
                      "Brand": "Southland",
                      "lineCode": "SLD"
                    },
                    {
                      "Brand": "Soyo Refurbished",
                      "lineCode": "SYR"
                    },
                    {
                      "Brand": "Spaceman",
                      "lineCode": "SMU"
                    },
                    {
                      "Brand": "Spectrum",
                      "lineCode": "SPE"
                    },
                    {
                      "Brand": "Spectrum Refurbished",
                      "lineCode": "SPR"
                    },
                    {
                      "Brand": "Speed Queen",
                      "lineCode": "Fa"
                    },
                    {
                      "Brand": "Spraytech",
                      "lineCode": "SPT"
                    },
                    {
                      "Brand": "SRC Refrigeration",
                      "lineCode": "SRC"
                    },
                    {
                      "Brand": "Stanco",
                      "lineCode": "STC"
                    },
                    {
                      "Brand": "Stanley",
                      "lineCode": "SLY"
                    },
                    {
                      "Brand": "Star",
                      "lineCode": "STA"
                    },
                    {
                      "Brand": "Star Trac",
                      "lineCode": "STR"
                    },
                    {
                      "Brand": "Starlogic Refurbish",
                      "lineCode": "STL"
                    },
                    {
                      "Brand": "Sterling",
                      "lineCode": "STE"
                    },
                    {
                      "Brand": "Stero Dishwasher",
                      "lineCode": "STD"
                    },
                    {
                      "Brand": "Stevens Appliance Tr",
                      "lineCode": "SAT"
                    },
                    {
                      "Brand": "Stoelting",
                      "lineCode": "STO"
                    },
                    {
                      "Brand": "structural Concepts",
                      "lineCode": "SCS"
                    },
                    {
                      "Brand": "Sub-Zero",
                      "lineCode": "SUB"
                    },
                    {
                      "Brand": "Subaru / Robin",
                      "lineCode": "SRN"
                    },
                    {
                      "Brand": "Summit Brands",
                      "lineCode": "SUM"
                    },
                    {
                      "Brand": "Sun-stream",
                      "lineCode": "SST"
                    },
                    {
                      "Brand": "Sunbeam",
                      "lineCode": "SUN"
                    },
                    {
                      "Brand": "Sunglo",
                      "lineCode": "SGO"
                    },
                    {
                      "Brand": "Sunheat",
                      "lineCode": "SHT"
                    },
                    {
                      "Brand": "Sunpak",
                      "lineCode": "SPK"
                    },
                    {
                      "Brand": "Supplies",
                      "lineCode": "SUP"
                    },
                    {
                      "Brand": "Sure Flame",
                      "lineCode": "SUR"
                    },
                    {
                      "Brand": "SVA",
                      "lineCode": "SVA"
                    },
                    {
                      "Brand": "Switchcraft",
                      "lineCode": "SWI"
                    },
                    {
                      "Brand": "Sylvania",
                      "lineCode": "SYL"
                    },
                    {
                      "Brand": "Systemax",
                      "lineCode": "STM"
                    },
                    {
                      "Brand": "T-fal",
                      "lineCode": "T-F"
                    },
                    {
                      "Brand": "Tanaka",
                      "lineCode": "TAN"
                    },
                    {
                      "Brand": "Tappan",
                      "lineCode": "FRI"
                    },
                    {
                      "Brand": "Tce Technical",
                      "lineCode": "RCL"
                    },
                    {
                      "Brand": "TCL",
                      "lineCode": "TCL"
                    },
                    {
                      "Brand": "Tech Spray",
                      "lineCode": "TEC"
                    },
                    {
                      "Brand": "Tecumseh",
                      "lineCode": "TSH"
                    },
                    {
                      "Brand": "Tektronix",
                      "lineCode": "TKX"
                    },
                    {
                      "Brand": "Tempur-pedic",
                      "lineCode": "TMP"
                    },
                    {
                      "Brand": "Test Equipment",
                      "lineCode": "VEL"
                    },
                    {
                      "Brand": "Test Parts",
                      "lineCode": "TST"
                    },
                    {
                      "Brand": "The Good Clean",
                      "lineCode": "TGC"
                    },
                    {
                      "Brand": "Thermador",
                      "lineCode": "BCH"
                    },
                    {
                      "Brand": "Thermofluid Tech",
                      "lineCode": "THT"
                    },
                    {
                      "Brand": "Thor",
                      "lineCode": "THO"
                    },
                    {
                      "Brand": "Tile",
                      "lineCode": "ESI"
                    },
                    {
                      "Brand": "Titan",
                      "lineCode": "TIT"
                    },
                    {
                      "Brand": "Titan Tankless Water",
                      "lineCode": "TTW"
                    },
                    {
                      "Brand": "TNT",
                      "lineCode": "TNT"
                    },
                    {
                      "Brand": "Tom Tom",
                      "lineCode": "TMT"
                    },
                    {
                      "Brand": "Tools",
                      "lineCode": "PAC"
                    },
                    {
                      "Brand": "Toro",
                      "lineCode": "TOR"
                    },
                    {
                      "Brand": "Toshiba",
                      "lineCode": "TBA"
                    },
                    {
                      "Brand": "Toshiba Computer",
                      "lineCode": "TOS"
                    },
                    {
                      "Brand": "Tradepro",
                      "lineCode": "TRA"
                    },
                    {
                      "Brand": "Trane",
                      "lineCode": "TRN"
                    },
                    {
                      "Brand": "Traulsen",
                      "lineCode": "TSN"
                    },
                    {
                      "Brand": "Tri-state Module",
                      "lineCode": "TSM"
                    },
                    {
                      "Brand": "Tripp-lite",
                      "lineCode": "TRI"
                    },
                    {
                      "Brand": "Troy Bilt",
                      "lineCode": "MTD"
                    },
                    {
                      "Brand": "Turbo Air",
                      "lineCode": "TUA"
                    },
                    {
                      "Brand": "Turbochef",
                      "lineCode": "BMC"
                    },
                    {
                      "Brand": "Twin Eagles",
                      "lineCode": "TWI"
                    },
                    {
                      "Brand": "U-line",
                      "lineCode": "ULN"
                    },
                    {
                      "Brand": "UltraFryer",
                      "lineCode": "ULT"
                    },
                    {
                      "Brand": "Unic",
                      "lineCode": "UIC"
                    },
                    {
                      "Brand": "Universal Ent",
                      "lineCode": "ULE"
                    },
                    {
                      "Brand": "Uniweld",
                      "lineCode": "UNI"
                    },
                    {
                      "Brand": "Unox",
                      "lineCode": "UNO"
                    },
                    {
                      "Brand": "Us Stove Company",
                      "lineCode": "USS"
                    },
                    {
                      "Brand": "Usd Products",
                      "lineCode": "USD"
                    },
                    {
                      "Brand": "V7e Elect. Refurbish",
                      "lineCode": "VSR"
                    },
                    {
                      "Brand": "Vanco",
                      "lineCode": "VAN"
                    },
                    {
                      "Brand": "Vapco Products",
                      "lineCode": "VAP"
                    },
                    {
                      "Brand": "Vent-a-hood",
                      "lineCode": "VEN"
                    },
                    {
                      "Brand": "Verge",
                      "lineCode": "VRG"
                    },
                    {
                      "Brand": "Vermont",
                      "lineCode": "VER"
                    },
                    {
                      "Brand": "Victory",
                      "lineCode": "VIC"
                    },
                    {
                      "Brand": "VIDEO GAMING",
                      "lineCode": "VGA"
                    },
                    {
                      "Brand": "Video Mount Products",
                      "lineCode": "VMP"
                    },
                    {
                      "Brand": "Viewsonic Refurb",
                      "lineCode": "VWS"
                    },
                    {
                      "Brand": "Viking",
                      "lineCode": "VIK"
                    },
                    {
                      "Brand": "Viore",
                      "lineCode": "VIO"
                    },
                    {
                      "Brand": "Virginia Air",
                      "lineCode": "VIR"
                    },
                    {
                      "Brand": "Vision Fitness",
                      "lineCode": "VIS"
                    },
                    {
                      "Brand": "Vivitek",
                      "lineCode": "VIV"
                    },
                    {
                      "Brand": "VIZIO",
                      "lineCode": "VIZ"
                    },
                    {
                      "Brand": "VIZIO-FOXCONN",
                      "lineCode": "FOX"
                    },
                    {
                      "Brand": "VIZIO-TPV",
                      "lineCode": "TPV"
                    },
                    {
                      "Brand": "VIZIO-WISTRON",
                      "lineCode": "WIS"
                    },
                    {
                      "Brand": "Vizparts",
                      "lineCode": "VZP"
                    },
                    {
                      "Brand": "Vollrath",
                      "lineCode": "VLH"
                    },
                    {
                      "Brand": "Vulcan",
                      "lineCode": "VUL"
                    },
                    {
                      "Brand": "Wagner",
                      "lineCode": "WAG"
                    },
                    {
                      "Brand": "Walbro",
                      "lineCode": "WAL"
                    },
                    {
                      "Brand": "Walker & Sons",
                      "lineCode": "WLK"
                    },
                    {
                      "Brand": "Waring",
                      "lineCode": "WAR"
                    },
                    {
                      "Brand": "Wearever",
                      "lineCode": "WVR"
                    },
                    {
                      "Brand": "Weather Guard",
                      "lineCode": "WEA"
                    },
                    {
                      "Brand": "Weber",
                      "lineCode": "WBR"
                    },
                    {
                      "Brand": "Weed Eater",
                      "lineCode": "WEE"
                    },
                    {
                      "Brand": "Wells",
                      "lineCode": "WEL"
                    },
                    {
                      "Brand": "Weslo",
                      "lineCode": "WSL"
                    },
                    {
                      "Brand": "West Penn",
                      "lineCode": "WES"
                    },
                    {
                      "Brand": "Western Dig. Refurb",
                      "lineCode": "WDR"
                    },
                    {
                      "Brand": "Westinghouse",
                      "lineCode": "WDE"
                    },
                    {
                      "Brand": "Whirlpool",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "White Mountain",
                      "lineCode": "WMN"
                    },
                    {
                      "Brand": "White-rodgers",
                      "lineCode": "WHR"
                    },
                    {
                      "Brand": "White-Westinghouse",
                      "lineCode": "FRI"
                    },
                    {
                      "Brand": "Wii Nintendo",
                      "lineCode": "WII"
                    },
                    {
                      "Brand": "Wilbur Curtis",
                      "lineCode": "WIC"
                    },
                    {
                      "Brand": "Wilton",
                      "lineCode": "WIL"
                    },
                    {
                      "Brand": "Winco",
                      "lineCode": "WCO"
                    },
                    {
                      "Brand": "Winegard",
                      "lineCode": "WIN"
                    },
                    {
                      "Brand": "Winston",
                      "lineCode": "WST"
                    },
                    {
                      "Brand": "Wolf Appliacen",
                      "lineCode": "WOL"
                    },
                    {
                      "Brand": "Wood Finishing",
                      "lineCode": "WFS"
                    },
                    {
                      "Brand": "Wood Stone",
                      "lineCode": "WOO"
                    },
                    {
                      "Brand": "Worx",
                      "lineCode": "WOR"
                    },
                    {
                      "Brand": "X2gen Refurbished",
                      "lineCode": "XTG"
                    },
                    {
                      "Brand": "Xantus Products",
                      "lineCode": "XAN"
                    },
                    {
                      "Brand": "Xfmrs & Solenoids",
                      "lineCode": "STN"
                    },
                    {
                      "Brand": "Yamaha",
                      "lineCode": "YAM"
                    },
                    {
                      "Brand": "Yard Man",
                      "lineCode": "YAR"
                    },
                    {
                      "Brand": "Yc",
                      "lineCode": "YCX"
                    },
                    {
                      "Brand": "Yeats Dolly",
                      "lineCode": "YEA"
                    },
                    {
                      "Brand": "York",
                      "lineCode": "YOR"
                    },
                    {
                      "Brand": "Yummly",
                      "lineCode": "WHI"
                    },
                    {
                      "Brand": "Zama",
                      "lineCode": "ZAM"
                    },
                    {
                      "Brand": "Zebra",
                      "lineCode": "ZEB"
                    },
                    {
                      "Brand": "Zephyr",
                      "lineCode": "ZEP"
                    },
                    {
                      "Brand": "Zodiac",
                      "lineCode": "ZOD"
                    }
                  ];   
                // console.log("Brand_json",Brand_json)
                          
                           var brandName = item.vendor;
                            const formatString = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
                            const matchingBrand = Brand_json.find(item => formatString(item.Brand) === formatString(brandName));
                         // console.log("matchingBrand",matchingBrand)
                      
                      var imageUrl;
                      
                      if (matchingBrand && item.image === null ) {
                        imageUrl = `https://encompass-11307.kxcdn.com/imageDisplay?mfgCode=${matchingBrand.lineCode}&type=b&size=s`;
                        //console.log("log if imageUrl")
                      } else {
                        imageUrl = item.image;
                      }

                const inputValue = document.querySelector('.aa-Input')?.value?.trim();
                
                
                return html`<li class="aa-Item test2" id="autocomplete-0-products-item-1" role="option" aria-selected="false">
                            <a href="/products/${item.handle}" class="aa-ItemLink aa-ProductItem A">
                              <div class="aa-ItemContent">
                                <div class="aa-ItemPicture aa-ItemPicture--loaded">
                                  <img src="${imageUrl}" alt="" />

                                   ${
                                      item.sku?.replace(/[-_]/g, '').trim().toLowerCase() === inputValue?.replace(/[-_]/g, '').trim().toLowerCase()
                                        ? html`<img
                                            src="https://cdn.shopify.com/s/files/1/0700/0293/3937/files/exact-match.svg?v=1750412494"
                                            alt="Exact Match"
                                            class="exact-match-logo"
                                          />`
                                        : ''
                                    }
           
                                </div>
                                <div class="aa-ItemContentBody">
                                    <div class="aa-ItemContentBrand check">${item.product_type}
                                    </div>
                                  <div class="aa-ItemContentTitleWrapper">
                                    <div class="aa-ItemContentTitle">${item.title}
                                    </div>
                                    <div class="aa-ItemContentSku" >${item.sku}</div>
                                  </div>
                                  <div class="aa-ItemContentPrice"><div class="aa-ItemContentPriceCurrent"></div>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </li>`;
              }
            }
          },
        ];
      },
    };


    // const saleItemsPlugin = {
    //   name: 'custom-sale-items-plugin',
    //   getSources({ query }) {
    //     return [
    //       {
    //         sourceId: "webcat",
    //         getItems() {
    //           return getAlgoliaResults({
    //             searchClient,
    //             queries: [{
    //               indexName: "shopifyps_products",
    //               query,
    //               // params: {
    //               //   filters: "named_tags.webcat:true"
    //               // }
    //             }]
    //           }) 
    //         },
    //         templates: {
    //           header({ html, state }) {
    //             console.log("him>>>",state);
    //             return html`
    //               <div class="aa-SourceHeader">
    //                 <span class="aa-SourceHeaderTitle">Sale Items</span>
    //                 <div class="aa-SourceHeaderLine" />
    //               </div>`;
    //           },
    //           item({ item, components, html }) {
    //             //return html`${item.title}`;
    //           }
    //         }
    //       },
    //     ];
    //   },
    // };
    options.plugins.push(modelItemsPlugin);

    return options;
  });


let singleResultProductHandle = null;

// Update Algolia hook to track single results
algoliaShopify.hooks.registerHook('beforeAutocompleteProductTransformResponseHits', function(hits, results) {
  singleResultProductHandle = results[0]?.hits?.length === 1 ? results[0].hits[0].handle : null;
  return hits;
});

// Handle search button click
document.addEventListener('click', function(e) {
  const searchButton = e.target.closest('.aa-SubmitButton');
  if (!searchButton) return;

  e.preventDefault();
  const searchInput = document.querySelector('.aa-Input');
  const query = searchInput?.value.trim();

  if (singleResultProductHandle) {
    // Single result → redirect to product
    window.location.href = `/products/${singleResultProductHandle}`;
  } else if (query) {
    // Multiple results → redirect to search page
    window.location.href = `/search?q=${encodeURIComponent(query)}`;
  }
});

// Handle Enter key in search input
const searchInput = document.querySelector('.aa-Input');
if (searchInput) {
  searchInput.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const query = this.value.trim();

    if (singleResultProductHandle) {
      // Single result → redirect to product
      window.location.href = `/products/${singleResultProductHandle}`;
    } else if (query) {
      // Multiple results → redirect to search page
      window.location.href = `/search?q=${encodeURIComponent(query)}`;
    }
  });
}



 // Add the output of the custom plugin to the autocomplate layout.
  algoliaShopify.hooks.registerHook("beforeAutocompleteMainTemplate", function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html } = templateOptions;
  //  console.log("elements",elements)
    // Add the custom plugin output to the Autocomplete template by referencing 
    // the custom plugin sourceId - `saleItems`.
    // console.log("elements.collections:",elements.collections,"elements.articles:",elements.articles,"elements.pages:",elements.pages,"elements.redirectUrlPlugin:",elements.redirectUrlPlugin)

    const hasCollections = elements.collections && elements.collections.props && Array.isArray(elements.collections.props.children) && elements.collections.props.children.length > 0;
    const hasArticles = elements.articles && elements.articles.props && Array.isArray(elements.articles.props.children) && elements.articles.props.children.length > 0;
    const hasPages = elements.pages && elements.pages.props && Array.isArray(elements.pages.props.children) && elements.pages.props.children.length > 0;
    const hasRedirectUrlPlugin = elements.redirectUrlPlugin && elements.redirectUrlPlugin.props && Array.isArray(elements.redirectUrlPlugin.props.children) && elements.redirectUrlPlugin.props.children.length > 0;

// Check if any of the collections, articles, pages, or redirectUrlPlugin have data
const showSuggestions = hasCollections || hasArticles || hasPages || hasRedirectUrlPlugin;
    // console.log("${elements.products}",elements.products)

    const hasProducts = 
  elements.products && 
  elements.products.props && 
  Array.isArray(elements.products.props.children) && 
  elements.products.props.children.length > 0;

    
    
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSections">
        ${showSuggestions ? html`
          <div class="aa-PanelSection--left">
          <div class="aa-SourceHeader accordian_item">
              <span class="aa-SourceHeaderTitle">Categories</span>
              <div class="accordian-toggle">
                <span class="toggle-sign suggesstIncre">+</span>
                <span class="toggle-sign suggestDecre" style="display: none;">-</span>
              </div> 
          </div>
           <div class="namedcollections">
            ${elements.collections} ${elements.articles} ${elements.pages}
            ${elements.redirectUrlPlugin}
            </div>
          </div>
          ` : ''}  
          <div class="aa-PanelSection--right">
           ${hasProducts ? html`
            <div class="defaultparts">
               ${elements.products}
            </div>
            ` : ''}  
            <div class="pluginmodels">
           
               ${elements.modelItems}
            </div>
          </div>
        </div>
      </div>
    `;

  });



  


let previousQuery = ""; 

  // algoliaShopify.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function(_defaultTemplate, templateOptions) {
  //   // console.log("_defaultTemplate:",_defaultTemplate,"templateOptions",templateOptions)
  //   const { html, state } = templateOptions;
  //   //console.log("state",state.query,"previousQuery",previousQuery)

  //   if(previousQuery === state.query ) {
  //     $('.encompassResult').css('display','none')
  //     // console.log("matched with previous one ")
  //   }else{
   
  //     $('.encompassResult').css('display','none')
  //      previousQuery = state.query;
  //     // console.log("not matched with previous one ")

  //     var data = {
  //           searchstr: state.query
  //       };

  //       jQuery.ajax({
  //           url: `https://fridgeparts.us/grpapp/admin_ajax.php?action=searchMain`,
  //           type: 'POST',
  //           data: data,
  //           success: function(response) {
  //             // console.log("data>>>search",response)
  //             var serDataJson = JSON.parse(response)
  //             // console.log("serDataJson",serDataJson)
              

  //             var parts = serDataJson.data.parts;
  //             // console.log("parts",parts)

  //             $('.searchResult').empty();
                
              
  //                $.each(parts, function(index, part) {
  //                  console.log("part>>>>",part)
  //                   var partNumber = part.partNumber;
  //                   var mfgName = part.mfgName;
  //                   var basePN = part.basePN;
  //                   var description = part.description;
  //                   var partImage = part.partImage;

  //                  // console.log("partImagepartImage>>>",partImage)

  //                   var finalPath;
                  
  //                     if (partImage.startsWith("http")) {
  //                         // If imagePath starts with 'http', use the same path
  //                         finalPath1 = partImage;
                        
  //                         finalPath = finalPath1.replace(/([?&]size=)[^&]*/, '$1s');
  //                       // console.log("finalPath for var encompas ",finalPath) 
                        
  //                     } else {
  //                         // If imagePath does not start with 'http', prepend the necessary URL
  //                         const finalPath2  = "https://encompass-11307.kxcdn.com/imageDisplay?" + partImage;
  //                       // console.log("finalPath2",finalPath2)

  //                         finalPath = finalPath2.replace(/([?&]size=)[^&]*/, '$1s');
  //                       // console.log("finalPath for var encompas ",finalPath) 
                        
  //                     }
                  
  //                     // console.log("finalPath for encompass data ", finalPath);
                    
  //                  //  console.log("part Number: " + partNumber + ", Manufacturer Name: " + mfgName);
  //                  // console.log( "basePN:",basePN, "description:",description, "partImage:",partImage)

  //                  var Divappend = `<div class="encompass_data two_flex 1" ><div  product-tags = ""  imgsrcCRT="${finalPath}" priceCRT="" titleCRT="${mfgName} ${partNumber}" desCRT="${mfgName} ${partNumber} ${description}" basepnCRT="${basePN}" parthandle="${mfgName} ${partNumber}" attrpartNo="${partNumber}" attrhandle="" vendorname="${mfgName}" class="modellistpara two_flex">
  //                                                    <div class="OneDiv"> 
  //                                                    <div class="img_path" > 
  //                                                      <a class="newhandleSearch" href="javascript:void(0)" ><img src='${finalPath}' style='height: 100px;' ></a>
  //                                                       <div> <img src="https://cdn.shopify.com/s/files/1/0638/4887/4142/files/${mfgName}.png" alt="${mfgName}" class="Model_BrandLogo"></div>
  //                                                    </div>
  //                                                     <div class="PaPrAdd" >
  //                                                        <div class="main_text_Div">
  //                                                          <h4><a class="newhandleSearch" href="javascript:void(0)" >${mfgName} ${partNumber}</a></h4>
  //                                                        </div> 
  //                                                        <div class="divconatin" >
  //                                                           <h4><a class="newhandleSearch" href="javascript:void(0)" >$</a></h4>
  //                                                        </div>
  //                                                     </div> 
  //                                                     </div> 
  //                                               </div>
  //                                               <div class="divBtn" >
  //                                                   <button basepn="${basePN}" product-tags = "" imgsrcCRT="https://encompass-11307.kxcdn.com/imageDisplay?${finalPath}" priceCRT="" titleCRT="${mfgName} ${partNumber}" desCRT="${mfgName} ${partNumber} ${description}" actionCart="addtocart" attrpartNo="${partNumber}" vendorname="${mfgName}"  prtNo="" href="javascript:void(0)" class="add_to_cart_encompass add_tocart_data  linkclass newhandleSearch"><div class="cart_icon_img">
  //                                         <img src="https://cdn.shopify.com/s/files/1/0638/4887/4142/files/Group_4.png?v=1719407493">
  //                                       </div>Add to Cart</button>
  //                                   </div></div>`

  //                  // console.log("Divappend",Divappend)
  //                  $('.searchResult').append(Divappend);
  //                  $('.encompassResult').css('display','none')
  //               });
             
              
  //           },
  //           error: function(jqXHR, textStatus, errorThrown) {
  //               // Handle the error here
  //               //console.error('AJAX error: ', textStatus, errorThrown);
  //           }
  //       });
      
  //   }
    
    
  //   return html`
  //     <div class="searchResult" ></div>
  //     <div class="aa-PanelLayout aa-Panel--scrollable encompassResult">
  //       <p class="aa-NoResultsHeader">
  //         ${algoliaShopify.translation_helpers.no_result_for(state.query)}
  //       </p>
  //     </div>
  //   `;
  // });


  



  algoliaShopify.hooks.registerHook("beforeAutocompleteProductTemplate",function (_defaultTemplate, templateOptions, distinct, itemLink, handleItemClick) {
      // Modify default options, then return them


    // console.log("templateOptions >>>>>",templateOptions)
      const { html, item, components } = templateOptions;
    // console.log("item rrrr>>>>>",item.vendor)
    //   console.log("components>>>>ram:",components.Highlight({hit: item,attribute:"title"}))
      // console.log("components:",components.Highlight({ hit: item, attribute: "title" }))

      var Brand_json = [
        {
          "Brand": "3M Filtrete Products",
          "lineCode": "MMM"
        },
        {
          "Brand": "Abu Garcia",
          "lineCode": "ABU"
        },
        {
          "Brand": "Accu Sharp",
          "lineCode": "ACU"
        },
        {
          "Brand": "Accutemp",
          "lineCode": "ATP"
        },
        {
          "Brand": "Acer",
          "lineCode": "ACR"
        },
        {
          "Brand": "Acer Refurb",
          "lineCode": "ACX"
        },
        {
          "Brand": "Acp",
          "lineCode": "ACP"
        },
        {
          "Brand": "Acros",
          "lineCode": "WHI"
        },
        {
          "Brand": "AeonAir",
          "lineCode": "ANR"
        },
        {
          "Brand": "Affresh",
          "lineCode": "WHI"
        },
        {
          "Brand": "Aga Marvel",
          "lineCode": "AGA"
        },
        {
          "Brand": "Aiphone",
          "lineCode": "AIP"
        },
        {
          "Brand": "Air King",
          "lineCode": "ARK"
        },
        {
          "Brand": "Airmaster",
          "lineCode": "AMT"
        },
        {
          "Brand": "AIRSLED",
          "lineCode": "AIR"
        },
        {
          "Brand": "Airtouch",
          "lineCode": "ACE"
        },
        {
          "Brand": "Aiwa",
          "lineCode": "AIW"
        },
        {
          "Brand": "Akai",
          "lineCode": "AKI"
        },
        {
          "Brand": "All Filters",
          "lineCode": "ACF"
        },
        {
          "Brand": "Alpha",
          "lineCode": "ALH"
        },
        {
          "Brand": "Alpine",
          "lineCode": "ALP"
        },
        {
          "Brand": "Alto Shaam",
          "lineCode": "ATL"
        },
        {
          "Brand": "Amana",
          "lineCode": "WHI"
        },
        {
          "Brand": "Amana Commerical",
          "lineCode": "AMA"
        },
        {
          "Brand": "Amana Menumaster",
          "lineCode": "AMR"
        },
        {
          "Brand": "Amana Ptac",
          "lineCode": "AMN"
        },
        {
          "Brand": "American Hakko",
          "lineCode": "HAK"
        },
        {
          "Brand": "American Metal Filte",
          "lineCode": "AMF"
        },
        {
          "Brand": "American Range",
          "lineCode": "ARE"
        },
        {
          "Brand": "American Standard",
          "lineCode": "AMS"
        },
        {
          "Brand": "Anderic",
          "lineCode": "NPS"
        },
        {
          "Brand": "Andis",
          "lineCode": "AND"
        },
        {
          "Brand": "Anets",
          "lineCode": "ANE"
        },
        {
          "Brand": "ANTUNES",
          "lineCode": "ANT"
        },
        {
          "Brand": "Aoc/epi",
          "lineCode": "AOC"
        },
        {
          "Brand": "Apex",
          "lineCode": "APX"
        },
        {
          "Brand": "Apple",
          "lineCode": "APL"
        },
        {
          "Brand": "Apple Replacement",
          "lineCode": "APA"
        },
        {
          "Brand": "APPLI PARTS",
          "lineCode": "GAL"
        },
        {
          "Brand": "Appliance Parts",
          "lineCode": "KIT"
        },
        {
          "Brand": "Appliance Parts",
          "lineCode": "ERP"
        },
        {
          "Brand": "APW Wyott",
          "lineCode": "AWT"
        },
        {
          "Brand": "Apw Wyott",
          "lineCode": "APW"
        },
        {
          "Brand": "Arclyte Technologies",
          "lineCode": "ARC"
        },
        {
          "Brand": "Arctic Air C",
          "lineCode": "AAC"
        },
        {
          "Brand": "Ariens",
          "lineCode": "ARI"
        },
        {
          "Brand": "Armstrong",
          "lineCode": "ARM"
        },
        {
          "Brand": "Asko",
          "lineCode": "ASK"
        },
        {
          "Brand": "Asti",
          "lineCode": "AST"
        },
        {
          "Brand": "Astra",
          "lineCode": "ATR"
        },
        {
          "Brand": "Asus",
          "lineCode": "ASU"
        },
        {
          "Brand": "Asus Refurb",
          "lineCode": "ASR"
        },
        {
          "Brand": "Avanti",
          "lineCode": "AVA"
        },
        {
          "Brand": "Avent",
          "lineCode": "AVT"
        },
        {
          "Brand": "Axis",
          "lineCode": "AXI"
        },
        {
          "Brand": "Ayp Craftsman",
          "lineCode": "HOP"
        },
        {
          "Brand": "B-air",
          "lineCode": "BAR"
        },
        {
          "Brand": "Backer Ehp",
          "lineCode": "BAC"
        },
        {
          "Brand": "Bad Part Number",
          "lineCode": "BAD"
        },
        {
          "Brand": "Bakers Pride",
          "lineCode": "BAK"
        },
        {
          "Brand": "Baratza",
          "lineCode": "BTZ"
        },
        {
          "Brand": "Barranca Diamond",
          "lineCode": "BRD"
        },
        {
          "Brand": "Barry Restore It All",
          "lineCode": "BRY"
        },
        {
          "Brand": "Bauknecht",
          "lineCode": "WHI"
        },
        {
          "Brand": "Baxter",
          "lineCode": "BAX"
        },
        {
          "Brand": "Baystate Pool",
          "lineCode": "SPA"
        },
        {
          "Brand": "Beckman Industrial",
          "lineCode": "BEC"
        },
        {
          "Brand": "Beko",
          "lineCode": "BEK"
        },
        {
          "Brand": "Belt And Vcr Acc.",
          "lineCode": "PRB"
        },
        {
          "Brand": "Benq Usa",
          "lineCode": "BEN"
        },
        {
          "Brand": "Berkel",
          "lineCode": "BKL"
        },
        {
          "Brand": "Bertazzoni",
          "lineCode": "BRT"
        },
        {
          "Brand": "Beverage Air",
          "lineCode": "BEV"
        },
        {
          "Brand": "Binatone Electronics",
          "lineCode": "BQN"
        },
        {
          "Brand": "Bionaire",
          "lineCode": "BIO"
        },
        {
          "Brand": "Bissell",
          "lineCode": "BIS"
        },
        {
          "Brand": "Bizerba",
          "lineCode": "BIZ"
        },
        {
          "Brand": "BK Precision",
          "lineCode": "BKP"
        },
        {
          "Brand": "BKI",
          "lineCode": "BKI"
        },
        {
          "Brand": "Black & Decker",
          "lineCode": "BLA"
        },
        {
          "Brand": "Blodgett",
          "lineCode": "BGT"
        },
        {
          "Brand": "Blomberg",
          "lineCode": "BLM"
        },
        {
          "Brand": "Blue Ember",
          "lineCode": "BER"
        },
        {
          "Brand": "Bluebird",
          "lineCode": "BBD"
        },
        {
          "Brand": "Bluedri",
          "lineCode": "BDR"
        },
        {
          "Brand": "Bolens",
          "lineCode": "BOL"
        },
        {
          "Brand": "Bosch",
          "lineCode": "BCH"
        },
        {
          "Brand": "Bosch Tools",
          "lineCode": "BSH"
        },
        {
          "Brand": "Bostitch",
          "lineCode": "BTH"
        },
        {
          "Brand": "Boston Acoustics",
          "lineCode": "BSA"
        },
        {
          "Brand": "Bowers &Wilkins",
          "lineCode": "BWL"
        },
        {
          "Brand": "Boxes",
          "lineCode": "BOX"
        },
        {
          "Brand": "Brastemp",
          "lineCode": "WHI"
        },
        {
          "Brand": "Braun",
          "lineCode": "BRA"
        },
        {
          "Brand": "Braun",
          "lineCode": "BBN"
        },
        {
          "Brand": "Breville",
          "lineCode": "BRE"
        },
        {
          "Brand": "Briggs Power",
          "lineCode": "BSG"
        },
        {
          "Brand": "Briggs Stratton",
          "lineCode": "BSP"
        },
        {
          "Brand": "Britelite Refurbish",
          "lineCode": "BLR"
        },
        {
          "Brand": "Broan",
          "lineCode": "BRN"
        },
        {
          "Brand": "Broil King",
          "lineCode": "BLK"
        },
        {
          "Brand": "Broil-mate",
          "lineCode": "BRM"
        },
        {
          "Brand": "Broilmaster",
          "lineCode": "BMR"
        },
        {
          "Brand": "Broksonic",
          "lineCode": "BRK"
        },
        {
          "Brand": "Brookstone",
          "lineCode": "BKS"
        },
        {
          "Brand": "Brother",
          "lineCode": "BRO"
        },
        {
          "Brand": "Brother Refurb",
          "lineCode": "BRR"
        },
        {
          "Brand": "Brown Stove",
          "lineCode": "BRS"
        },
        {
          "Brand": "Bunn",
          "lineCode": "BUN"
        },
        {
          "Brand": "Caloric",
          "lineCode": "WHI"
        },
        {
          "Brand": "Calphalon",
          "lineCode": "CAL"
        },
        {
          "Brand": "Calspa",
          "lineCode": "CLP"
        },
        {
          "Brand": "Camp Chef",
          "lineCode": "CCF"
        },
        {
          "Brand": "Campbell Hausfeld",
          "lineCode": "CHD"
        },
        {
          "Brand": "Canon",
          "lineCode": "CAN"
        },
        {
          "Brand": "Canon Camera",
          "lineCode": "CA2"
        },
        {
          "Brand": "Canon Consumer",
          "lineCode": "CA1"
        },
        {
          "Brand": "Carrier",
          "lineCode": "CAR"
        },
        {
          "Brand": "Carter-Hoffmann",
          "lineCode": "CHN"
        },
        {
          "Brand": "CCS",
          "lineCode": "CCS"
        },
        {
          "Brand": "CELL PHONE PARTS",
          "lineCode": "SAM"
        },
        {
          "Brand": "CELL PHONE PARTS",
          "lineCode": "HTC"
        },
        {
          "Brand": "Chamberlain",
          "lineCode": "CHL"
        },
        {
          "Brand": "Champion",
          "lineCode": "CHA"
        },
        {
          "Brand": "Champion Moyer Diebel",
          "lineCode": "CML"
        },
        {
          "Brand": "Chapin",
          "lineCode": "CPN"
        },
        {
          "Brand": "Char-broil",
          "lineCode": "CBL"
        },
        {
          "Brand": "Chemicals",
          "lineCode": "RAW"
        },
        {
          "Brand": "Chemtronics",
          "lineCode": "CHE"
        },
        {
          "Brand": "Chicago Pneumatic",
          "lineCode": "CPC"
        },
        {
          "Brand": "Chipquik",
          "lineCode": "CHI"
        },
        {
          "Brand": "Cielo",
          "lineCode": "CLO"
        },
        {
          "Brand": "Clarion",
          "lineCode": "CLR"
        },
        {
          "Brand": "Classen",
          "lineCode": "CLA"
        },
        {
          "Brand": "Cleco",
          "lineCode": "CLC"
        },
        {
          "Brand": "Cleveland",
          "lineCode": "CLE"
        },
        {
          "Brand": "Climate Master",
          "lineCode": "CLI"
        },
        {
          "Brand": "CMA Dish Machines",
          "lineCode": "CMA"
        },
        {
          "Brand": "Coleman",
          "lineCode": "COL"
        },
        {
          "Brand": "Commercial cooking",
          "lineCode": "CEL"
        },
        {
          "Brand": "Compaq",
          "lineCode": "CPQ"
        },
        {
          "Brand": "Compaq Refurb",
          "lineCode": "CPX"
        },
        {
          "Brand": "Computer and Mobile",
          "lineCode": "COM"
        },
        {
          "Brand": "Computer Parts",
          "lineCode": "IMT"
        },
        {
          "Brand": "Computer Software",
          "lineCode": "QUE"
        },
        {
          "Brand": "Consul",
          "lineCode": "WHI"
        },
        {
          "Brand": "Continental Fan",
          "lineCode": "CON"
        },
        {
          "Brand": "Continental Refrigeration",
          "lineCode": "CRN"
        },
        {
          "Brand": "Convotherm",
          "lineCode": "CNV"
        },
        {
          "Brand": "Cooper",
          "lineCode": "COO"
        },
        {
          "Brand": "Cornelius",
          "lineCode": "COR"
        },
        {
          "Brand": "Craftsman",
          "lineCode": "CRA"
        },
        {
          "Brand": "Crary Bear Cat",
          "lineCode": "CBC"
        },
        {
          "Brand": "Crc America",
          "lineCode": "FBT"
        },
        {
          "Brand": "Cres Cor",
          "lineCode": "CRC"
        },
        {
          "Brand": "Criterion Appliance",
          "lineCode": "CRI"
        },
        {
          "Brand": "Crock Pot",
          "lineCode": "CRP"
        },
        {
          "Brand": "Crown Electronics",
          "lineCode": "CRO"
        },
        {
          "Brand": "Crown Steam",
          "lineCode": "CSM"
        },
        {
          "Brand": "Cub Cadet",
          "lineCode": "CUB"
        },
        {
          "Brand": "Cuisinart",
          "lineCode": "CUI"
        },
        {
          "Brand": "Curlin",
          "lineCode": "CUR"
        },
        {
          "Brand": "Cybex",
          "lineCode": "CYB"
        },
        {
          "Brand": "D&r Associates Inc.",
          "lineCode": "DRA"
        },
        {
          "Brand": "Dacor",
          "lineCode": "DAC"
        },
        {
          "Brand": "Daewoo",
          "lineCode": "DAE"
        },
        {
          "Brand": "Daikin",
          "lineCode": "DAI"
        },
        {
          "Brand": "Danby",
          "lineCode": "DBY"
        },
        {
          "Brand": "Dantona Industries",
          "lineCode": "DAN"
        },
        {
          "Brand": "Deflect-0",
          "lineCode": "DEF"
        },
        {
          "Brand": "Delfield",
          "lineCode": "DFD"
        },
        {
          "Brand": "Dell",
          "lineCode": "DEL"
        },
        {
          "Brand": "Dell Refurb",
          "lineCode": "DER"
        },
        {
          "Brand": "Delonghi",
          "lineCode": "DEI"
        },
        {
          "Brand": "Delta",
          "lineCode": "DTL"
        },
        {
          "Brand": "Delta Faucet",
          "lineCode": "DTF"
        },
        {
          "Brand": "Denon",
          "lineCode": "DEN"
        },
        {
          "Brand": "Devilbiss",
          "lineCode": "DEV"
        },
        {
          "Brand": "Dewalt",
          "lineCode": "DEW"
        },
        {
          "Brand": "Dex Refurbished",
          "lineCode": "DXR"
        },
        {
          "Brand": "Digitenna",
          "lineCode": "DIG"
        },
        {
          "Brand": "Dirt Devil",
          "lineCode": "DIR"
        },
        {
          "Brand": "Diversitech Inc",
          "lineCode": "DIV"
        },
        {
          "Brand": "Dngo International",
          "lineCode": "DNG"
        },
        {
          "Brand": "Dormont",
          "lineCode": "DRM"
        },
        {
          "Brand": "Dormont Manufacturin",
          "lineCode": "DOR"
        },
        {
          "Brand": "Dotco",
          "lineCode": "DOT"
        },
        {
          "Brand": "DR Power Equipment",
          "lineCode": "DRE"
        },
        {
          "Brand": "Dremel",
          "lineCode": "DML"
        },
        {
          "Brand": "DSS",
          "lineCode": "DSS"
        },
        {
          "Brand": "Duke",
          "lineCode": "DUK"
        },
        {
          "Brand": "Dundas Jafine Inc",
          "lineCode": "DUN"
        },
        {
          "Brand": "Duracell U.S.A.",
          "lineCode": "DUR"
        },
        {
          "Brand": "Dustless",
          "lineCode": "DUS"
        },
        {
          "Brand": "Dynabrade",
          "lineCode": "DYB"
        },
        {
          "Brand": "Dyson",
          "lineCode": "DYS"
        },
        {
          "Brand": "E-machine",
          "lineCode": "EMA"
        },
        {
          "Brand": "Echo",
          "lineCode": "ECH"
        },
        {
          "Brand": "Eclipse",
          "lineCode": "ECL"
        },
        {
          "Brand": "Edic",
          "lineCode": "EDI"
        },
        {
          "Brand": "Edlund",
          "lineCode": "EDL"
        },
        {
          "Brand": "Ego",
          "lineCode": "EGO"
        },
        {
          "Brand": "Electrolux",
          "lineCode": "FRI"
        },
        {
          "Brand": "Electrolux Pro",
          "lineCode": "ELX"
        },
        {
          "Brand": "Electronic Resources",
          "lineCode": "ELR"
        },
        {
          "Brand": "Electrosound",
          "lineCode": "ELS"
        },
        {
          "Brand": "Elica",
          "lineCode": "ELI"
        },
        {
          "Brand": "Emachines Refurb",
          "lineCode": "EMR"
        },
        {
          "Brand": "Emerson",
          "lineCode": "EME"
        },
        {
          "Brand": "Empire Video",
          "lineCode": "EMP"
        },
        {
          "Brand": "Encompass",
          "lineCode": "VBI"
        },
        {
          "Brand": "Encompass Parts",
          "lineCode": "EPD"
        },
        {
          "Brand": "Encompass Service",
          "lineCode": "ESS"
        },
        {
          "Brand": "Envision",
          "lineCode": "ENV"
        },
        {
          "Brand": "Envision Refurbished",
          "lineCode": "ENR"
        },
        {
          "Brand": "Epson",
          "lineCode": "EPS"
        },
        {
          "Brand": "Epson Refurb",
          "lineCode": "EPR"
        },
        {
          "Brand": "Escort",
          "lineCode": "ESC"
        },
        {
          "Brand": "Espresso Accessories",
          "lineCode": "ESP"
        },
        {
          "Brand": "Eureka",
          "lineCode": "ERK"
        },
        {
          "Brand": "Eveready Battery Co.",
          "lineCode": "EVE"
        },
        {
          "Brand": "Everpure",
          "lineCode": "EVP"
        },
        {
          "Brand": "Exmark",
          "lineCode": "EXM"
        },
        {
          "Brand": "Ez-flo",
          "lineCode": "EZF"
        },
        {
          "Brand": "Famous Entreprises",
          "lineCode": "FAM"
        },
        {
          "Brand": "Fantom",
          "lineCode": "FAN"
        },
        {
          "Brand": "Fasco",
          "lineCode": "FAS"
        },
        {
          "Brand": "FBD",
          "lineCode": "FBD"
        },
        {
          "Brand": "Federal Industries",
          "lineCode": "FED"
        },
        {
          "Brand": "Fein",
          "lineCode": "FEI"
        },
        {
          "Brand": "Fiesta",
          "lineCode": "FIE"
        },
        {
          "Brand": "Filters",
          "lineCode": "ECO"
        },
        {
          "Brand": "Fisher / Paykel",
          "lineCode": "FAP"
        },
        {
          "Brand": "Flex",
          "lineCode": "FLE"
        },
        {
          "Brand": "Flotec",
          "lineCode": "FLO"
        },
        {
          "Brand": "Fluke",
          "lineCode": "FLU"
        },
        {
          "Brand": "Follett",
          "lineCode": "FOL"
        },
        {
          "Brand": "Freemotion",
          "lineCode": "FMN"
        },
        {
          "Brand": "Freudenberg Filtrati",
          "lineCode": "FRE"
        },
        {
          "Brand": "Fri-Jado",
          "lineCode": "FJD"
        },
        {
          "Brand": "Friedrich",
          "lineCode": "FCH"
        },
        {
          "Brand": "Frigidaire",
          "lineCode": "FRI"
        },
        {
          "Brand": "Front Projector Lamp",
          "lineCode": "FPL"
        },
        {
          "Brand": "Frs Radio",
          "lineCode": "TKK"
        },
        {
          "Brand": "Frymaster",
          "lineCode": "FRY"
        },
        {
          "Brand": "Fuji-xerox Artermark",
          "lineCode": "FXA"
        },
        {
          "Brand": "Funai",
          "lineCode": "FUN"
        },
        {
          "Brand": "Gaggenau",
          "lineCode": "BCH"
        },
        {
          "Brand": "Gaming Parts",
          "lineCode": "GAM"
        },
        {
          "Brand": "Gardner",
          "lineCode": "GDN"
        },
        {
          "Brand": "Garland",
          "lineCode": "GLN"
        },
        {
          "Brand": "Garmin",
          "lineCode": "GAR"
        },
        {
          "Brand": "Gateway",
          "lineCode": "GAT"
        },
        {
          "Brand": "Gateway Refurb",
          "lineCode": "GTW"
        },
        {
          "Brand": "Gaylord",
          "lineCode": "GAY"
        },
        {
          "Brand": "Gc-thorsen",
          "lineCode": "GCE"
        },
        {
          "Brand": "GE",
          "lineCode": "HOT"
        },
        {
          "Brand": "GE Small Appliance",
          "lineCode": "GSA"
        },
        {
          "Brand": "Generac Delco",
          "lineCode": "GEN"
        },
        {
          "Brand": "Generic",
          "lineCode": "LPU"
        },
        {
          "Brand": "Generic Computer",
          "lineCode": "KAS"
        },
        {
          "Brand": "Genie",
          "lineCode": "GNE"
        },
        {
          "Brand": "Get It Clean",
          "lineCode": "GIC"
        },
        {
          "Brand": "Gibson",
          "lineCode": "FRI"
        },
        {
          "Brand": "Giles",
          "lineCode": "GLS"
        },
        {
          "Brand": "Gillette",
          "lineCode": "GIL"
        },
        {
          "Brand": "Gladiator",
          "lineCode": "WHI"
        },
        {
          "Brand": "Globe",
          "lineCode": "GLO"
        },
        {
          "Brand": "Go Plus Lighting",
          "lineCode": "GOP"
        },
        {
          "Brand": "Go Video",
          "lineCode": "GOV"
        },
        {
          "Brand": "Golds Gym",
          "lineCode": "GDG"
        },
        {
          "Brand": "Goliath Smart Phones",
          "lineCode": "GOL"
        },
        {
          "Brand": "GoLite",
          "lineCode": "GLT"
        },
        {
          "Brand": "Goodman",
          "lineCode": "GOO"
        },
        {
          "Brand": "Google",
          "lineCode": "GGL"
        },
        {
          "Brand": "Gps Batteries",
          "lineCode": "GPS"
        },
        {
          "Brand": "Gpx Remotes",
          "lineCode": "GPX"
        },
        {
          "Brand": "Graco",
          "lineCode": "GRA"
        },
        {
          "Brand": "GREEN CHOICE",
          "lineCode": "SOH"
        },
        {
          "Brand": "Green Choice",
          "lineCode": "SJP"
        },
        {
          "Brand": "Green Choice",
          "lineCode": "REB"
        },
        {
          "Brand": "Green Choice",
          "lineCode": "CGI"
        },
        {
          "Brand": "Green Choice Parts",
          "lineCode": "PPP"
        },
        {
          "Brand": "Green Choice Parts",
          "lineCode": "GCP"
        },
        {
          "Brand": "Green Choice Parts",
          "lineCode": "CKP"
        },
        {
          "Brand": "Greenworks",
          "lineCode": "GRN"
        },
        {
          "Brand": "Grindmaster",
          "lineCode": "GRI"
        },
        {
          "Brand": "Grindmaster Cecilware",
          "lineCode": "GMC"
        },
        {
          "Brand": "Grip-rite",
          "lineCode": "GPR"
        },
        {
          "Brand": "Groen",
          "lineCode": "GRO"
        },
        {
          "Brand": "Haier",
          "lineCode": "HAI"
        },
        {
          "Brand": "Haier Literature",
          "lineCode": "HSL"
        },
        {
          "Brand": "Hamilton Beach",
          "lineCode": "HAM"
        },
        {
          "Brand": "Hannspree Refurb",
          "lineCode": "HNS"
        },
        {
          "Brand": "Harmon Kardon",
          "lineCode": "HAR"
        },
        {
          "Brand": "Hatco",
          "lineCode": "HAT"
        },
        {
          "Brand": "Hayward",
          "lineCode": "HAY"
        },
        {
          "Brand": "Health Rider",
          "lineCode": "HRD"
        },
        {
          "Brand": "Heat Hog",
          "lineCode": "HHG"
        },
        {
          "Brand": "Heat Stream",
          "lineCode": "HSR"
        },
        {
          "Brand": "Heat Tools",
          "lineCode": "DRG"
        },
        {
          "Brand": "Heat Wagon",
          "lineCode": "HWN"
        },
        {
          "Brand": "Heatcraft",
          "lineCode": "HCT"
        },
        {
          "Brand": "Heatstar",
          "lineCode": "HEA"
        },
        {
          "Brand": "Henny Penny",
          "lineCode": "HNP"
        },
        {
          "Brand": "Hewlett Packard Refu",
          "lineCode": "HPR"
        },
        {
          "Brand": "High Capacity",
          "lineCode": "BAT"
        },
        {
          "Brand": "Hisense",
          "lineCode": "HIS"
        },
        {
          "Brand": "Hitachi",
          "lineCode": "HIT"
        },
        {
          "Brand": "Hiteker",
          "lineCode": "HTK"
        },
        {
          "Brand": "Hkc Digital",
          "lineCode": "HKC"
        },
        {
          "Brand": "Hobart",
          "lineCode": "HOB"
        },
        {
          "Brand": "Holman",
          "lineCode": "HOL"
        },
        {
          "Brand": "Homelite",
          "lineCode": "HOM"
        },
        {
          "Brand": "Honda",
          "lineCode": "HON"
        },
        {
          "Brand": "Honda Marine",
          "lineCode": "HAD"
        },
        {
          "Brand": "Honeywell",
          "lineCode": "HWL"
        },
        {
          "Brand": "Hoover",
          "lineCode": "HOO"
        },
        {
          "Brand": "Horizon Fitness",
          "lineCode": "HZN"
        },
        {
          "Brand": "Horton Valves",
          "lineCode": "HOR"
        },
        {
          "Brand": "Hoshizaki",
          "lineCode": "HZK"
        },
        {
          "Brand": "Hospira",
          "lineCode": "HOS"
        },
        {
          "Brand": "Hotpoint",
          "lineCode": "HOT"
        },
        {
          "Brand": "HP",
          "lineCode": "HEW"
        },
        {
          "Brand": "HP/Canon",
          "lineCode": "HPC"
        },
        {
          "Brand": "Hughes",
          "lineCode": "HUG"
        },
        {
          "Brand": "Hunter",
          "lineCode": "HUN"
        },
        {
          "Brand": "Huntington",
          "lineCode": "HTG"
        },
        {
          "Brand": "Husky",
          "lineCode": "HKY"
        },
        {
          "Brand": "Husqvarna",
          "lineCode": "HUS"
        },
        {
          "Brand": "Hussmann",
          "lineCode": "HSN"
        },
        {
          "Brand": "HVAC",
          "lineCode": "SPC"
        },
        {
          "Brand": "Hvac Parts",
          "lineCode": "GEM"
        },
        {
          "Brand": "Hydra Kool",
          "lineCode": "HDK"
        },
        {
          "Brand": "Hydrotech",
          "lineCode": "HYD"
        },
        {
          "Brand": "Hyundai Corporation",
          "lineCode": "HCU"
        },
        {
          "Brand": "I-symphony",
          "lineCode": "ISY"
        },
        {
          "Brand": "Ibm Refurb",
          "lineCode": "IBX"
        },
        {
          "Brand": "Ice-o-matic",
          "lineCode": "ICE"
        },
        {
          "Brand": "IKEA",
          "lineCode": "IKE"
        },
        {
          "Brand": "Ilo",
          "lineCode": "ILO"
        },
        {
          "Brand": "Imperial",
          "lineCode": "IPL"
        },
        {
          "Brand": "Import",
          "lineCode": "IMP"
        },
        {
          "Brand": "Impression",
          "lineCode": "IPR"
        },
        {
          "Brand": "Indesit",
          "lineCode": "WHI"
        },
        {
          "Brand": "Industrial Air",
          "lineCode": "IND"
        },
        {
          "Brand": "Infocus",
          "lineCode": "INF"
        },
        {
          "Brand": "Infratech",
          "lineCode": "INH"
        },
        {
          "Brand": "Ingersoll Rand",
          "lineCode": "ING"
        },
        {
          "Brand": "Inglis",
          "lineCode": "WHI"
        },
        {
          "Brand": "Innolux",
          "lineCode": "ILX"
        },
        {
          "Brand": "Inovate",
          "lineCode": "INO"
        },
        {
          "Brand": "Insignia",
          "lineCode": "ISG"
        },
        {
          "Brand": "Intel",
          "lineCode": "INT"
        },
        {
          "Brand": "Intermetro",
          "lineCode": "IMO"
        },
        {
          "Brand": "International Comfort Products",
          "lineCode": "ICP"
        },
        {
          "Brand": "International Environmental Corporation",
          "lineCode": "IEC"
        },
        {
          "Brand": "J.w. Harris",
          "lineCode": "JWH"
        },
        {
          "Brand": "Jackson",
          "lineCode": "JCN"
        },
        {
          "Brand": "Jacques Ebert",
          "lineCode": "JAC"
        },
        {
          "Brand": "Jacuzzi",
          "lineCode": "JZI"
        },
        {
          "Brand": "Jade",
          "lineCode": "JDE"
        },
        {
          "Brand": "Jancy",
          "lineCode": "JAN"
        },
        {
          "Brand": "Japanese Semi's",
          "lineCode": "JAP"
        },
        {
          "Brand": "Jason Illinois Inc",
          "lineCode": "JAS"
        },
        {
          "Brand": "JBL",
          "lineCode": "JBL"
        },
        {
          "Brand": "JBT",
          "lineCode": "JBT"
        },
        {
          "Brand": "Jenn-air",
          "lineCode": "JEN"
        },
        {
          "Brand": "Jennair",
          "lineCode": "WHI"
        },
        {
          "Brand": "Jenny",
          "lineCode": "JNY"
        },
        {
          "Brand": "Jet",
          "lineCode": "JET"
        },
        {
          "Brand": "Jet Tech",
          "lineCode": "JTT"
        },
        {
          "Brand": "John Guest",
          "lineCode": "JOG"
        },
        {
          "Brand": "Jonsered",
          "lineCode": "JON"
        },
        {
          "Brand": "JVC",
          "lineCode": "JVC"
        },
        {
          "Brand": "Jvc/amtran",
          "lineCode": "JVA"
        },
        {
          "Brand": "Kairak",
          "lineCode": "KAI"
        },
        {
          "Brand": "Karcher",
          "lineCode": "KAR"
        },
        {
          "Brand": "Kason",
          "lineCode": "KSN"
        },
        {
          "Brand": "Kawasaki",
          "lineCode": "KAW"
        },
        {
          "Brand": "Kds Monitors",
          "lineCode": "KDS"
        },
        {
          "Brand": "Kdsusa Inc Refurb",
          "lineCode": "KDX"
        },
        {
          "Brand": "Kef Audio",
          "lineCode": "KEF"
        },
        {
          "Brand": "Kelon",
          "lineCode": "KEL"
        },
        {
          "Brand": "Kelvinator",
          "lineCode": "FRI"
        },
        {
          "Brand": "Kendall",
          "lineCode": "KNL"
        },
        {
          "Brand": "Kenmore",
          "lineCode": "KMR"
        },
        {
          "Brand": "Kenwood",
          "lineCode": "KEW"
        },
        {
          "Brand": "Kenwood",
          "lineCode": "KEN"
        },
        {
          "Brand": "Kirby",
          "lineCode": "KIR"
        },
        {
          "Brand": "KitchenAid",
          "lineCode": "WHI"
        },
        {
          "Brand": "Knaack",
          "lineCode": "KNA"
        },
        {
          "Brand": "Kobalt",
          "lineCode": "KOB"
        },
        {
          "Brand": "Kodak Refurb",
          "lineCode": "KOR"
        },
        {
          "Brand": "Kohler",
          "lineCode": "KOH"
        },
        {
          "Brand": "Kolpak",
          "lineCode": "KOL"
        },
        {
          "Brand": "Konka",
          "lineCode": "KON"
        },
        {
          "Brand": "Kool It",
          "lineCode": "KOO"
        },
        {
          "Brand": "KOVA",
          "lineCode": "KAT"
        },
        {
          "Brand": "Krowne",
          "lineCode": "KRO"
        },
        {
          "Brand": "Krups",
          "lineCode": "KRU"
        },
        {
          "Brand": "Kyocera Mita",
          "lineCode": "KYO"
        },
        {
          "Brand": "L&lsquo;OR Barista",
          "lineCode": "LOR"
        },
        {
          "Brand": "Lamp Only",
          "lineCode": "LMP"
        },
        {
          "Brand": "Lancer",
          "lineCode": "LCR"
        },
        {
          "Brand": "Lang",
          "lineCode": "LAN"
        },
        {
          "Brand": "Lasko",
          "lineCode": "LAS"
        },
        {
          "Brand": "Lawn Boy",
          "lineCode": "LAW"
        },
        {
          "Brand": "Lelit",
          "lineCode": "LEL"
        },
        {
          "Brand": "Lennox",
          "lineCode": "LNX"
        },
        {
          "Brand": "Lenovo",
          "lineCode": "LEN"
        },
        {
          "Brand": "Lenovo Recertified",
          "lineCode": "LEH"
        },
        {
          "Brand": "Lexmark",
          "lineCode": "LEX"
        },
        {
          "Brand": "Lexmark Refurb",
          "lineCode": "LXR"
        },
        {
          "Brand": "LG",
          "lineCode": "ZEN"
        },
        {
          "Brand": "LG",
          "lineCode": "LGE"
        },
        {
          "Brand": "Liebherr",
          "lineCode": "LIE"
        },
        {
          "Brand": "Liftmaster",
          "lineCode": "LIF"
        },
        {
          "Brand": "Lincoln",
          "lineCode": "LCN"
        },
        {
          "Brand": "Linksys",
          "lineCode": "LIN"
        },
        {
          "Brand": "Liquid Video Refurb",
          "lineCode": "LVR"
        },
        {
          "Brand": "Little Wonder",
          "lineCode": "LTW"
        },
        {
          "Brand": "Littlefuse",
          "lineCode": "LIT"
        },
        {
          "Brand": "Lmb Heeger",
          "lineCode": "LMB"
        },
        {
          "Brand": "Lobb",
          "lineCode": "LOB"
        },
        {
          "Brand": "Lokring Appliance",
          "lineCode": "LOK"
        },
        {
          "Brand": "Lowell",
          "lineCode": "LOW"
        },
        {
          "Brand": "LPS",
          "lineCode": "LPS"
        },
        {
          "Brand": "Luxor",
          "lineCode": "LUX"
        },
        {
          "Brand": "Lynx",
          "lineCode": "LYN"
        },
        {
          "Brand": "Ma-line",
          "lineCode": "MAE"
        },
        {
          "Brand": "Magic Chef",
          "lineCode": "MAC"
        },
        {
          "Brand": "Magnavox",
          "lineCode": "MAG"
        },
        {
          "Brand": "Majestic",
          "lineCode": "MAJ"
        },
        {
          "Brand": "Makita",
          "lineCode": "MAK"
        },
        {
          "Brand": "Mallory",
          "lineCode": "MAL"
        },
        {
          "Brand": "Manitowoc Ice",
          "lineCode": "MIC"
        },
        {
          "Brand": "Mantis",
          "lineCode": "MAN"
        },
        {
          "Brand": "Marantz",
          "lineCode": "MAR"
        },
        {
          "Brand": "Margaritaville",
          "lineCode": "MGT"
        },
        {
          "Brand": "Market Forge",
          "lineCode": "MKF"
        },
        {
          "Brand": "Marquis",
          "lineCode": "MRQ"
        },
        {
          "Brand": "Marshall Air",
          "lineCode": "MSA"
        },
        {
          "Brand": "Mass Integrated",
          "lineCode": "MIS"
        },
        {
          "Brand": "Master",
          "lineCode": "MAS"
        },
        {
          "Brand": "Master-Bilt",
          "lineCode": "MLT"
        },
        {
          "Brand": "Matrix Fitness",
          "lineCode": "MAT"
        },
        {
          "Brand": "Matsushita",
          "lineCode": "MSL"
        },
        {
          "Brand": "Matv/catv Acc",
          "lineCode": "PCO"
        },
        {
          "Brand": "Max",
          "lineCode": "MXX"
        },
        {
          "Brand": "Max Professional",
          "lineCode": "MXP"
        },
        {
          "Brand": "Maxell",
          "lineCode": "MAX"
        },
        {
          "Brand": "Maytag",
          "lineCode": "WHI"
        },
        {
          "Brand": "Maytag",
          "lineCode": "MAY"
        },
        {
          "Brand": "MCM",
          "lineCode": "MCM"
        },
        {
          "Brand": "Medex",
          "lineCode": "MDM"
        },
        {
          "Brand": "Memory Products",
          "lineCode": "PAR"
        },
        {
          "Brand": "Merco",
          "lineCode": "MEO"
        },
        {
          "Brand": "Merrychef",
          "lineCode": "MER"
        },
        {
          "Brand": "Metabo HPT",
          "lineCode": "MET"
        },
        {
          "Brand": "Metabo Hpt",
          "lineCode": "HPT"
        },
        {
          "Brand": "Mi-t-m",
          "lineCode": "MIM"
        },
        {
          "Brand": "Miami Parts",
          "lineCode": "MIA"
        },
        {
          "Brand": "Microsoft",
          "lineCode": "MCS"
        },
        {
          "Brand": "Middleby",
          "lineCode": "MBY"
        },
        {
          "Brand": "Midea",
          "lineCode": "MID"
        },
        {
          "Brand": "Midland Metal",
          "lineCode": "MLM"
        },
        {
          "Brand": "Miele",
          "lineCode": "MIE"
        },
        {
          "Brand": "Milnor",
          "lineCode": "MNR"
        },
        {
          "Brand": "Milwaukee",
          "lineCode": "MIL"
        },
        {
          "Brand": "Minn Kota",
          "lineCode": "MKA"
        },
        {
          "Brand": "Miracle Remote",
          "lineCode": "MIR"
        },
        {
          "Brand": "Mirro",
          "lineCode": "MRO"
        },
        {
          "Brand": "Mitsubishi",
          "lineCode": "MIT"
        },
        {
          "Brand": "Mitsubishi Refurb",
          "lineCode": "MTR"
        },
        {
          "Brand": "Mk Diamond",
          "lineCode": "MKD"
        },
        {
          "Brand": "Moen",
          "lineCode": "MOE"
        },
        {
          "Brand": "Moffat",
          "lineCode": "MOF"
        },
        {
          "Brand": "Monessen",
          "lineCode": "MNN"
        },
        {
          "Brand": "Monogram",
          "lineCode": "HOT"
        },
        {
          "Brand": "Montague",
          "lineCode": "MNU"
        },
        {
          "Brand": "Motorola Refurb",
          "lineCode": "MRX"
        },
        {
          "Brand": "Motors & Armatures",
          "lineCode": "MAA"
        },
        {
          "Brand": "Moyer Diebel",
          "lineCode": "CMD"
        },
        {
          "Brand": "Mr Coffee",
          "lineCode": "MRF"
        },
        {
          "Brand": "Mr Heater",
          "lineCode": "MRH"
        },
        {
          "Brand": "MRCOOL",
          "lineCode": "MRC"
        },
        {
          "Brand": "MSI",
          "lineCode": "MSI"
        },
        {
          "Brand": "Mst",
          "lineCode": "MST"
        },
        {
          "Brand": "Mtx Speakers",
          "lineCode": "MTX"
        },
        {
          "Brand": "Muratec",
          "lineCode": "MUR"
        },
        {
          "Brand": "Murray",
          "lineCode": "BSM"
        },
        {
          "Brand": "Nady",
          "lineCode": "NAD"
        },
        {
          "Brand": "Napoleon",
          "lineCode": "NPL"
        },
        {
          "Brand": "NEC",
          "lineCode": "NEC"
        },
        {
          "Brand": "Nespresso",
          "lineCode": "NES"
        },
        {
          "Brand": "New Wave Sales",
          "lineCode": "NWS"
        },
        {
          "Brand": "Nexgrill",
          "lineCode": "NGL"
        },
        {
          "Brand": "Nextbook Usa",
          "lineCode": "NEX"
        },
        {
          "Brand": "Nexxtech",
          "lineCode": "NXX"
        },
        {
          "Brand": "Nieco",
          "lineCode": "NIE"
        },
        {
          "Brand": "Nikon",
          "lineCode": "NKN"
        },
        {
          "Brand": "Nordictrack",
          "lineCode": "NDT"
        },
        {
          "Brand": "Norelco",
          "lineCode": "NOR"
        },
        {
          "Brand": "Norelco",
          "lineCode": "NCR"
        },
        {
          "Brand": "NORLAKE",
          "lineCode": "NRK"
        },
        {
          "Brand": "Nortek",
          "lineCode": "NTK"
        },
        {
          "Brand": "NOT FOR RESALE",
          "lineCode": "HEM"
        },
        {
          "Brand": "Novatek",
          "lineCode": "NOV"
        },
        {
          "Brand": "Nte Electronics",
          "lineCode": "NTE"
        },
        {
          "Brand": "Nu-Vu",
          "lineCode": "NUV"
        },
        {
          "Brand": "Nukote",
          "lineCode": "NUK"
        },
        {
          "Brand": "Numerex",
          "lineCode": "NUM"
        },
        {
          "Brand": "Nuova Simonelli",
          "lineCode": "NUO"
        },
        {
          "Brand": "Nutone",
          "lineCode": "NUT"
        },
        {
          "Brand": "Oem Compatible",
          "lineCode": "HPA"
        },
        {
          "Brand": "Office Supplies",
          "lineCode": "OFC"
        },
        {
          "Brand": "Okidata Refurb",
          "lineCode": "OKR"
        },
        {
          "Brand": "Olevia",
          "lineCode": "OLE"
        },
        {
          "Brand": "Olympus",
          "lineCode": "OLY"
        },
        {
          "Brand": "Onkyo",
          "lineCode": "ONK"
        },
        {
          "Brand": "Opal Icemakers",
          "lineCode": "OPL"
        },
        {
          "Brand": "Optoma",
          "lineCode": "OPT"
        },
        {
          "Brand": "Oral-B",
          "lineCode": "ORB"
        },
        {
          "Brand": "Orbit",
          "lineCode": "OBT"
        },
        {
          "Brand": "Oreck",
          "lineCode": "ORE"
        },
        {
          "Brand": "Oregon",
          "lineCode": "ORG"
        },
        {
          "Brand": "Orion",
          "lineCode": "ORI"
        },
        {
          "Brand": "OSRAM",
          "lineCode": "OSR"
        },
        {
          "Brand": "Osram Neolux",
          "lineCode": "NEO"
        },
        {
          "Brand": "Oster",
          "lineCode": "OST"
        },
        {
          "Brand": "Packaging",
          "lineCode": "PKG"
        },
        {
          "Brand": "Packard Inc",
          "lineCode": "PAK"
        },
        {
          "Brand": "Panasonic",
          "lineCode": "MSC"
        },
        {
          "Brand": "Panasonic Refurb",
          "lineCode": "MSR"
        },
        {
          "Brand": "Panduit",
          "lineCode": "PDT"
        },
        {
          "Brand": "Patio Comfort",
          "lineCode": "PAT"
        },
        {
          "Brand": "Peerless Premier",
          "lineCode": "PPA"
        },
        {
          "Brand": "Peg Perego",
          "lineCode": "PEG"
        },
        {
          "Brand": "Penn",
          "lineCode": "PEN"
        },
        {
          "Brand": "Pentair",
          "lineCode": "PTR"
        },
        {
          "Brand": "Perlick",
          "lineCode": "PLC"
        },
        {
          "Brand": "Petra",
          "lineCode": "PTA"
        },
        {
          "Brand": "Pflueger",
          "lineCode": "PFL"
        },
        {
          "Brand": "Pgs Grill",
          "lineCode": "PGS"
        },
        {
          "Brand": "Philco",
          "lineCode": "FRI"
        },
        {
          "Brand": "Philips",
          "lineCode": "PNF"
        },
        {
          "Brand": "Philips",
          "lineCode": "PCL"
        },
        {
          "Brand": "Philips",
          "lineCode": "NAP"
        },
        {
          "Brand": "PHILIPS GARMENT CARE",
          "lineCode": "PGC"
        },
        {
          "Brand": "Philips Health Solut",
          "lineCode": "PHS"
        },
        {
          "Brand": "Philips Healthy Cook",
          "lineCode": "PHC"
        },
        {
          "Brand": "Philips Hospitality",
          "lineCode": "PBS"
        },
        {
          "Brand": "Philips Lighting",
          "lineCode": "PHL"
        },
        {
          "Brand": "Philips Pet Care",
          "lineCode": "PPC"
        },
        {
          "Brand": "Philips Product",
          "lineCode": "PAF"
        },
        {
          "Brand": "Philips Purifiers",
          "lineCode": "PPH"
        },
        {
          "Brand": "Philmore",
          "lineCode": "PHI"
        },
        {
          "Brand": "Phoenix Lamp",
          "lineCode": "PHX"
        },
        {
          "Brand": "Pinnacle Sales",
          "lineCode": "PIN"
        },
        {
          "Brand": "Pioneer",
          "lineCode": "PIO"
        },
        {
          "Brand": "Pitco",
          "lineCode": "PIT"
        },
        {
          "Brand": "Plasmair",
          "lineCode": "PLA"
        },
        {
          "Brand": "Polk",
          "lineCode": "PLK"
        },
        {
          "Brand": "Polti Refurbished",
          "lineCode": "POR"
        },
        {
          "Brand": "Porter Cable",
          "lineCode": "PTC"
        },
        {
          "Brand": "Poulan",
          "lineCode": "POU"
        },
        {
          "Brand": "Power Cords",
          "lineCode": "WEB"
        },
        {
          "Brand": "Power Soak Systems",
          "lineCode": "PSS"
        },
        {
          "Brand": "Power Wheels",
          "lineCode": "PWS"
        },
        {
          "Brand": "Powermate",
          "lineCode": "PWM"
        },
        {
          "Brand": "Powermatic",
          "lineCode": "PMT"
        },
        {
          "Brand": "Powersonic",
          "lineCode": "POW"
        },
        {
          "Brand": "Premier Range Co.",
          "lineCode": "PER"
        },
        {
          "Brand": "Presto",
          "lineCode": "PRE"
        },
        {
          "Brand": "Prima Worldwide",
          "lineCode": "PWW"
        },
        {
          "Brand": "Primo",
          "lineCode": "PMO"
        },
        {
          "Brand": "Prince Castle",
          "lineCode": "PRI"
        },
        {
          "Brand": "Pro Temp",
          "lineCode": "PRP"
        },
        {
          "Brand": "Proctor Silex",
          "lineCode": "PSX"
        },
        {
          "Brand": "Proform",
          "lineCode": "PRF"
        },
        {
          "Brand": "Proscan",
          "lineCode": "PCN"
        },
        {
          "Brand": "Protective Coating",
          "lineCode": "PRT"
        },
        {
          "Brand": "Proview",
          "lineCode": "PRV"
        },
        {
          "Brand": "Pts Modules",
          "lineCode": "PTS"
        },
        {
          "Brand": "QST",
          "lineCode": "QST"
        },
        {
          "Brand": "Quam",
          "lineCode": "QUA"
        },
        {
          "Brand": "Quantum View",
          "lineCode": "QTM"
        },
        {
          "Brand": "Rain Bird",
          "lineCode": "RAI"
        },
        {
          "Brand": "Randell",
          "lineCode": "RAN"
        },
        {
          "Brand": "Rational",
          "lineCode": "RAT"
        },
        {
          "Brand": "Raypak",
          "lineCode": "RAY"
        },
        {
          "Brand": "Razor",
          "lineCode": "RAZ"
        },
        {
          "Brand": "RCA",
          "lineCode": "RCA"
        },
        {
          "Brand": "Rechargeable Battery",
          "lineCode": "USP"
        },
        {
          "Brand": "Rectorseal",
          "lineCode": "REC"
        },
        {
          "Brand": "Redmax",
          "lineCode": "RED"
        },
        {
          "Brand": "Remington",
          "lineCode": "REM"
        },
        {
          "Brand": "Replacement Transist",
          "lineCode": "REP"
        },
        {
          "Brand": "Reznor",
          "lineCode": "REZ"
        },
        {
          "Brand": "Rheem",
          "lineCode": "RHE"
        },
        {
          "Brand": "Ricoh Refurbished",
          "lineCode": "RCX"
        },
        {
          "Brand": "Ridgid",
          "lineCode": "RID"
        },
        {
          "Brand": "Rikon",
          "lineCode": "RIK"
        },
        {
          "Brand": "Ritchie Engineering",
          "lineCode": "RIE"
        },
        {
          "Brand": "Rite Off",
          "lineCode": "RIT"
        },
        {
          "Brand": "Robertshaw",
          "lineCode": "ROB"
        },
        {
          "Brand": "Robinair Divison",
          "lineCode": "ROD"
        },
        {
          "Brand": "Robot Coupe",
          "lineCode": "RCE"
        },
        {
          "Brand": "Rockwell",
          "lineCode": "ROC"
        },
        {
          "Brand": "Rolair",
          "lineCode": "ROL"
        },
        {
          "Brand": "Rotozip",
          "lineCode": "RTZ"
        },
        {
          "Brand": "Rowenta",
          "lineCode": "ROW"
        },
        {
          "Brand": "Royal",
          "lineCode": "ROY"
        },
        {
          "Brand": "Runco",
          "lineCode": "RUN"
        },
        {
          "Brand": "Ruud",
          "lineCode": "RUU"
        },
        {
          "Brand": "Ryobi",
          "lineCode": "TTI"
        },
        {
          "Brand": "Saeco",
          "lineCode": "SAE"
        },
        {
          "Brand": "Salvajor",
          "lineCode": "SAL"
        },
        {
          "Brand": "Samsung",
          "lineCode": "SMG"
        },
        {
          "Brand": "Sanitaire",
          "lineCode": "SAN"
        },
        {
          "Brand": "Sanyo",
          "lineCode": "SFS"
        },
        {
          "Brand": "Schaerer",
          "lineCode": "SCH"
        },
        {
          "Brand": "Scopes & Power Supp.",
          "lineCode": "KWD"
        },
        {
          "Brand": "Scotsman",
          "lineCode": "SCO"
        },
        {
          "Brand": "Sears Commerical",
          "lineCode": "SEA"
        },
        {
          "Brand": "SEB",
          "lineCode": "SEB"
        },
        {
          "Brand": "Senco",
          "lineCode": "SNC"
        },
        {
          "Brand": "Senseo",
          "lineCode": "SEN"
        },
        {
          "Brand": "Sensible Products",
          "lineCode": "SEP"
        },
        {
          "Brand": "Server",
          "lineCode": "SER"
        },
        {
          "Brand": "Shakespeare",
          "lineCode": "SHK"
        },
        {
          "Brand": "Shark",
          "lineCode": "SRK"
        },
        {
          "Brand": "Sharp",
          "lineCode": "SHA"
        },
        {
          "Brand": "Shimano",
          "lineCode": "SHM"
        },
        {
          "Brand": "Shindaiwa",
          "lineCode": "SHI"
        },
        {
          "Brand": "Shopvac",
          "lineCode": "SHO"
        },
        {
          "Brand": "Sierra",
          "lineCode": "SIE"
        },
        {
          "Brand": "Sigmac Usa",
          "lineCode": "SGM"
        },
        {
          "Brand": "Silhouette",
          "lineCode": "SIL"
        },
        {
          "Brand": "Silver King",
          "lineCode": "SVK"
        },
        {
          "Brand": "Simer",
          "lineCode": "SME"
        },
        {
          "Brand": "Simplicity",
          "lineCode": "SIM"
        },
        {
          "Brand": "Skil",
          "lineCode": "SKI"
        },
        {
          "Brand": "Skuttle",
          "lineCode": "SKU"
        },
        {
          "Brand": "Small Appliance Product",
          "lineCode": "GEA"
        },
        {
          "Brand": "SMART TECHNOLOGIES",
          "lineCode": "SMT"
        },
        {
          "Brand": "Smeg",
          "lineCode": "SGG"
        },
        {
          "Brand": "Smudgetip",
          "lineCode": "SMD"
        },
        {
          "Brand": "Snapper",
          "lineCode": "SNA"
        },
        {
          "Brand": "Sonicare",
          "lineCode": "SCR"
        },
        {
          "Brand": "Sony",
          "lineCode": "SON"
        },
        {
          "Brand": "Soundlier",
          "lineCode": "SOU"
        },
        {
          "Brand": "Southbend",
          "lineCode": "SBD"
        },
        {
          "Brand": "Southbend Range",
          "lineCode": "SOR"
        },
        {
          "Brand": "Southland",
          "lineCode": "SLD"
        },
        {
          "Brand": "Soyo Refurbished",
          "lineCode": "SYR"
        },
        {
          "Brand": "Spaceman",
          "lineCode": "SMU"
        },
        {
          "Brand": "Spectrum",
          "lineCode": "SPE"
        },
        {
          "Brand": "Spectrum Refurbished",
          "lineCode": "SPR"
        },
        {
          "Brand": "Speed Queen",
          "lineCode": "Fa"
        },
        {
          "Brand": "Spraytech",
          "lineCode": "SPT"
        },
        {
          "Brand": "SRC Refrigeration",
          "lineCode": "SRC"
        },
        {
          "Brand": "Stanco",
          "lineCode": "STC"
        },
        {
          "Brand": "Stanley",
          "lineCode": "SLY"
        },
        {
          "Brand": "Star",
          "lineCode": "STA"
        },
        {
          "Brand": "Star Trac",
          "lineCode": "STR"
        },
        {
          "Brand": "Starlogic Refurbish",
          "lineCode": "STL"
        },
        {
          "Brand": "Sterling",
          "lineCode": "STE"
        },
        {
          "Brand": "Stero Dishwasher",
          "lineCode": "STD"
        },
        {
          "Brand": "Stevens Appliance Tr",
          "lineCode": "SAT"
        },
        {
          "Brand": "Stoelting",
          "lineCode": "STO"
        },
        {
          "Brand": "structural Concepts",
          "lineCode": "SCS"
        },
        {
          "Brand": "Sub-Zero",
          "lineCode": "SUB"
        },
        {
          "Brand": "Subaru / Robin",
          "lineCode": "SRN"
        },
        {
          "Brand": "Summit Brands",
          "lineCode": "SUM"
        },
        {
          "Brand": "Sun-stream",
          "lineCode": "SST"
        },
        {
          "Brand": "Sunbeam",
          "lineCode": "SUN"
        },
        {
          "Brand": "Sunglo",
          "lineCode": "SGO"
        },
        {
          "Brand": "Sunheat",
          "lineCode": "SHT"
        },
        {
          "Brand": "Sunpak",
          "lineCode": "SPK"
        },
        {
          "Brand": "Supplies",
          "lineCode": "SUP"
        },
        {
          "Brand": "Sure Flame",
          "lineCode": "SUR"
        },
        {
          "Brand": "SVA",
          "lineCode": "SVA"
        },
        {
          "Brand": "Switchcraft",
          "lineCode": "SWI"
        },
        {
          "Brand": "Sylvania",
          "lineCode": "SYL"
        },
        {
          "Brand": "Systemax",
          "lineCode": "STM"
        },
        {
          "Brand": "T-fal",
          "lineCode": "T-F"
        },
        {
          "Brand": "Tanaka",
          "lineCode": "TAN"
        },
        {
          "Brand": "Tappan",
          "lineCode": "FRI"
        },
        {
          "Brand": "Tce Technical",
          "lineCode": "RCL"
        },
        {
          "Brand": "TCL",
          "lineCode": "TCL"
        },
        {
          "Brand": "Tech Spray",
          "lineCode": "TEC"
        },
        {
          "Brand": "Tecumseh",
          "lineCode": "TSH"
        },
        {
          "Brand": "Tektronix",
          "lineCode": "TKX"
        },
        {
          "Brand": "Tempur-pedic",
          "lineCode": "TMP"
        },
        {
          "Brand": "Test Equipment",
          "lineCode": "VEL"
        },
        {
          "Brand": "Test Parts",
          "lineCode": "TST"
        },
        {
          "Brand": "The Good Clean",
          "lineCode": "TGC"
        },
        {
          "Brand": "Thermador",
          "lineCode": "BCH"
        },
        {
          "Brand": "Thermofluid Tech",
          "lineCode": "THT"
        },
        {
          "Brand": "Thor",
          "lineCode": "THO"
        },
        {
          "Brand": "Tile",
          "lineCode": "ESI"
        },
        {
          "Brand": "Titan",
          "lineCode": "TIT"
        },
        {
          "Brand": "Titan Tankless Water",
          "lineCode": "TTW"
        },
        {
          "Brand": "TNT",
          "lineCode": "TNT"
        },
        {
          "Brand": "Tom Tom",
          "lineCode": "TMT"
        },
        {
          "Brand": "Tools",
          "lineCode": "PAC"
        },
        {
          "Brand": "Toro",
          "lineCode": "TOR"
        },
        {
          "Brand": "Toshiba",
          "lineCode": "TBA"
        },
        {
          "Brand": "Toshiba Computer",
          "lineCode": "TOS"
        },
        {
          "Brand": "Tradepro",
          "lineCode": "TRA"
        },
        {
          "Brand": "Trane",
          "lineCode": "TRN"
        },
        {
          "Brand": "Traulsen",
          "lineCode": "TSN"
        },
        {
          "Brand": "Tri-state Module",
          "lineCode": "TSM"
        },
        {
          "Brand": "Tripp-lite",
          "lineCode": "TRI"
        },
        {
          "Brand": "Troy Bilt",
          "lineCode": "MTD"
        },
        {
          "Brand": "Turbo Air",
          "lineCode": "TUA"
        },
        {
          "Brand": "Turbochef",
          "lineCode": "BMC"
        },
        {
          "Brand": "Twin Eagles",
          "lineCode": "TWI"
        },
        {
          "Brand": "U-line",
          "lineCode": "ULN"
        },
        {
          "Brand": "UltraFryer",
          "lineCode": "ULT"
        },
        {
          "Brand": "Unic",
          "lineCode": "UIC"
        },
        {
          "Brand": "Universal Ent",
          "lineCode": "ULE"
        },
        {
          "Brand": "Uniweld",
          "lineCode": "UNI"
        },
        {
          "Brand": "Unox",
          "lineCode": "UNO"
        },
        {
          "Brand": "Us Stove Company",
          "lineCode": "USS"
        },
        {
          "Brand": "Usd Products",
          "lineCode": "USD"
        },
        {
          "Brand": "V7e Elect. Refurbish",
          "lineCode": "VSR"
        },
        {
          "Brand": "Vanco",
          "lineCode": "VAN"
        },
        {
          "Brand": "Vapco Products",
          "lineCode": "VAP"
        },
        {
          "Brand": "Vent-a-hood",
          "lineCode": "VEN"
        },
        {
          "Brand": "Verge",
          "lineCode": "VRG"
        },
        {
          "Brand": "Vermont",
          "lineCode": "VER"
        },
        {
          "Brand": "Victory",
          "lineCode": "VIC"
        },
        {
          "Brand": "VIDEO GAMING",
          "lineCode": "VGA"
        },
        {
          "Brand": "Video Mount Products",
          "lineCode": "VMP"
        },
        {
          "Brand": "Viewsonic Refurb",
          "lineCode": "VWS"
        },
        {
          "Brand": "Viking",
          "lineCode": "VIK"
        },
        {
          "Brand": "Viore",
          "lineCode": "VIO"
        },
        {
          "Brand": "Virginia Air",
          "lineCode": "VIR"
        },
        {
          "Brand": "Vision Fitness",
          "lineCode": "VIS"
        },
        {
          "Brand": "Vivitek",
          "lineCode": "VIV"
        },
        {
          "Brand": "VIZIO",
          "lineCode": "VIZ"
        },
        {
          "Brand": "VIZIO-FOXCONN",
          "lineCode": "FOX"
        },
        {
          "Brand": "VIZIO-TPV",
          "lineCode": "TPV"
        },
        {
          "Brand": "VIZIO-WISTRON",
          "lineCode": "WIS"
        },
        {
          "Brand": "Vizparts",
          "lineCode": "VZP"
        },
        {
          "Brand": "Vollrath",
          "lineCode": "VLH"
        },
        {
          "Brand": "Vulcan",
          "lineCode": "VUL"
        },
        {
          "Brand": "Wagner",
          "lineCode": "WAG"
        },
        {
          "Brand": "Walbro",
          "lineCode": "WAL"
        },
        {
          "Brand": "Walker & Sons",
          "lineCode": "WLK"
        },
        {
          "Brand": "Waring",
          "lineCode": "WAR"
        },
        {
          "Brand": "Wearever",
          "lineCode": "WVR"
        },
        {
          "Brand": "Weather Guard",
          "lineCode": "WEA"
        },
        {
          "Brand": "Weber",
          "lineCode": "WBR"
        },
        {
          "Brand": "Weed Eater",
          "lineCode": "WEE"
        },
        {
          "Brand": "Wells",
          "lineCode": "WEL"
        },
        {
          "Brand": "Weslo",
          "lineCode": "WSL"
        },
        {
          "Brand": "West Penn",
          "lineCode": "WES"
        },
        {
          "Brand": "Western Dig. Refurb",
          "lineCode": "WDR"
        },
        {
          "Brand": "Westinghouse",
          "lineCode": "WDE"
        },
        {
          "Brand": "Whirlpool",
          "lineCode": "WHI"
        },
        {
          "Brand": "White Mountain",
          "lineCode": "WMN"
        },
        {
          "Brand": "White-rodgers",
          "lineCode": "WHR"
        },
        {
          "Brand": "White-Westinghouse",
          "lineCode": "FRI"
        },
        {
          "Brand": "Wii Nintendo",
          "lineCode": "WII"
        },
        {
          "Brand": "Wilbur Curtis",
          "lineCode": "WIC"
        },
        {
          "Brand": "Wilton",
          "lineCode": "WIL"
        },
        {
          "Brand": "Winco",
          "lineCode": "WCO"
        },
        {
          "Brand": "Winegard",
          "lineCode": "WIN"
        },
        {
          "Brand": "Winston",
          "lineCode": "WST"
        },
        {
          "Brand": "Wolf Appliacen",
          "lineCode": "WOL"
        },
        {
          "Brand": "Wood Finishing",
          "lineCode": "WFS"
        },
        {
          "Brand": "Wood Stone",
          "lineCode": "WOO"
        },
        {
          "Brand": "Worx",
          "lineCode": "WOR"
        },
        {
          "Brand": "X2gen Refurbished",
          "lineCode": "XTG"
        },
        {
          "Brand": "Xantus Products",
          "lineCode": "XAN"
        },
        {
          "Brand": "Xfmrs & Solenoids",
          "lineCode": "STN"
        },
        {
          "Brand": "Yamaha",
          "lineCode": "YAM"
        },
        {
          "Brand": "Yard Man",
          "lineCode": "YAR"
        },
        {
          "Brand": "Yc",
          "lineCode": "YCX"
        },
        {
          "Brand": "Yeats Dolly",
          "lineCode": "YEA"
        },
        {
          "Brand": "York",
          "lineCode": "YOR"
        },
        {
          "Brand": "Yummly",
          "lineCode": "WHI"
        },
        {
          "Brand": "Zama",
          "lineCode": "ZAM"
        },
        {
          "Brand": "Zebra",
          "lineCode": "ZEB"
        },
        {
          "Brand": "Zephyr",
          "lineCode": "ZEP"
        },
        {
          "Brand": "Zodiac",
          "lineCode": "ZOD"
        }
      ];            
    // console.log("Brand_json",Brand_json)
    
     var brandName = item.vendor;
      const formatString = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      const matchingBrand = Brand_json.find(item => formatString(item.Brand) === formatString(brandName));
    // console.log("matchingBrand",matchingBrand.lineCode)

let imageUrl;

if (matchingBrand && algoliaShopify.helpers.compactImage(item) === 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif') {
  imageUrl = `https://encompass-11307.kxcdn.com/imageDisplay?mfgCode=${matchingBrand.lineCode}&type=b&size=s`;
} else {
  imageUrl = algoliaShopify.helpers.compactImage(item);
}

// console.log("matchingBrand lineCode: imageUrl", imageUrl);


    
//    const brandCode = item.barcode.replace(item.sku, '');

// console.log("Item Barcode without SKU:", brandCode);
// console.log("Item SKU:", item.sku);
    // console.log("Item price:", item.price, typeof item.price);

    // console.log("Item item.product_type:", item);

    // let priceHtml = '';

// if (item.product_type == 'Model') {
//   console.log("Item price Model:");
//   priceHtml = '';
// } else if (item.product_type == 'Part' && item.price == 0) {
//   console.log("Item price part:");
//   priceHtml = '<button class="contact-support-btn">Contact Support</button>';
// }else if (item.product_type == 'Part' && item.price != 0) {
//   console.log("Item price 1 part:");
//   priceHtml = algoliaShopify.helpers.displayPrice(item, distinct);
// } else {
//   console.log("Item price else:");
//   priceHtml = algoliaShopify.helpers.displayPrice(item, distinct);
// }
    // console.log("priceHtml",priceHtml)
const inputValue = document.querySelector('.aa-Input')?.value?.trim();
    // console.log("inputValue",inputValue,"item.sku",item.title)

      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem q"
      onClick="${(event) => handleItemClick(event, item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemContentBrand 2">
           ${
              item.product_type &&
              (
                item.product_type === "Part with model" ||
                item.product_type === "Part with Model" ||
                item.product_type === "NLA"
              )
                ? "Part"
                : components.Highlight({ hit: item, attribute: "product_type" })
            }
          </div>
        <div class="aa-ItemPicture aa-ItemPicture--loaded" atrr="${ item.product_type}">
       <img
          src="${imageUrl}"
          alt="${item.title}"
        />
        ${
            item.sku?.replace(/[-_]/g, '').trim().toLowerCase() === inputValue?.replace(/[-_]/g, '').trim().toLowerCase()
              ? html`<img
                  src="https://cdn.shopify.com/s/files/1/0700/0293/3937/files/exact-match.svg?v=1750412494"
                  alt="Exact Match"
                  class="exact-match-logo"
                />`
              : ''
          }

        </div>
        <div class="aa-ItemContentBody">
        
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
            <div class="aa-ItemContentSku" >${item.sku}</div>
          </div>
         <div class="aa-ItemContentPrice">
  <div class="aa-ItemContentPriceCurrent" price="${item.price}">
    ${item.product_type === "Model"
      ? ''
      : item.product_type === "Part"
        ? (item.price === 0
            ? html`<a class="contact-support-btn">View Detail</a>`
            : algoliaShopify.helpers.displayPrice(item, distinct))
        : algoliaShopify.helpers.displayPrice(item, distinct)}
  </div>
</div>


        </div>
      </div>
    </a>
  `;
    } );

 algoliaShopify.hooks.registerHook('beforeAutocompleteCollectionsTemplate', function(_defaultTemplate, templateOptions, itemLink) {
    const { html, item, components } = templateOptions;
    
    // let brandImage = '';
    // if (item.template_suffix == 'Brand') {
    //     console.log("brand image");
    //     brandImage = '<img src="https://cdn.shopify.com/s/files/1/0638/4887/4142/files/brand-image.png?v=1726144867">';
    // }

return html`
  <a href="${itemLink}" class="aa-ItemLink">
    <div class="aa-ItemWrapper 2">
      <div class="aa-ItemContent">
        <div class="aa-ItemIcon aa-ItemIcon--noBorder">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
            />
          </svg>
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentTitle">
            ${components.Highlight({ hit: item, attribute: 'title' })}
          </div><span class="collectionBrnd" >
          ${item.template_suffix == 'Brand' ? 'Brand' : ''}
          </span>
        </div>
      </div>
    </div>
  </a>
`;


});

document.addEventListener("algolia.hooks.initialize", () => {
	algoliaShopify.hooks.registerHook(
		"beforeAutocompleteConfigurationOptions",
		(config, context) => {
			if (context.sourceId === "products") {
				config.queries = config.queries.map((query) => ({
					...query,
					params: {
						...query.params,
						analyticsTags: ["autocomplete", "products", "v2"],
					},
				}));
			}
			return config;
		},
	);
});
  
// document.addEventListener('algolia.hooks.initialize', function() {
  // algoliaShopify.hooks.registerHook('beforeInstantSearchFacetItemTemplate', function(_defaultTemplate, item, html) {
  //   console.log("item",item,"html",html)
  //   return html`
  //     <label class="${item.cssClasses.label}">
  //       ${item.type === 'disjunctive' &&
  //         (item.isRefined
  //           ? html`
  //               <input
  //                 type="checkbox"
  //                 class="${item.cssClasses.checkbox}"
  //                 checked
  //               />
  //             `
  //           : html`
  //               <input type="checkbox" class="${item.cssClasses.checkbox}" />
  //             `)}
  //       ${item.label}
  //       <span class="${item.cssClasses.count}">
  //         ${algoliaShopify.helpers.formatNumber(item.count)}
  //       </span>
  //     </label>
  //   `;
  // });
// });



  

  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    console.log("html>>>>beforeInstantSearchMainTemplate",html)



    var storefrontAccessTokenHome = 'ad652a74eb9b4c8cc3d7c521feaa9e06';

let currentURL = window.location.href;
let urlObj = new URL(currentURL);
// console.log("urlObj", urlObj);
let path = urlObj.pathname;
// console.log("path", path);
let segments = path.split('/');
let brandName = '';
    let dataBrandHandle = '';
    let dataColHandle = '';
    
let collectionsIndex = segments.indexOf('collections');
// console.log("collectionsIndex", collectionsIndex);


    if (collectionsIndex !== -1 && segments[collectionsIndex + 1]) {
  brandName = segments[collectionsIndex + 1].toLowerCase();
  // console.log("brandName", brandName);
     dataBrandHandle = $('.Brand_title').data('brand-handle'); // Preferred if you're using jQuery's .data()
       dataColHandle = $('.Brand_title_collect').data('col-handle'); // Preferred if you're using jQuery's .data()
      // console.log("dataBrandHandle", dataBrandHandle);
      // console.log("dataColHandle", dataColHandle);

  getProDetails();
}
                          
  async function getProDetails() {
     let allProducts = [];
    let partss = [];
    let vendor_name = '';
    let collection_name = '';
    var ModelCounter = 0;
    // console.log("inside api brandName", brandName);
//     let split_brandname = brandName.split("-").slice(1).join("-");
// console.log("split_brandname", split_brandname);
    // console.log(typeof dataColHandle)
    if (typeof dataColHandle === "string") {
 partss = dataColHandle.split("-");

   vendor_name = partss.length > 1 ? partss[0] : "";  // Only if hyphen exists
   collection_name = partss.length > 1 ? partss.slice(1).join("-") : dataColHandle; // If no hyphen, use full value as collection_name
    }

// console.log("vendor_name:", vendor_name);
// console.log("collection_name:", collection_name);

     // Decide query string
  let queryFilter = "";
  // if (dataBrandHandle) {
  //   queryFilter = `vendor:"${dataBrandHandle}" AND product_type:Model`;
  // } else if (vendor_name && collection_name) {
  //   queryFilter = `vendor:"${vendor_name}" AND tag:'subcate:${collection_name}' AND product_type:Model`;
  // } else if (collection_name) {
  //   queryFilter = `tag:'subcate:${collection_name}' AND product_type:Model`;
  // } else {
  //   console.warn("Insufficient information to construct a valid filter query.");
  //   return;
  // }
    
if (dataBrandHandle) {
  queryFilter = `vendor:\\"${dataBrandHandle}\\" AND product_type:Model`;
} else if (vendor_name && collection_name) {
  queryFilter = `vendor:\\"${vendor_name}\\" AND tag:'subcate:${collection_name}' AND product_type:Model`;
} else if (collection_name) {
  queryFilter = `tag:'subcate:${collection_name}' AND product_type:Model`;
}

  // console.log("queryFilter", queryFilter);
    
    const response = await fetch("https://grp-site.myshopify.com/api/2023-04/graphql.json", {
    method: 'POST',
      headers: {
         'Content-Type': 'application/json',
         'X-Shopify-Storefront-Access-Token': storefrontAccessTokenHome,
        },
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      body: JSON.stringify({
     query: `{
         products(first: 20, query: "${queryFilter}") {
         nodes {
               handle
               title
               vendor
               productType
               variants(first: 250) {
                  nodes {
                       sku
                     }
                }
          }
       } 
   }`,
}),
});
                              
const result = await response.json();
// console.log("result for find parts", result);

    const product_brand = result?.data?.products || [];
// console.log("product_brand", product_brand);

    if(product_brand == '' || product_brand == "undefined" ){
      $('.collection-Section').hide();
    }

    // var product_brand = result.data.collectionByHandle.products;

if (!product_brand || !product_brand.nodes || product_brand.nodes.length === 0) {
    var collectionSection = document.querySelector('.collection-Section-div');
    if (collectionSection) {
        collectionSection.style.display = 'none';
    }
}else{

 product_brand.nodes.forEach((product) => {
var currentUrl = window.location.href;
var updatedUrl = null;

if (currentUrl.includes("/collections/")) {
  var baseUrl = currentUrl.split("/collections/")[0];
  var parts = currentUrl.split("/collections/")[1]?.split("/");
  var handleFromUrl = parts && parts.length > 1 ? parts[1] : "";
// console.log("handleFromUrl", handleFromUrl);
  if (handleFromUrl) {
    updatedUrl = `${baseUrl}/products/${handleFromUrl}`;
    window.location.href = updatedUrl; // Optional redirect
  }
}

// product_brand.nodes.forEach((product) => {
  const vendor = product.vendor;
  const handle = product.handle;
  const variants = product.variants;
  const sku = variants ? variants.nodes[0].sku : "";
  const productType = product.productType;
  // console.log("all info", vendor, handle, variants, sku, productType);

  if (productType && productType.toLowerCase() === "model") {
    // Use updatedUrl if available, otherwise fallback to /products/<handle>
    const linkUrl = updatedUrl ? updatedUrl : `/products/${handle}`;

    const brandhtml = `<div class="productLi">                  
                         <a href="${linkUrl}">
                           <div class="product-detail">
                             <h4 class="brtsku">${sku}</h4>
                           </div>
                         </a>
                       </div>`;

    $(".collection-Section-div").append(brandhtml);
    ModelCounter++;

     // Update the "View All Models" link with the brand name
    let moreModelLink = document.querySelector('.more_model');
    let brand = dataBrandHandle || vendor_name;
    if( brand && collection_name ){
      moreModelLink.href = `https://grp-site.myshopify.com/pages/models?brand=${brand}&category=${collection_name}`;
    }
    else if(brand) {
      moreModelLink.href = `https://grp-site.myshopify.com/pages/models?brand=${brand}`;
    } else if(collection_name){
      moreModelLink.href = `https://grp-site.myshopify.com/pages/models?category=${collection_name}`;
    }else{
       moreModelLink.href = ``;
    }
  }
// });

});
    
   
}    
    // console.log("ModelCounter",ModelCounter)
 if(ModelCounter <= 0){
      // console.log("if condition")
      $('.collection-Section').hide();
    }else{
      // console.log("else condition")
      $('.collection-Section').show();
    }
  }

      // console.log("Custom Algolia logic running...");



    
    return html`
      <div class="ais-page">
        <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
        
        <div class="ais-facets-button">
          Show filters
        </div>
        <div class="ais-facets">
              <div class="Product_type_check">
                      <label id="All" onclick="relocate('All')" class="all-btn-custom custom-filter-button ais-RefinementList-label ais-facet--label">All </label>
                      <label id="Part" onclick="relocate('Part')" class="part-btn-custom custom-filter-button ais-RefinementList-label ais-facet--label">Parts</label>
                      <label id="Model" onclick="relocate('Model')" class="model-btn-custom custom-filter-button ais-RefinementList-label ais-facet--label">Models</label>
              </div>
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
            facet =>
              html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header active"
                    >${facet.title}</label
                  >
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
          )}
          <div class="collection-Section" > <p class="col-model_section">${brandTitle} Model</p> <div class="collection-Section-div" ></div> <p class="view_model_button"><a class="more_model" href="" style="color: white !important; font-weight: 700 !important; font-size: 17px !important; margin-top: 10px;">View All Models</a></p></div>
        </div>
        
        <div class="ais-block">
        <div class="main_search test" >
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        </div>
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container 22"></div>
      </div>
    `;

    
  });

algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
  //  console.log("hit",hit)

  // if (hit.sku === "") {
  //   return ''; // Hides the product by not rendering any HTML
  // }

  // this code (hide->part-with-model)
    // if (item.product_type !== 'part-with-model') {
    //   return ''; // Skip rendering
    // }
  // this code (hide->part-with-model)
  
  // console.log("html",html)
      // console.log("components rrrr>>>>> beforeInstantSearchProductTemplate",components)
    const typecomponents = components.Highlight({ attribute: 'product_type', hit })
    const isModel = typecomponents.props.parts[0][0].value === "Model";
    // const spantag = `<span>Contact support</span>`;
    // console.log("isModel",isModel)
    // console.log("_defaultTemplate",_defaultTemplate)

     var Brand_json_instant = [
        {
          "Brand": "3M Filtrete Products",
          "lineCode": "MMM"
        },
        {
          "Brand": "Abu Garcia",
          "lineCode": "ABU"
        },
        {
          "Brand": "Accu Sharp",
          "lineCode": "ACU"
        },
        {
          "Brand": "Accutemp",
          "lineCode": "ATP"
        },
        {
          "Brand": "Acer",
          "lineCode": "ACR"
        },
        {
          "Brand": "Acer Refurb",
          "lineCode": "ACX"
        },
        {
          "Brand": "Acp",
          "lineCode": "ACP"
        },
        {
          "Brand": "Acros",
          "lineCode": "WHI"
        },
        {
          "Brand": "AeonAir",
          "lineCode": "ANR"
        },
        {
          "Brand": "Affresh",
          "lineCode": "WHI"
        },
        {
          "Brand": "Aga Marvel",
          "lineCode": "AGA"
        },
        {
          "Brand": "Aiphone",
          "lineCode": "AIP"
        },
        {
          "Brand": "Air King",
          "lineCode": "ARK"
        },
        {
          "Brand": "Airmaster",
          "lineCode": "AMT"
        },
        {
          "Brand": "AIRSLED",
          "lineCode": "AIR"
        },
        {
          "Brand": "Airtouch",
          "lineCode": "ACE"
        },
        {
          "Brand": "Aiwa",
          "lineCode": "AIW"
        },
        {
          "Brand": "Akai",
          "lineCode": "AKI"
        },
        {
          "Brand": "All Filters",
          "lineCode": "ACF"
        },
        {
          "Brand": "Alpha",
          "lineCode": "ALH"
        },
        {
          "Brand": "Alpine",
          "lineCode": "ALP"
        },
        {
          "Brand": "Alto Shaam",
          "lineCode": "ATL"
        },
        {
          "Brand": "Amana",
          "lineCode": "WHI"
        },
        {
          "Brand": "Amana Commerical",
          "lineCode": "AMA"
        },
        {
          "Brand": "Amana Menumaster",
          "lineCode": "AMR"
        },
        {
          "Brand": "Amana Ptac",
          "lineCode": "AMN"
        },
        {
          "Brand": "American Hakko",
          "lineCode": "HAK"
        },
        {
          "Brand": "American Metal Filte",
          "lineCode": "AMF"
        },
        {
          "Brand": "American Range",
          "lineCode": "ARE"
        },
        {
          "Brand": "American Standard",
          "lineCode": "AMS"
        },
        {
          "Brand": "Anderic",
          "lineCode": "NPS"
        },
        {
          "Brand": "Andis",
          "lineCode": "AND"
        },
        {
          "Brand": "Anets",
          "lineCode": "ANE"
        },
        {
          "Brand": "ANTUNES",
          "lineCode": "ANT"
        },
        {
          "Brand": "Aoc/epi",
          "lineCode": "AOC"
        },
        {
          "Brand": "Apex",
          "lineCode": "APX"
        },
        {
          "Brand": "Apple",
          "lineCode": "APL"
        },
        {
          "Brand": "Apple Replacement",
          "lineCode": "APA"
        },
        {
          "Brand": "APPLI PARTS",
          "lineCode": "GAL"
        },
        {
          "Brand": "Appliance Parts",
          "lineCode": "KIT"
        },
        {
          "Brand": "Appliance Parts",
          "lineCode": "ERP"
        },
        {
          "Brand": "APW Wyott",
          "lineCode": "AWT"
        },
        {
          "Brand": "Apw Wyott",
          "lineCode": "APW"
        },
        {
          "Brand": "Arclyte Technologies",
          "lineCode": "ARC"
        },
        {
          "Brand": "Arctic Air C",
          "lineCode": "AAC"
        },
        {
          "Brand": "Ariens",
          "lineCode": "ARI"
        },
        {
          "Brand": "Armstrong",
          "lineCode": "ARM"
        },
        {
          "Brand": "Asko",
          "lineCode": "ASK"
        },
        {
          "Brand": "Asti",
          "lineCode": "AST"
        },
        {
          "Brand": "Astra",
          "lineCode": "ATR"
        },
        {
          "Brand": "Asus",
          "lineCode": "ASU"
        },
        {
          "Brand": "Asus Refurb",
          "lineCode": "ASR"
        },
        {
          "Brand": "Avanti",
          "lineCode": "AVA"
        },
        {
          "Brand": "Avent",
          "lineCode": "AVT"
        },
        {
          "Brand": "Axis",
          "lineCode": "AXI"
        },
        {
          "Brand": "Ayp Craftsman",
          "lineCode": "HOP"
        },
        {
          "Brand": "B-air",
          "lineCode": "BAR"
        },
        {
          "Brand": "Backer Ehp",
          "lineCode": "BAC"
        },
        {
          "Brand": "Bad Part Number",
          "lineCode": "BAD"
        },
        {
          "Brand": "Bakers Pride",
          "lineCode": "BAK"
        },
        {
          "Brand": "Baratza",
          "lineCode": "BTZ"
        },
        {
          "Brand": "Barranca Diamond",
          "lineCode": "BRD"
        },
        {
          "Brand": "Barry Restore It All",
          "lineCode": "BRY"
        },
        {
          "Brand": "Bauknecht",
          "lineCode": "WHI"
        },
        {
          "Brand": "Baxter",
          "lineCode": "BAX"
        },
        {
          "Brand": "Baystate Pool",
          "lineCode": "SPA"
        },
        {
          "Brand": "Beckman Industrial",
          "lineCode": "BEC"
        },
        {
          "Brand": "Beko",
          "lineCode": "BEK"
        },
        {
          "Brand": "Belt And Vcr Acc.",
          "lineCode": "PRB"
        },
        {
          "Brand": "Benq Usa",
          "lineCode": "BEN"
        },
        {
          "Brand": "Berkel",
          "lineCode": "BKL"
        },
        {
          "Brand": "Bertazzoni",
          "lineCode": "BRT"
        },
        {
          "Brand": "Beverage Air",
          "lineCode": "BEV"
        },
        {
          "Brand": "Binatone Electronics",
          "lineCode": "BQN"
        },
        {
          "Brand": "Bionaire",
          "lineCode": "BIO"
        },
        {
          "Brand": "Bissell",
          "lineCode": "BIS"
        },
        {
          "Brand": "Bizerba",
          "lineCode": "BIZ"
        },
        {
          "Brand": "BK Precision",
          "lineCode": "BKP"
        },
        {
          "Brand": "BKI",
          "lineCode": "BKI"
        },
        {
          "Brand": "Black & Decker",
          "lineCode": "BLA"
        },
        {
          "Brand": "Blodgett",
          "lineCode": "BGT"
        },
        {
          "Brand": "Blomberg",
          "lineCode": "BLM"
        },
        {
          "Brand": "Blue Ember",
          "lineCode": "BER"
        },
        {
          "Brand": "Bluebird",
          "lineCode": "BBD"
        },
        {
          "Brand": "Bluedri",
          "lineCode": "BDR"
        },
        {
          "Brand": "Bolens",
          "lineCode": "BOL"
        },
        {
          "Brand": "Bosch",
          "lineCode": "BCH"
        },
        {
          "Brand": "Bosch Tools",
          "lineCode": "BSH"
        },
        {
          "Brand": "Bostitch",
          "lineCode": "BTH"
        },
        {
          "Brand": "Boston Acoustics",
          "lineCode": "BSA"
        },
        {
          "Brand": "Bowers &Wilkins",
          "lineCode": "BWL"
        },
        {
          "Brand": "Boxes",
          "lineCode": "BOX"
        },
        {
          "Brand": "Brastemp",
          "lineCode": "WHI"
        },
        {
          "Brand": "Braun",
          "lineCode": "BRA"
        },
        {
          "Brand": "Braun",
          "lineCode": "BBN"
        },
        {
          "Brand": "Breville",
          "lineCode": "BRE"
        },
        {
          "Brand": "Briggs Power",
          "lineCode": "BSG"
        },
        {
          "Brand": "Briggs Stratton",
          "lineCode": "BSP"
        },
        {
          "Brand": "Britelite Refurbish",
          "lineCode": "BLR"
        },
        {
          "Brand": "Broan",
          "lineCode": "BRN"
        },
        {
          "Brand": "Broil King",
          "lineCode": "BLK"
        },
        {
          "Brand": "Broil-mate",
          "lineCode": "BRM"
        },
        {
          "Brand": "Broilmaster",
          "lineCode": "BMR"
        },
        {
          "Brand": "Broksonic",
          "lineCode": "BRK"
        },
        {
          "Brand": "Brookstone",
          "lineCode": "BKS"
        },
        {
          "Brand": "Brother",
          "lineCode": "BRO"
        },
        {
          "Brand": "Brother Refurb",
          "lineCode": "BRR"
        },
        {
          "Brand": "Brown Stove",
          "lineCode": "BRS"
        },
        {
          "Brand": "Bunn",
          "lineCode": "BUN"
        },
        {
          "Brand": "Caloric",
          "lineCode": "WHI"
        },
        {
          "Brand": "Calphalon",
          "lineCode": "CAL"
        },
        {
          "Brand": "Calspa",
          "lineCode": "CLP"
        },
        {
          "Brand": "Camp Chef",
          "lineCode": "CCF"
        },
        {
          "Brand": "Campbell Hausfeld",
          "lineCode": "CHD"
        },
        {
          "Brand": "Canon",
          "lineCode": "CAN"
        },
        {
          "Brand": "Canon Camera",
          "lineCode": "CA2"
        },
        {
          "Brand": "Canon Consumer",
          "lineCode": "CA1"
        },
        {
          "Brand": "Carrier",
          "lineCode": "CAR"
        },
        {
          "Brand": "Carter-Hoffmann",
          "lineCode": "CHN"
        },
        {
          "Brand": "CCS",
          "lineCode": "CCS"
        },
        {
          "Brand": "CELL PHONE PARTS",
          "lineCode": "SAM"
        },
        {
          "Brand": "CELL PHONE PARTS",
          "lineCode": "HTC"
        },
        {
          "Brand": "Chamberlain",
          "lineCode": "CHL"
        },
        {
          "Brand": "Champion",
          "lineCode": "CHA"
        },
        {
          "Brand": "Champion Moyer Diebel",
          "lineCode": "CML"
        },
        {
          "Brand": "Chapin",
          "lineCode": "CPN"
        },
        {
          "Brand": "Char-broil",
          "lineCode": "CBL"
        },
        {
          "Brand": "Chemicals",
          "lineCode": "RAW"
        },
        {
          "Brand": "Chemtronics",
          "lineCode": "CHE"
        },
        {
          "Brand": "Chicago Pneumatic",
          "lineCode": "CPC"
        },
        {
          "Brand": "Chipquik",
          "lineCode": "CHI"
        },
        {
          "Brand": "Cielo",
          "lineCode": "CLO"
        },
        {
          "Brand": "Clarion",
          "lineCode": "CLR"
        },
        {
          "Brand": "Classen",
          "lineCode": "CLA"
        },
        {
          "Brand": "Cleco",
          "lineCode": "CLC"
        },
        {
          "Brand": "Cleveland",
          "lineCode": "CLE"
        },
        {
          "Brand": "Climate Master",
          "lineCode": "CLI"
        },
        {
          "Brand": "CMA Dish Machines",
          "lineCode": "CMA"
        },
        {
          "Brand": "Coleman",
          "lineCode": "COL"
        },
        {
          "Brand": "Commercial cooking",
          "lineCode": "CEL"
        },
        {
          "Brand": "Compaq",
          "lineCode": "CPQ"
        },
        {
          "Brand": "Compaq Refurb",
          "lineCode": "CPX"
        },
        {
          "Brand": "Computer and Mobile",
          "lineCode": "COM"
        },
        {
          "Brand": "Computer Parts",
          "lineCode": "IMT"
        },
        {
          "Brand": "Computer Software",
          "lineCode": "QUE"
        },
        {
          "Brand": "Consul",
          "lineCode": "WHI"
        },
        {
          "Brand": "Continental Fan",
          "lineCode": "CON"
        },
        {
          "Brand": "Continental Refrigeration",
          "lineCode": "CRN"
        },
        {
          "Brand": "Convotherm",
          "lineCode": "CNV"
        },
        {
          "Brand": "Cooper",
          "lineCode": "COO"
        },
        {
          "Brand": "Cornelius",
          "lineCode": "COR"
        },
        {
          "Brand": "Craftsman",
          "lineCode": "CRA"
        },
        {
          "Brand": "Crary Bear Cat",
          "lineCode": "CBC"
        },
        {
          "Brand": "Crc America",
          "lineCode": "FBT"
        },
        {
          "Brand": "Cres Cor",
          "lineCode": "CRC"
        },
        {
          "Brand": "Criterion Appliance",
          "lineCode": "CRI"
        },
        {
          "Brand": "Crock Pot",
          "lineCode": "CRP"
        },
        {
          "Brand": "Crown Electronics",
          "lineCode": "CRO"
        },
        {
          "Brand": "Crown Steam",
          "lineCode": "CSM"
        },
        {
          "Brand": "Cub Cadet",
          "lineCode": "CUB"
        },
        {
          "Brand": "Cuisinart",
          "lineCode": "CUI"
        },
        {
          "Brand": "Curlin",
          "lineCode": "CUR"
        },
        {
          "Brand": "Cybex",
          "lineCode": "CYB"
        },
        {
          "Brand": "D&r Associates Inc.",
          "lineCode": "DRA"
        },
        {
          "Brand": "Dacor",
          "lineCode": "DAC"
        },
        {
          "Brand": "Daewoo",
          "lineCode": "DAE"
        },
        {
          "Brand": "Daikin",
          "lineCode": "DAI"
        },
        {
          "Brand": "Danby",
          "lineCode": "DBY"
        },
        {
          "Brand": "Dantona Industries",
          "lineCode": "DAN"
        },
        {
          "Brand": "Deflect-0",
          "lineCode": "DEF"
        },
        {
          "Brand": "Delfield",
          "lineCode": "DFD"
        },
        {
          "Brand": "Dell",
          "lineCode": "DEL"
        },
        {
          "Brand": "Dell Refurb",
          "lineCode": "DER"
        },
        {
          "Brand": "Delonghi",
          "lineCode": "DEI"
        },
        {
          "Brand": "Delta",
          "lineCode": "DTL"
        },
        {
          "Brand": "Delta Faucet",
          "lineCode": "DTF"
        },
        {
          "Brand": "Denon",
          "lineCode": "DEN"
        },
        {
          "Brand": "Devilbiss",
          "lineCode": "DEV"
        },
        {
          "Brand": "Dewalt",
          "lineCode": "DEW"
        },
        {
          "Brand": "Dex Refurbished",
          "lineCode": "DXR"
        },
        {
          "Brand": "Digitenna",
          "lineCode": "DIG"
        },
        {
          "Brand": "Dirt Devil",
          "lineCode": "DIR"
        },
        {
          "Brand": "Diversitech Inc",
          "lineCode": "DIV"
        },
        {
          "Brand": "Dngo International",
          "lineCode": "DNG"
        },
        {
          "Brand": "Dormont",
          "lineCode": "DRM"
        },
        {
          "Brand": "Dormont Manufacturin",
          "lineCode": "DOR"
        },
        {
          "Brand": "Dotco",
          "lineCode": "DOT"
        },
        {
          "Brand": "DR Power Equipment",
          "lineCode": "DRE"
        },
        {
          "Brand": "Dremel",
          "lineCode": "DML"
        },
        {
          "Brand": "DSS",
          "lineCode": "DSS"
        },
        {
          "Brand": "Duke",
          "lineCode": "DUK"
        },
        {
          "Brand": "Dundas Jafine Inc",
          "lineCode": "DUN"
        },
        {
          "Brand": "Duracell U.S.A.",
          "lineCode": "DUR"
        },
        {
          "Brand": "Dustless",
          "lineCode": "DUS"
        },
        {
          "Brand": "Dynabrade",
          "lineCode": "DYB"
        },
        {
          "Brand": "Dyson",
          "lineCode": "DYS"
        },
        {
          "Brand": "E-machine",
          "lineCode": "EMA"
        },
        {
          "Brand": "Echo",
          "lineCode": "ECH"
        },
        {
          "Brand": "Eclipse",
          "lineCode": "ECL"
        },
        {
          "Brand": "Edic",
          "lineCode": "EDI"
        },
        {
          "Brand": "Edlund",
          "lineCode": "EDL"
        },
        {
          "Brand": "Ego",
          "lineCode": "EGO"
        },
        {
          "Brand": "Electrolux",
          "lineCode": "FRI"
        },
        {
          "Brand": "Electrolux Pro",
          "lineCode": "ELX"
        },
        {
          "Brand": "Electronic Resources",
          "lineCode": "ELR"
        },
        {
          "Brand": "Electrosound",
          "lineCode": "ELS"
        },
        {
          "Brand": "Elica",
          "lineCode": "ELI"
        },
        {
          "Brand": "Emachines Refurb",
          "lineCode": "EMR"
        },
        {
          "Brand": "Emerson",
          "lineCode": "EME"
        },
        {
          "Brand": "Empire Video",
          "lineCode": "EMP"
        },
        {
          "Brand": "Encompass",
          "lineCode": "VBI"
        },
        {
          "Brand": "Encompass Parts",
          "lineCode": "EPD"
        },
        {
          "Brand": "Encompass Service",
          "lineCode": "ESS"
        },
        {
          "Brand": "Envision",
          "lineCode": "ENV"
        },
        {
          "Brand": "Envision Refurbished",
          "lineCode": "ENR"
        },
        {
          "Brand": "Epson",
          "lineCode": "EPS"
        },
        {
          "Brand": "Epson Refurb",
          "lineCode": "EPR"
        },
        {
          "Brand": "Escort",
          "lineCode": "ESC"
        },
        {
          "Brand": "Espresso Accessories",
          "lineCode": "ESP"
        },
        {
          "Brand": "Eureka",
          "lineCode": "ERK"
        },
        {
          "Brand": "Eveready Battery Co.",
          "lineCode": "EVE"
        },
        {
          "Brand": "Everpure",
          "lineCode": "EVP"
        },
        {
          "Brand": "Exmark",
          "lineCode": "EXM"
        },
        {
          "Brand": "Ez-flo",
          "lineCode": "EZF"
        },
        {
          "Brand": "Famous Entreprises",
          "lineCode": "FAM"
        },
        {
          "Brand": "Fantom",
          "lineCode": "FAN"
        },
        {
          "Brand": "Fasco",
          "lineCode": "FAS"
        },
        {
          "Brand": "FBD",
          "lineCode": "FBD"
        },
        {
          "Brand": "Federal Industries",
          "lineCode": "FED"
        },
        {
          "Brand": "Fein",
          "lineCode": "FEI"
        },
        {
          "Brand": "Fiesta",
          "lineCode": "FIE"
        },
        {
          "Brand": "Filters",
          "lineCode": "ECO"
        },
        {
          "Brand": "Fisher / Paykel",
          "lineCode": "FAP"
        },
        {
          "Brand": "Flex",
          "lineCode": "FLE"
        },
        {
          "Brand": "Flotec",
          "lineCode": "FLO"
        },
        {
          "Brand": "Fluke",
          "lineCode": "FLU"
        },
        {
          "Brand": "Follett",
          "lineCode": "FOL"
        },
        {
          "Brand": "Freemotion",
          "lineCode": "FMN"
        },
        {
          "Brand": "Freudenberg Filtrati",
          "lineCode": "FRE"
        },
        {
          "Brand": "Fri-Jado",
          "lineCode": "FJD"
        },
        {
          "Brand": "Friedrich",
          "lineCode": "FCH"
        },
        {
          "Brand": "Frigidaire",
          "lineCode": "FRI"
        },
        {
          "Brand": "Front Projector Lamp",
          "lineCode": "FPL"
        },
        {
          "Brand": "Frs Radio",
          "lineCode": "TKK"
        },
        {
          "Brand": "Frymaster",
          "lineCode": "FRY"
        },
        {
          "Brand": "Fuji-xerox Artermark",
          "lineCode": "FXA"
        },
        {
          "Brand": "Funai",
          "lineCode": "FUN"
        },
        {
          "Brand": "Gaggenau",
          "lineCode": "BCH"
        },
        {
          "Brand": "Gaming Parts",
          "lineCode": "GAM"
        },
        {
          "Brand": "Gardner",
          "lineCode": "GDN"
        },
        {
          "Brand": "Garland",
          "lineCode": "GLN"
        },
        {
          "Brand": "Garmin",
          "lineCode": "GAR"
        },
        {
          "Brand": "Gateway",
          "lineCode": "GAT"
        },
        {
          "Brand": "Gateway Refurb",
          "lineCode": "GTW"
        },
        {
          "Brand": "Gaylord",
          "lineCode": "GAY"
        },
        {
          "Brand": "Gc-thorsen",
          "lineCode": "GCE"
        },
        {
          "Brand": "GE",
          "lineCode": "HOT"
        },
        {
          "Brand": "GE Small Appliance",
          "lineCode": "GSA"
        },
        {
          "Brand": "Generac Delco",
          "lineCode": "GEN"
        },
        {
          "Brand": "Generic",
          "lineCode": "LPU"
        },
        {
          "Brand": "Generic Computer",
          "lineCode": "KAS"
        },
        {
          "Brand": "Genie",
          "lineCode": "GNE"
        },
        {
          "Brand": "Get It Clean",
          "lineCode": "GIC"
        },
        {
          "Brand": "Gibson",
          "lineCode": "FRI"
        },
        {
          "Brand": "Giles",
          "lineCode": "GLS"
        },
        {
          "Brand": "Gillette",
          "lineCode": "GIL"
        },
        {
          "Brand": "Gladiator",
          "lineCode": "WHI"
        },
        {
          "Brand": "Globe",
          "lineCode": "GLO"
        },
        {
          "Brand": "Go Plus Lighting",
          "lineCode": "GOP"
        },
        {
          "Brand": "Go Video",
          "lineCode": "GOV"
        },
        {
          "Brand": "Golds Gym",
          "lineCode": "GDG"
        },
        {
          "Brand": "Goliath Smart Phones",
          "lineCode": "GOL"
        },
        {
          "Brand": "GoLite",
          "lineCode": "GLT"
        },
        {
          "Brand": "Goodman",
          "lineCode": "GOO"
        },
        {
          "Brand": "Google",
          "lineCode": "GGL"
        },
        {
          "Brand": "Gps Batteries",
          "lineCode": "GPS"
        },
        {
          "Brand": "Gpx Remotes",
          "lineCode": "GPX"
        },
        {
          "Brand": "Graco",
          "lineCode": "GRA"
        },
        {
          "Brand": "GREEN CHOICE",
          "lineCode": "SOH"
        },
        {
          "Brand": "Green Choice",
          "lineCode": "SJP"
        },
        {
          "Brand": "Green Choice",
          "lineCode": "REB"
        },
        {
          "Brand": "Green Choice",
          "lineCode": "CGI"
        },
        {
          "Brand": "Green Choice Parts",
          "lineCode": "PPP"
        },
        {
          "Brand": "Green Choice Parts",
          "lineCode": "GCP"
        },
        {
          "Brand": "Green Choice Parts",
          "lineCode": "CKP"
        },
        {
          "Brand": "Greenworks",
          "lineCode": "GRN"
        },
        {
          "Brand": "Grindmaster",
          "lineCode": "GRI"
        },
        {
          "Brand": "Grindmaster Cecilware",
          "lineCode": "GMC"
        },
        {
          "Brand": "Grip-rite",
          "lineCode": "GPR"
        },
        {
          "Brand": "Groen",
          "lineCode": "GRO"
        },
        {
          "Brand": "Haier",
          "lineCode": "HAI"
        },
        {
          "Brand": "Haier Literature",
          "lineCode": "HSL"
        },
        {
          "Brand": "Hamilton Beach",
          "lineCode": "HAM"
        },
        {
          "Brand": "Hannspree Refurb",
          "lineCode": "HNS"
        },
        {
          "Brand": "Harmon Kardon",
          "lineCode": "HAR"
        },
        {
          "Brand": "Hatco",
          "lineCode": "HAT"
        },
        {
          "Brand": "Hayward",
          "lineCode": "HAY"
        },
        {
          "Brand": "Health Rider",
          "lineCode": "HRD"
        },
        {
          "Brand": "Heat Hog",
          "lineCode": "HHG"
        },
        {
          "Brand": "Heat Stream",
          "lineCode": "HSR"
        },
        {
          "Brand": "Heat Tools",
          "lineCode": "DRG"
        },
        {
          "Brand": "Heat Wagon",
          "lineCode": "HWN"
        },
        {
          "Brand": "Heatcraft",
          "lineCode": "HCT"
        },
        {
          "Brand": "Heatstar",
          "lineCode": "HEA"
        },
        {
          "Brand": "Henny Penny",
          "lineCode": "HNP"
        },
        {
          "Brand": "Hewlett Packard Refu",
          "lineCode": "HPR"
        },
        {
          "Brand": "High Capacity",
          "lineCode": "BAT"
        },
        {
          "Brand": "Hisense",
          "lineCode": "HIS"
        },
        {
          "Brand": "Hitachi",
          "lineCode": "HIT"
        },
        {
          "Brand": "Hiteker",
          "lineCode": "HTK"
        },
        {
          "Brand": "Hkc Digital",
          "lineCode": "HKC"
        },
        {
          "Brand": "Hobart",
          "lineCode": "HOB"
        },
        {
          "Brand": "Holman",
          "lineCode": "HOL"
        },
        {
          "Brand": "Homelite",
          "lineCode": "HOM"
        },
        {
          "Brand": "Honda",
          "lineCode": "HON"
        },
        {
          "Brand": "Honda Marine",
          "lineCode": "HAD"
        },
        {
          "Brand": "Honeywell",
          "lineCode": "HWL"
        },
        {
          "Brand": "Hoover",
          "lineCode": "HOO"
        },
        {
          "Brand": "Horizon Fitness",
          "lineCode": "HZN"
        },
        {
          "Brand": "Horton Valves",
          "lineCode": "HOR"
        },
        {
          "Brand": "Hoshizaki",
          "lineCode": "HZK"
        },
        {
          "Brand": "Hospira",
          "lineCode": "HOS"
        },
        {
          "Brand": "Hotpoint",
          "lineCode": "HOT"
        },
        {
          "Brand": "HP",
          "lineCode": "HEW"
        },
        {
          "Brand": "HP/Canon",
          "lineCode": "HPC"
        },
        {
          "Brand": "Hughes",
          "lineCode": "HUG"
        },
        {
          "Brand": "Hunter",
          "lineCode": "HUN"
        },
        {
          "Brand": "Huntington",
          "lineCode": "HTG"
        },
        {
          "Brand": "Husky",
          "lineCode": "HKY"
        },
        {
          "Brand": "Husqvarna",
          "lineCode": "HUS"
        },
        {
          "Brand": "Hussmann",
          "lineCode": "HSN"
        },
        {
          "Brand": "HVAC",
          "lineCode": "SPC"
        },
        {
          "Brand": "Hvac Parts",
          "lineCode": "GEM"
        },
        {
          "Brand": "Hydra Kool",
          "lineCode": "HDK"
        },
        {
          "Brand": "Hydrotech",
          "lineCode": "HYD"
        },
        {
          "Brand": "Hyundai Corporation",
          "lineCode": "HCU"
        },
        {
          "Brand": "I-symphony",
          "lineCode": "ISY"
        },
        {
          "Brand": "Ibm Refurb",
          "lineCode": "IBX"
        },
        {
          "Brand": "Ice-o-matic",
          "lineCode": "ICE"
        },
        {
          "Brand": "IKEA",
          "lineCode": "IKE"
        },
        {
          "Brand": "Ilo",
          "lineCode": "ILO"
        },
        {
          "Brand": "Imperial",
          "lineCode": "IPL"
        },
        {
          "Brand": "Import",
          "lineCode": "IMP"
        },
        {
          "Brand": "Impression",
          "lineCode": "IPR"
        },
        {
          "Brand": "Indesit",
          "lineCode": "WHI"
        },
        {
          "Brand": "Industrial Air",
          "lineCode": "IND"
        },
        {
          "Brand": "Infocus",
          "lineCode": "INF"
        },
        {
          "Brand": "Infratech",
          "lineCode": "INH"
        },
        {
          "Brand": "Ingersoll Rand",
          "lineCode": "ING"
        },
        {
          "Brand": "Inglis",
          "lineCode": "WHI"
        },
        {
          "Brand": "Innolux",
          "lineCode": "ILX"
        },
        {
          "Brand": "Inovate",
          "lineCode": "INO"
        },
        {
          "Brand": "Insignia",
          "lineCode": "ISG"
        },
        {
          "Brand": "Intel",
          "lineCode": "INT"
        },
        {
          "Brand": "Intermetro",
          "lineCode": "IMO"
        },
        {
          "Brand": "International Comfort Products",
          "lineCode": "ICP"
        },
        {
          "Brand": "International Environmental Corporation",
          "lineCode": "IEC"
        },
        {
          "Brand": "J.w. Harris",
          "lineCode": "JWH"
        },
        {
          "Brand": "Jackson",
          "lineCode": "JCN"
        },
        {
          "Brand": "Jacques Ebert",
          "lineCode": "JAC"
        },
        {
          "Brand": "Jacuzzi",
          "lineCode": "JZI"
        },
        {
          "Brand": "Jade",
          "lineCode": "JDE"
        },
        {
          "Brand": "Jancy",
          "lineCode": "JAN"
        },
        {
          "Brand": "Japanese Semi's",
          "lineCode": "JAP"
        },
        {
          "Brand": "Jason Illinois Inc",
          "lineCode": "JAS"
        },
        {
          "Brand": "JBL",
          "lineCode": "JBL"
        },
        {
          "Brand": "JBT",
          "lineCode": "JBT"
        },
        {
          "Brand": "Jenn-air",
          "lineCode": "JEN"
        },
        {
          "Brand": "Jennair",
          "lineCode": "WHI"
        },
        {
          "Brand": "Jenny",
          "lineCode": "JNY"
        },
        {
          "Brand": "Jet",
          "lineCode": "JET"
        },
        {
          "Brand": "Jet Tech",
          "lineCode": "JTT"
        },
        {
          "Brand": "John Guest",
          "lineCode": "JOG"
        },
        {
          "Brand": "Jonsered",
          "lineCode": "JON"
        },
        {
          "Brand": "JVC",
          "lineCode": "JVC"
        },
        {
          "Brand": "Jvc/amtran",
          "lineCode": "JVA"
        },
        {
          "Brand": "Kairak",
          "lineCode": "KAI"
        },
        {
          "Brand": "Karcher",
          "lineCode": "KAR"
        },
        {
          "Brand": "Kason",
          "lineCode": "KSN"
        },
        {
          "Brand": "Kawasaki",
          "lineCode": "KAW"
        },
        {
          "Brand": "Kds Monitors",
          "lineCode": "KDS"
        },
        {
          "Brand": "Kdsusa Inc Refurb",
          "lineCode": "KDX"
        },
        {
          "Brand": "Kef Audio",
          "lineCode": "KEF"
        },
        {
          "Brand": "Kelon",
          "lineCode": "KEL"
        },
        {
          "Brand": "Kelvinator",
          "lineCode": "FRI"
        },
        {
          "Brand": "Kendall",
          "lineCode": "KNL"
        },
        {
          "Brand": "Kenmore",
          "lineCode": "KMR"
        },
        {
          "Brand": "Kenwood",
          "lineCode": "KEW"
        },
        {
          "Brand": "Kenwood",
          "lineCode": "KEN"
        },
        {
          "Brand": "Kirby",
          "lineCode": "KIR"
        },
        {
          "Brand": "KitchenAid",
          "lineCode": "WHI"
        },
        {
          "Brand": "Knaack",
          "lineCode": "KNA"
        },
        {
          "Brand": "Kobalt",
          "lineCode": "KOB"
        },
        {
          "Brand": "Kodak Refurb",
          "lineCode": "KOR"
        },
        {
          "Brand": "Kohler",
          "lineCode": "KOH"
        },
        {
          "Brand": "Kolpak",
          "lineCode": "KOL"
        },
        {
          "Brand": "Konka",
          "lineCode": "KON"
        },
        {
          "Brand": "Kool It",
          "lineCode": "KOO"
        },
        {
          "Brand": "KOVA",
          "lineCode": "KAT"
        },
        {
          "Brand": "Krowne",
          "lineCode": "KRO"
        },
        {
          "Brand": "Krups",
          "lineCode": "KRU"
        },
        {
          "Brand": "Kyocera Mita",
          "lineCode": "KYO"
        },
        {
          "Brand": "L&lsquo;OR Barista",
          "lineCode": "LOR"
        },
        {
          "Brand": "Lamp Only",
          "lineCode": "LMP"
        },
        {
          "Brand": "Lancer",
          "lineCode": "LCR"
        },
        {
          "Brand": "Lang",
          "lineCode": "LAN"
        },
        {
          "Brand": "Lasko",
          "lineCode": "LAS"
        },
        {
          "Brand": "Lawn Boy",
          "lineCode": "LAW"
        },
        {
          "Brand": "Lelit",
          "lineCode": "LEL"
        },
        {
          "Brand": "Lennox",
          "lineCode": "LNX"
        },
        {
          "Brand": "Lenovo",
          "lineCode": "LEN"
        },
        {
          "Brand": "Lenovo Recertified",
          "lineCode": "LEH"
        },
        {
          "Brand": "Lexmark",
          "lineCode": "LEX"
        },
        {
          "Brand": "Lexmark Refurb",
          "lineCode": "LXR"
        },
        {
          "Brand": "LG",
          "lineCode": "ZEN"
        },
        {
          "Brand": "LG",
          "lineCode": "LGE"
        },
        {
          "Brand": "Liebherr",
          "lineCode": "LIE"
        },
        {
          "Brand": "Liftmaster",
          "lineCode": "LIF"
        },
        {
          "Brand": "Lincoln",
          "lineCode": "LCN"
        },
        {
          "Brand": "Linksys",
          "lineCode": "LIN"
        },
        {
          "Brand": "Liquid Video Refurb",
          "lineCode": "LVR"
        },
        {
          "Brand": "Little Wonder",
          "lineCode": "LTW"
        },
        {
          "Brand": "Littlefuse",
          "lineCode": "LIT"
        },
        {
          "Brand": "Lmb Heeger",
          "lineCode": "LMB"
        },
        {
          "Brand": "Lobb",
          "lineCode": "LOB"
        },
        {
          "Brand": "Lokring Appliance",
          "lineCode": "LOK"
        },
        {
          "Brand": "Lowell",
          "lineCode": "LOW"
        },
        {
          "Brand": "LPS",
          "lineCode": "LPS"
        },
        {
          "Brand": "Luxor",
          "lineCode": "LUX"
        },
        {
          "Brand": "Lynx",
          "lineCode": "LYN"
        },
        {
          "Brand": "Ma-line",
          "lineCode": "MAE"
        },
        {
          "Brand": "Magic Chef",
          "lineCode": "MAC"
        },
        {
          "Brand": "Magnavox",
          "lineCode": "MAG"
        },
        {
          "Brand": "Majestic",
          "lineCode": "MAJ"
        },
        {
          "Brand": "Makita",
          "lineCode": "MAK"
        },
        {
          "Brand": "Mallory",
          "lineCode": "MAL"
        },
        {
          "Brand": "Manitowoc Ice",
          "lineCode": "MIC"
        },
        {
          "Brand": "Mantis",
          "lineCode": "MAN"
        },
        {
          "Brand": "Marantz",
          "lineCode": "MAR"
        },
        {
          "Brand": "Margaritaville",
          "lineCode": "MGT"
        },
        {
          "Brand": "Market Forge",
          "lineCode": "MKF"
        },
        {
          "Brand": "Marquis",
          "lineCode": "MRQ"
        },
        {
          "Brand": "Marshall Air",
          "lineCode": "MSA"
        },
        {
          "Brand": "Mass Integrated",
          "lineCode": "MIS"
        },
        {
          "Brand": "Master",
          "lineCode": "MAS"
        },
        {
          "Brand": "Master-Bilt",
          "lineCode": "MLT"
        },
        {
          "Brand": "Matrix Fitness",
          "lineCode": "MAT"
        },
        {
          "Brand": "Matsushita",
          "lineCode": "MSL"
        },
        {
          "Brand": "Matv/catv Acc",
          "lineCode": "PCO"
        },
        {
          "Brand": "Max",
          "lineCode": "MXX"
        },
        {
          "Brand": "Max Professional",
          "lineCode": "MXP"
        },
        {
          "Brand": "Maxell",
          "lineCode": "MAX"
        },
        {
          "Brand": "Maytag",
          "lineCode": "WHI"
        },
        {
          "Brand": "Maytag",
          "lineCode": "MAY"
        },
        {
          "Brand": "MCM",
          "lineCode": "MCM"
        },
        {
          "Brand": "Medex",
          "lineCode": "MDM"
        },
        {
          "Brand": "Memory Products",
          "lineCode": "PAR"
        },
        {
          "Brand": "Merco",
          "lineCode": "MEO"
        },
        {
          "Brand": "Merrychef",
          "lineCode": "MER"
        },
        {
          "Brand": "Metabo HPT",
          "lineCode": "MET"
        },
        {
          "Brand": "Metabo Hpt",
          "lineCode": "HPT"
        },
        {
          "Brand": "Mi-t-m",
          "lineCode": "MIM"
        },
        {
          "Brand": "Miami Parts",
          "lineCode": "MIA"
        },
        {
          "Brand": "Microsoft",
          "lineCode": "MCS"
        },
        {
          "Brand": "Middleby",
          "lineCode": "MBY"
        },
        {
          "Brand": "Midea",
          "lineCode": "MID"
        },
        {
          "Brand": "Midland Metal",
          "lineCode": "MLM"
        },
        {
          "Brand": "Miele",
          "lineCode": "MIE"
        },
        {
          "Brand": "Milnor",
          "lineCode": "MNR"
        },
        {
          "Brand": "Milwaukee",
          "lineCode": "MIL"
        },
        {
          "Brand": "Minn Kota",
          "lineCode": "MKA"
        },
        {
          "Brand": "Miracle Remote",
          "lineCode": "MIR"
        },
        {
          "Brand": "Mirro",
          "lineCode": "MRO"
        },
        {
          "Brand": "Mitsubishi",
          "lineCode": "MIT"
        },
        {
          "Brand": "Mitsubishi Refurb",
          "lineCode": "MTR"
        },
        {
          "Brand": "Mk Diamond",
          "lineCode": "MKD"
        },
        {
          "Brand": "Moen",
          "lineCode": "MOE"
        },
        {
          "Brand": "Moffat",
          "lineCode": "MOF"
        },
        {
          "Brand": "Monessen",
          "lineCode": "MNN"
        },
        {
          "Brand": "Monogram",
          "lineCode": "HOT"
        },
        {
          "Brand": "Montague",
          "lineCode": "MNU"
        },
        {
          "Brand": "Motorola Refurb",
          "lineCode": "MRX"
        },
        {
          "Brand": "Motors & Armatures",
          "lineCode": "MAA"
        },
        {
          "Brand": "Moyer Diebel",
          "lineCode": "CMD"
        },
        {
          "Brand": "Mr Coffee",
          "lineCode": "MRF"
        },
        {
          "Brand": "Mr Heater",
          "lineCode": "MRH"
        },
        {
          "Brand": "MRCOOL",
          "lineCode": "MRC"
        },
        {
          "Brand": "MSI",
          "lineCode": "MSI"
        },
        {
          "Brand": "Mst",
          "lineCode": "MST"
        },
        {
          "Brand": "Mtx Speakers",
          "lineCode": "MTX"
        },
        {
          "Brand": "Muratec",
          "lineCode": "MUR"
        },
        {
          "Brand": "Murray",
          "lineCode": "BSM"
        },
        {
          "Brand": "Nady",
          "lineCode": "NAD"
        },
        {
          "Brand": "Napoleon",
          "lineCode": "NPL"
        },
        {
          "Brand": "NEC",
          "lineCode": "NEC"
        },
        {
          "Brand": "Nespresso",
          "lineCode": "NES"
        },
        {
          "Brand": "New Wave Sales",
          "lineCode": "NWS"
        },
        {
          "Brand": "Nexgrill",
          "lineCode": "NGL"
        },
        {
          "Brand": "Nextbook Usa",
          "lineCode": "NEX"
        },
        {
          "Brand": "Nexxtech",
          "lineCode": "NXX"
        },
        {
          "Brand": "Nieco",
          "lineCode": "NIE"
        },
        {
          "Brand": "Nikon",
          "lineCode": "NKN"
        },
        {
          "Brand": "Nordictrack",
          "lineCode": "NDT"
        },
        {
          "Brand": "Norelco",
          "lineCode": "NOR"
        },
        {
          "Brand": "Norelco",
          "lineCode": "NCR"
        },
        {
          "Brand": "NORLAKE",
          "lineCode": "NRK"
        },
        {
          "Brand": "Nortek",
          "lineCode": "NTK"
        },
        {
          "Brand": "NOT FOR RESALE",
          "lineCode": "HEM"
        },
        {
          "Brand": "Novatek",
          "lineCode": "NOV"
        },
        {
          "Brand": "Nte Electronics",
          "lineCode": "NTE"
        },
        {
          "Brand": "Nu-Vu",
          "lineCode": "NUV"
        },
        {
          "Brand": "Nukote",
          "lineCode": "NUK"
        },
        {
          "Brand": "Numerex",
          "lineCode": "NUM"
        },
        {
          "Brand": "Nuova Simonelli",
          "lineCode": "NUO"
        },
        {
          "Brand": "Nutone",
          "lineCode": "NUT"
        },
        {
          "Brand": "Oem Compatible",
          "lineCode": "HPA"
        },
        {
          "Brand": "Office Supplies",
          "lineCode": "OFC"
        },
        {
          "Brand": "Okidata Refurb",
          "lineCode": "OKR"
        },
        {
          "Brand": "Olevia",
          "lineCode": "OLE"
        },
        {
          "Brand": "Olympus",
          "lineCode": "OLY"
        },
        {
          "Brand": "Onkyo",
          "lineCode": "ONK"
        },
        {
          "Brand": "Opal Icemakers",
          "lineCode": "OPL"
        },
        {
          "Brand": "Optoma",
          "lineCode": "OPT"
        },
        {
          "Brand": "Oral-B",
          "lineCode": "ORB"
        },
        {
          "Brand": "Orbit",
          "lineCode": "OBT"
        },
        {
          "Brand": "Oreck",
          "lineCode": "ORE"
        },
        {
          "Brand": "Oregon",
          "lineCode": "ORG"
        },
        {
          "Brand": "Orion",
          "lineCode": "ORI"
        },
        {
          "Brand": "OSRAM",
          "lineCode": "OSR"
        },
        {
          "Brand": "Osram Neolux",
          "lineCode": "NEO"
        },
        {
          "Brand": "Oster",
          "lineCode": "OST"
        },
        {
          "Brand": "Packaging",
          "lineCode": "PKG"
        },
        {
          "Brand": "Packard Inc",
          "lineCode": "PAK"
        },
        {
          "Brand": "Panasonic",
          "lineCode": "MSC"
        },
        {
          "Brand": "Panasonic Refurb",
          "lineCode": "MSR"
        },
        {
          "Brand": "Panduit",
          "lineCode": "PDT"
        },
        {
          "Brand": "Patio Comfort",
          "lineCode": "PAT"
        },
        {
          "Brand": "Peerless Premier",
          "lineCode": "PPA"
        },
        {
          "Brand": "Peg Perego",
          "lineCode": "PEG"
        },
        {
          "Brand": "Penn",
          "lineCode": "PEN"
        },
        {
          "Brand": "Pentair",
          "lineCode": "PTR"
        },
        {
          "Brand": "Perlick",
          "lineCode": "PLC"
        },
        {
          "Brand": "Petra",
          "lineCode": "PTA"
        },
        {
          "Brand": "Pflueger",
          "lineCode": "PFL"
        },
        {
          "Brand": "Pgs Grill",
          "lineCode": "PGS"
        },
        {
          "Brand": "Philco",
          "lineCode": "FRI"
        },
        {
          "Brand": "Philips",
          "lineCode": "PNF"
        },
        {
          "Brand": "Philips",
          "lineCode": "PCL"
        },
        {
          "Brand": "Philips",
          "lineCode": "NAP"
        },
        {
          "Brand": "PHILIPS GARMENT CARE",
          "lineCode": "PGC"
        },
        {
          "Brand": "Philips Health Solut",
          "lineCode": "PHS"
        },
        {
          "Brand": "Philips Healthy Cook",
          "lineCode": "PHC"
        },
        {
          "Brand": "Philips Hospitality",
          "lineCode": "PBS"
        },
        {
          "Brand": "Philips Lighting",
          "lineCode": "PHL"
        },
        {
          "Brand": "Philips Pet Care",
          "lineCode": "PPC"
        },
        {
          "Brand": "Philips Product",
          "lineCode": "PAF"
        },
        {
          "Brand": "Philips Purifiers",
          "lineCode": "PPH"
        },
        {
          "Brand": "Philmore",
          "lineCode": "PHI"
        },
        {
          "Brand": "Phoenix Lamp",
          "lineCode": "PHX"
        },
        {
          "Brand": "Pinnacle Sales",
          "lineCode": "PIN"
        },
        {
          "Brand": "Pioneer",
          "lineCode": "PIO"
        },
        {
          "Brand": "Pitco",
          "lineCode": "PIT"
        },
        {
          "Brand": "Plasmair",
          "lineCode": "PLA"
        },
        {
          "Brand": "Polk",
          "lineCode": "PLK"
        },
        {
          "Brand": "Polti Refurbished",
          "lineCode": "POR"
        },
        {
          "Brand": "Porter Cable",
          "lineCode": "PTC"
        },
        {
          "Brand": "Poulan",
          "lineCode": "POU"
        },
        {
          "Brand": "Power Cords",
          "lineCode": "WEB"
        },
        {
          "Brand": "Power Soak Systems",
          "lineCode": "PSS"
        },
        {
          "Brand": "Power Wheels",
          "lineCode": "PWS"
        },
        {
          "Brand": "Powermate",
          "lineCode": "PWM"
        },
        {
          "Brand": "Powermatic",
          "lineCode": "PMT"
        },
        {
          "Brand": "Powersonic",
          "lineCode": "POW"
        },
        {
          "Brand": "Premier Range Co.",
          "lineCode": "PER"
        },
        {
          "Brand": "Presto",
          "lineCode": "PRE"
        },
        {
          "Brand": "Prima Worldwide",
          "lineCode": "PWW"
        },
        {
          "Brand": "Primo",
          "lineCode": "PMO"
        },
        {
          "Brand": "Prince Castle",
          "lineCode": "PRI"
        },
        {
          "Brand": "Pro Temp",
          "lineCode": "PRP"
        },
        {
          "Brand": "Proctor Silex",
          "lineCode": "PSX"
        },
        {
          "Brand": "Proform",
          "lineCode": "PRF"
        },
        {
          "Brand": "Proscan",
          "lineCode": "PCN"
        },
        {
          "Brand": "Protective Coating",
          "lineCode": "PRT"
        },
        {
          "Brand": "Proview",
          "lineCode": "PRV"
        },
        {
          "Brand": "Pts Modules",
          "lineCode": "PTS"
        },
        {
          "Brand": "QST",
          "lineCode": "QST"
        },
        {
          "Brand": "Quam",
          "lineCode": "QUA"
        },
        {
          "Brand": "Quantum View",
          "lineCode": "QTM"
        },
        {
          "Brand": "Rain Bird",
          "lineCode": "RAI"
        },
        {
          "Brand": "Randell",
          "lineCode": "RAN"
        },
        {
          "Brand": "Rational",
          "lineCode": "RAT"
        },
        {
          "Brand": "Raypak",
          "lineCode": "RAY"
        },
        {
          "Brand": "Razor",
          "lineCode": "RAZ"
        },
        {
          "Brand": "RCA",
          "lineCode": "RCA"
        },
        {
          "Brand": "Rechargeable Battery",
          "lineCode": "USP"
        },
        {
          "Brand": "Rectorseal",
          "lineCode": "REC"
        },
        {
          "Brand": "Redmax",
          "lineCode": "RED"
        },
        {
          "Brand": "Remington",
          "lineCode": "REM"
        },
        {
          "Brand": "Replacement Transist",
          "lineCode": "REP"
        },
        {
          "Brand": "Reznor",
          "lineCode": "REZ"
        },
        {
          "Brand": "Rheem",
          "lineCode": "RHE"
        },
        {
          "Brand": "Ricoh Refurbished",
          "lineCode": "RCX"
        },
        {
          "Brand": "Ridgid",
          "lineCode": "RID"
        },
        {
          "Brand": "Rikon",
          "lineCode": "RIK"
        },
        {
          "Brand": "Ritchie Engineering",
          "lineCode": "RIE"
        },
        {
          "Brand": "Rite Off",
          "lineCode": "RIT"
        },
        {
          "Brand": "Robertshaw",
          "lineCode": "ROB"
        },
        {
          "Brand": "Robinair Divison",
          "lineCode": "ROD"
        },
        {
          "Brand": "Robot Coupe",
          "lineCode": "RCE"
        },
        {
          "Brand": "Rockwell",
          "lineCode": "ROC"
        },
        {
          "Brand": "Rolair",
          "lineCode": "ROL"
        },
        {
          "Brand": "Rotozip",
          "lineCode": "RTZ"
        },
        {
          "Brand": "Rowenta",
          "lineCode": "ROW"
        },
        {
          "Brand": "Royal",
          "lineCode": "ROY"
        },
        {
          "Brand": "Runco",
          "lineCode": "RUN"
        },
        {
          "Brand": "Ruud",
          "lineCode": "RUU"
        },
        {
          "Brand": "Ryobi",
          "lineCode": "TTI"
        },
        {
          "Brand": "Saeco",
          "lineCode": "SAE"
        },
        {
          "Brand": "Salvajor",
          "lineCode": "SAL"
        },
        {
          "Brand": "Samsung",
          "lineCode": "SMG"
        },
        {
          "Brand": "Sanitaire",
          "lineCode": "SAN"
        },
        {
          "Brand": "Sanyo",
          "lineCode": "SFS"
        },
        {
          "Brand": "Schaerer",
          "lineCode": "SCH"
        },
        {
          "Brand": "Scopes & Power Supp.",
          "lineCode": "KWD"
        },
        {
          "Brand": "Scotsman",
          "lineCode": "SCO"
        },
        {
          "Brand": "Sears Commerical",
          "lineCode": "SEA"
        },
        {
          "Brand": "SEB",
          "lineCode": "SEB"
        },
        {
          "Brand": "Senco",
          "lineCode": "SNC"
        },
        {
          "Brand": "Senseo",
          "lineCode": "SEN"
        },
        {
          "Brand": "Sensible Products",
          "lineCode": "SEP"
        },
        {
          "Brand": "Server",
          "lineCode": "SER"
        },
        {
          "Brand": "Shakespeare",
          "lineCode": "SHK"
        },
        {
          "Brand": "Shark",
          "lineCode": "SRK"
        },
        {
          "Brand": "Sharp",
          "lineCode": "SHA"
        },
        {
          "Brand": "Shimano",
          "lineCode": "SHM"
        },
        {
          "Brand": "Shindaiwa",
          "lineCode": "SHI"
        },
        {
          "Brand": "Shopvac",
          "lineCode": "SHO"
        },
        {
          "Brand": "Sierra",
          "lineCode": "SIE"
        },
        {
          "Brand": "Sigmac Usa",
          "lineCode": "SGM"
        },
        {
          "Brand": "Silhouette",
          "lineCode": "SIL"
        },
        {
          "Brand": "Silver King",
          "lineCode": "SVK"
        },
        {
          "Brand": "Simer",
          "lineCode": "SME"
        },
        {
          "Brand": "Simplicity",
          "lineCode": "SIM"
        },
        {
          "Brand": "Skil",
          "lineCode": "SKI"
        },
        {
          "Brand": "Skuttle",
          "lineCode": "SKU"
        },
        {
          "Brand": "Small Appliance Product",
          "lineCode": "GEA"
        },
        {
          "Brand": "SMART TECHNOLOGIES",
          "lineCode": "SMT"
        },
        {
          "Brand": "Smeg",
          "lineCode": "SGG"
        },
        {
          "Brand": "Smudgetip",
          "lineCode": "SMD"
        },
        {
          "Brand": "Snapper",
          "lineCode": "SNA"
        },
        {
          "Brand": "Sonicare",
          "lineCode": "SCR"
        },
        {
          "Brand": "Sony",
          "lineCode": "SON"
        },
        {
          "Brand": "Soundlier",
          "lineCode": "SOU"
        },
        {
          "Brand": "Southbend",
          "lineCode": "SBD"
        },
        {
          "Brand": "Southbend Range",
          "lineCode": "SOR"
        },
        {
          "Brand": "Southland",
          "lineCode": "SLD"
        },
        {
          "Brand": "Soyo Refurbished",
          "lineCode": "SYR"
        },
        {
          "Brand": "Spaceman",
          "lineCode": "SMU"
        },
        {
          "Brand": "Spectrum",
          "lineCode": "SPE"
        },
        {
          "Brand": "Spectrum Refurbished",
          "lineCode": "SPR"
        },
        {
          "Brand": "Speed Queen",
          "lineCode": "Fa"
        },
        {
          "Brand": "Spraytech",
          "lineCode": "SPT"
        },
        {
          "Brand": "SRC Refrigeration",
          "lineCode": "SRC"
        },
        {
          "Brand": "Stanco",
          "lineCode": "STC"
        },
        {
          "Brand": "Stanley",
          "lineCode": "SLY"
        },
        {
          "Brand": "Star",
          "lineCode": "STA"
        },
        {
          "Brand": "Star Trac",
          "lineCode": "STR"
        },
        {
          "Brand": "Starlogic Refurbish",
          "lineCode": "STL"
        },
        {
          "Brand": "Sterling",
          "lineCode": "STE"
        },
        {
          "Brand": "Stero Dishwasher",
          "lineCode": "STD"
        },
        {
          "Brand": "Stevens Appliance Tr",
          "lineCode": "SAT"
        },
        {
          "Brand": "Stoelting",
          "lineCode": "STO"
        },
        {
          "Brand": "structural Concepts",
          "lineCode": "SCS"
        },
        {
          "Brand": "Sub-Zero",
          "lineCode": "SUB"
        },
        {
          "Brand": "Subaru / Robin",
          "lineCode": "SRN"
        },
        {
          "Brand": "Summit Brands",
          "lineCode": "SUM"
        },
        {
          "Brand": "Sun-stream",
          "lineCode": "SST"
        },
        {
          "Brand": "Sunbeam",
          "lineCode": "SUN"
        },
        {
          "Brand": "Sunglo",
          "lineCode": "SGO"
        },
        {
          "Brand": "Sunheat",
          "lineCode": "SHT"
        },
        {
          "Brand": "Sunpak",
          "lineCode": "SPK"
        },
        {
          "Brand": "Supplies",
          "lineCode": "SUP"
        },
        {
          "Brand": "Sure Flame",
          "lineCode": "SUR"
        },
        {
          "Brand": "SVA",
          "lineCode": "SVA"
        },
        {
          "Brand": "Switchcraft",
          "lineCode": "SWI"
        },
        {
          "Brand": "Sylvania",
          "lineCode": "SYL"
        },
        {
          "Brand": "Systemax",
          "lineCode": "STM"
        },
        {
          "Brand": "T-fal",
          "lineCode": "T-F"
        },
        {
          "Brand": "Tanaka",
          "lineCode": "TAN"
        },
        {
          "Brand": "Tappan",
          "lineCode": "FRI"
        },
        {
          "Brand": "Tce Technical",
          "lineCode": "RCL"
        },
        {
          "Brand": "TCL",
          "lineCode": "TCL"
        },
        {
          "Brand": "Tech Spray",
          "lineCode": "TEC"
        },
        {
          "Brand": "Tecumseh",
          "lineCode": "TSH"
        },
        {
          "Brand": "Tektronix",
          "lineCode": "TKX"
        },
        {
          "Brand": "Tempur-pedic",
          "lineCode": "TMP"
        },
        {
          "Brand": "Test Equipment",
          "lineCode": "VEL"
        },
        {
          "Brand": "Test Parts",
          "lineCode": "TST"
        },
        {
          "Brand": "The Good Clean",
          "lineCode": "TGC"
        },
        {
          "Brand": "Thermador",
          "lineCode": "BCH"
        },
        {
          "Brand": "Thermofluid Tech",
          "lineCode": "THT"
        },
        {
          "Brand": "Thor",
          "lineCode": "THO"
        },
        {
          "Brand": "Tile",
          "lineCode": "ESI"
        },
        {
          "Brand": "Titan",
          "lineCode": "TIT"
        },
        {
          "Brand": "Titan Tankless Water",
          "lineCode": "TTW"
        },
        {
          "Brand": "TNT",
          "lineCode": "TNT"
        },
        {
          "Brand": "Tom Tom",
          "lineCode": "TMT"
        },
        {
          "Brand": "Tools",
          "lineCode": "PAC"
        },
        {
          "Brand": "Toro",
          "lineCode": "TOR"
        },
        {
          "Brand": "Toshiba",
          "lineCode": "TBA"
        },
        {
          "Brand": "Toshiba Computer",
          "lineCode": "TOS"
        },
        {
          "Brand": "Tradepro",
          "lineCode": "TRA"
        },
        {
          "Brand": "Trane",
          "lineCode": "TRN"
        },
        {
          "Brand": "Traulsen",
          "lineCode": "TSN"
        },
        {
          "Brand": "Tri-state Module",
          "lineCode": "TSM"
        },
        {
          "Brand": "Tripp-lite",
          "lineCode": "TRI"
        },
        {
          "Brand": "Troy Bilt",
          "lineCode": "MTD"
        },
        {
          "Brand": "Turbo Air",
          "lineCode": "TUA"
        },
        {
          "Brand": "Turbochef",
          "lineCode": "BMC"
        },
        {
          "Brand": "Twin Eagles",
          "lineCode": "TWI"
        },
        {
          "Brand": "U-line",
          "lineCode": "ULN"
        },
        {
          "Brand": "UltraFryer",
          "lineCode": "ULT"
        },
        {
          "Brand": "Unic",
          "lineCode": "UIC"
        },
        {
          "Brand": "Universal Ent",
          "lineCode": "ULE"
        },
        {
          "Brand": "Uniweld",
          "lineCode": "UNI"
        },
        {
          "Brand": "Unox",
          "lineCode": "UNO"
        },
        {
          "Brand": "Us Stove Company",
          "lineCode": "USS"
        },
        {
          "Brand": "Usd Products",
          "lineCode": "USD"
        },
        {
          "Brand": "V7e Elect. Refurbish",
          "lineCode": "VSR"
        },
        {
          "Brand": "Vanco",
          "lineCode": "VAN"
        },
        {
          "Brand": "Vapco Products",
          "lineCode": "VAP"
        },
        {
          "Brand": "Vent-a-hood",
          "lineCode": "VEN"
        },
        {
          "Brand": "Verge",
          "lineCode": "VRG"
        },
        {
          "Brand": "Vermont",
          "lineCode": "VER"
        },
        {
          "Brand": "Victory",
          "lineCode": "VIC"
        },
        {
          "Brand": "VIDEO GAMING",
          "lineCode": "VGA"
        },
        {
          "Brand": "Video Mount Products",
          "lineCode": "VMP"
        },
        {
          "Brand": "Viewsonic Refurb",
          "lineCode": "VWS"
        },
        {
          "Brand": "Viking",
          "lineCode": "VIK"
        },
        {
          "Brand": "Viore",
          "lineCode": "VIO"
        },
        {
          "Brand": "Virginia Air",
          "lineCode": "VIR"
        },
        {
          "Brand": "Vision Fitness",
          "lineCode": "VIS"
        },
        {
          "Brand": "Vivitek",
          "lineCode": "VIV"
        },
        {
          "Brand": "VIZIO",
          "lineCode": "VIZ"
        },
        {
          "Brand": "VIZIO-FOXCONN",
          "lineCode": "FOX"
        },
        {
          "Brand": "VIZIO-TPV",
          "lineCode": "TPV"
        },
        {
          "Brand": "VIZIO-WISTRON",
          "lineCode": "WIS"
        },
        {
          "Brand": "Vizparts",
          "lineCode": "VZP"
        },
        {
          "Brand": "Vollrath",
          "lineCode": "VLH"
        },
        {
          "Brand": "Vulcan",
          "lineCode": "VUL"
        },
        {
          "Brand": "Wagner",
          "lineCode": "WAG"
        },
        {
          "Brand": "Walbro",
          "lineCode": "WAL"
        },
        {
          "Brand": "Walker & Sons",
          "lineCode": "WLK"
        },
        {
          "Brand": "Waring",
          "lineCode": "WAR"
        },
        {
          "Brand": "Wearever",
          "lineCode": "WVR"
        },
        {
          "Brand": "Weather Guard",
          "lineCode": "WEA"
        },
        {
          "Brand": "Weber",
          "lineCode": "WBR"
        },
        {
          "Brand": "Weed Eater",
          "lineCode": "WEE"
        },
        {
          "Brand": "Wells",
          "lineCode": "WEL"
        },
        {
          "Brand": "Weslo",
          "lineCode": "WSL"
        },
        {
          "Brand": "West Penn",
          "lineCode": "WES"
        },
        {
          "Brand": "Western Dig. Refurb",
          "lineCode": "WDR"
        },
        {
          "Brand": "Westinghouse",
          "lineCode": "WDE"
        },
        {
          "Brand": "Whirlpool",
          "lineCode": "WHI"
        },
        {
          "Brand": "White Mountain",
          "lineCode": "WMN"
        },
        {
          "Brand": "White-rodgers",
          "lineCode": "WHR"
        },
        {
          "Brand": "White-Westinghouse",
          "lineCode": "FRI"
        },
        {
          "Brand": "Wii Nintendo",
          "lineCode": "WII"
        },
        {
          "Brand": "Wilbur Curtis",
          "lineCode": "WIC"
        },
        {
          "Brand": "Wilton",
          "lineCode": "WIL"
        },
        {
          "Brand": "Winco",
          "lineCode": "WCO"
        },
        {
          "Brand": "Winegard",
          "lineCode": "WIN"
        },
        {
          "Brand": "Winston",
          "lineCode": "WST"
        },
        {
          "Brand": "Wolf Appliacen",
          "lineCode": "WOL"
        },
        {
          "Brand": "Wood Finishing",
          "lineCode": "WFS"
        },
        {
          "Brand": "Wood Stone",
          "lineCode": "WOO"
        },
        {
          "Brand": "Worx",
          "lineCode": "WOR"
        },
        {
          "Brand": "X2gen Refurbished",
          "lineCode": "XTG"
        },
        {
          "Brand": "Xantus Products",
          "lineCode": "XAN"
        },
        {
          "Brand": "Xfmrs & Solenoids",
          "lineCode": "STN"
        },
        {
          "Brand": "Yamaha",
          "lineCode": "YAM"
        },
        {
          "Brand": "Yard Man",
          "lineCode": "YAR"
        },
        {
          "Brand": "Yc",
          "lineCode": "YCX"
        },
        {
          "Brand": "Yeats Dolly",
          "lineCode": "YEA"
        },
        {
          "Brand": "York",
          "lineCode": "YOR"
        },
        {
          "Brand": "Yummly",
          "lineCode": "WHI"
        },
        {
          "Brand": "Zama",
          "lineCode": "ZAM"
        },
        {
          "Brand": "Zebra",
          "lineCode": "ZEB"
        },
        {
          "Brand": "Zephyr",
          "lineCode": "ZEP"
        },
        {
          "Brand": "Zodiac",
          "lineCode": "ZOD"
        }
      ];                          
    // console.log("Brand_json_instant",Brand_json_instant)
    
     var brandName_instant = hit.vendor;
  // console.log("brandName_instant",brandName_instant)
      const formatString = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      const matchingBrand = Brand_json_instant.find(item => formatString(item.Brand) === formatString(brandName_instant));
    // console.log("matchingBrand",matchingBrand)
  var Brand_Line = "";
  if(matchingBrand){
    Brand_Line = matchingBrand.lineCode;
  }else{
     Brand_Line = "";
  }
  // console.log("Brand_Line>>",Brand_Line)
  // var Brand_Line = matchingBrand.lineCode;

let imageUrl;

if (matchingBrand && algoliaShopify.helpers.mediumImage(hit) === 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif') {
  imageUrl = `https://encompass-11307.kxcdn.com/imageDisplay?mfgCode=${matchingBrand.lineCode}&type=b&size=s`;
} else {
   imageUrl = hit.image;
}
// console.log("hit.vendor",hit.vendor)
  let newImage = '';
  if(hit.image){
    // console.log("Image Found")
    newImage = hit.image;
  }else if(matchingBrand && algoliaShopify.helpers.mediumImage(hit) === 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif'){
    // console.log("deafult Image Found")
    newImage = `https://encompass-11307.kxcdn.com/imageDisplay?mfgCode=${Brand_Line}&type=b&size=s`;
  }else if (hit.image && hit.image.includes("https://cdn.shopify.com/s/files/1/0700/0293/3937/files/")) {
  const formattedVendor = hit.vendor.replace(/[\s/]+/g, '_');
// console.log("formattedVendor", formattedVendor);

  newImage = `https://cdn.shopify.com/s/files/1/0700/0293/3937/files/${formattedVendor}.png`;
  // console.log("Image Not Found");
    
} else {
  // do something else
  // console.log("Image does NOT include specified path:", hit.image);
    newImage = `https://encompass-11307.kxcdn.com/imageDisplay?mfgCode=${Brand_Line}&type=b&size=s`;
}

//   else if(hit.image) {
//  const formattedVendor = hit.vendor.replace(/[\s/]+/g, '_');
// console.log("formattedVendor", formattedVendor);

//   newImage = `https://cdn.shopify.com/s/files/1/0700/0293/3937/files/${formattedVendor}.png`;
//   console.log("Image Not Found");
// }

// console.log("newImage",newImage)
// console.log("matchingBrand lineCode: imageUrl" );

// var product_type = typecomponents.props.parts[0][0].value;
  // console.log("vendor <<<<",hit.collections[0])
// console.log("collcetion <<<<",hit.collections[1])

  const inputValue1 = document.querySelector('.ais-SearchBox-input')?.value?.trim();
    //  console.log("inputValue1",inputValue1,"item.sku",hit.sku)
    
    return html`
      <div
        class="ais-hit ais-product abc"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        data-barCode="${hit.barcode}"
        data-product-type="${hit.product_type}"
        data-vendor="${hit.collections[0]}"
        data-collection-name="${hit.collections[1]}"
        data-vendor="${hit.vendor}"
      >
        ${hit.collections && (
            hit.collections.includes('lg-refrigerator-water-filters') || 
            hit.collections.includes('water-filter-parts-with-models')
          )
        ?  html`
            <div class="waterfilter-lgo">
              <div>
                ${html`<div>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="147" height="160" viewBox="0 0 147 160" fill="none">
                      <path d="M0 0H147V98.2035C147 100.606 145.92 102.881 144.059 104.401L78.559 157.87C75.6146 160.274 71.3854 160.274 68.441 157.87L2.94099 104.401C1.07981 102.881 0 100.606 0 98.2035V0Z" fill="#CA1C00"></path>
                      <path d="M38.488 58.69C37.66 58.69 36.786 58.6287 35.866 58.506C34.946 58.414 34.0567 58.276 33.198 58.092C32.3393 57.908 31.5573 57.7087 30.852 57.494C30.1467 57.2793 29.5947 57.08 29.196 56.896L30.53 51.192C31.3273 51.5293 32.3393 51.8973 33.566 52.296C34.8233 52.664 36.372 52.848 38.212 52.848C40.328 52.848 41.8767 52.4493 42.858 51.652C43.8393 50.8547 44.33 49.7813 44.33 48.432C44.33 47.604 44.146 46.914 43.778 46.362C43.4407 45.7793 42.9653 45.3193 42.352 44.982C41.7387 44.614 41.0027 44.3687 40.144 44.246C39.316 44.0927 38.4267 44.016 37.476 44.016H34.808V38.496H37.844C38.5187 38.496 39.1627 38.4347 39.776 38.312C40.42 38.1893 40.9873 37.99 41.478 37.714C41.9687 37.4073 42.352 37.0087 42.628 36.518C42.9347 35.9967 43.088 35.3527 43.088 34.586C43.088 34.0033 42.9653 33.4973 42.72 33.068C42.4747 32.6387 42.1527 32.286 41.754 32.01C41.386 31.734 40.9413 31.5347 40.42 31.412C39.9293 31.2587 39.4233 31.182 38.902 31.182C37.5833 31.182 36.3567 31.3813 35.222 31.78C34.118 32.1787 33.106 32.6693 32.186 33.252L29.748 28.238C30.2387 27.9313 30.806 27.6093 31.45 27.272C32.1247 26.9347 32.8607 26.628 33.658 26.352C34.4553 26.076 35.2987 25.846 36.188 25.662C37.108 25.478 38.074 25.386 39.086 25.386C40.9567 25.386 42.5667 25.616 43.916 26.076C45.296 26.5053 46.4307 27.134 47.32 27.962C48.2093 28.7593 48.8687 29.71 49.298 30.814C49.7273 31.8873 49.942 33.068 49.942 34.356C49.942 35.6133 49.5893 36.84 48.884 38.036C48.1787 39.2013 47.228 40.0907 46.032 40.704C47.688 41.3787 48.9607 42.3907 49.85 43.74C50.77 45.0587 51.23 46.6533 51.23 48.524C51.23 49.996 50.9847 51.3607 50.494 52.618C50.0033 53.8447 49.2367 54.918 48.194 55.838C47.1513 56.7273 45.8173 57.4327 44.192 57.954C42.5973 58.4447 40.696 58.69 38.488 58.69ZM55.9845 32.746C56.8739 32.378 57.7939 31.964 58.7445 31.504C59.7259 31.0133 60.6765 30.492 61.5965 29.94C62.5165 29.3573 63.3905 28.7593 64.2185 28.146C65.0772 27.502 65.8439 26.8273 66.5185 26.122H71.3025V58H64.4485V35.046C63.5285 35.6593 62.5012 36.2267 61.3665 36.748C60.2319 37.2387 59.1279 37.668 58.0545 38.036L55.9845 32.746ZM95.4231 34.31C95.4231 37.1927 94.6871 39.4007 93.2151 40.934C91.7431 42.4673 89.7651 43.234 87.2811 43.234C84.7971 43.234 82.8191 42.4673 81.3471 40.934C79.8751 39.4007 79.1391 37.1927 79.1391 34.31C79.1391 31.4273 79.8751 29.2193 81.3471 27.686C82.8191 26.1527 84.7971 25.386 87.2811 25.386C89.7651 25.386 91.7431 26.1527 93.2151 27.686C94.6871 29.2193 95.4231 31.4273 95.4231 34.31ZM90.2251 34.31C90.2251 32.746 89.9491 31.6113 89.3971 30.906C88.8451 30.2007 88.1397 29.848 87.2811 29.848C86.3917 29.848 85.6711 30.2007 85.1191 30.906C84.5977 31.6113 84.3371 32.746 84.3371 34.31C84.3371 35.874 84.5977 37.024 85.1191 37.76C85.6711 38.4653 86.3917 38.818 87.2811 38.818C88.1397 38.818 88.8451 38.4653 89.3971 37.76C89.9491 37.024 90.2251 35.874 90.2251 34.31ZM104.393 26.122H110.787L92.8011 58H86.4071L104.393 26.122ZM118.147 49.812C118.147 52.6947 117.411 54.9027 115.939 56.436C114.467 57.9693 112.489 58.736 110.005 58.736C107.521 58.736 105.543 57.9693 104.071 56.436C102.599 54.9027 101.863 52.6947 101.863 49.812C101.863 46.9293 102.599 44.7213 104.071 43.188C105.543 41.6547 107.521 40.888 110.005 40.888C112.489 40.888 114.467 41.6547 115.939 43.188C117.411 44.7213 118.147 46.9293 118.147 49.812ZM112.949 49.812C112.949 48.248 112.673 47.1133 112.121 46.408C111.569 45.7027 110.864 45.35 110.005 45.35C109.116 45.35 108.395 45.7027 107.843 46.408C107.322 47.1133 107.061 48.248 107.061 49.812C107.061 51.376 107.322 52.526 107.843 53.262C108.395 53.9673 109.116 54.32 110.005 54.32C110.864 54.32 111.569 53.9673 112.121 53.262C112.673 52.526 112.949 51.376 112.949 49.812ZM38.128 83.344C38.128 84.976 38.32 86.448 38.704 87.76C39.12 89.072 39.696 90.208 40.432 91.168C41.2 92.096 42.128 92.816 43.216 93.328C44.304 93.84 45.552 94.096 46.96 94.096C48.336 94.096 49.568 93.84 50.656 93.328C51.776 92.816 52.704 92.096 53.44 91.168C54.208 90.208 54.784 89.072 55.168 87.76C55.584 86.448 55.792 84.976 55.792 83.344C55.792 81.712 55.584 80.24 55.168 78.928C54.784 77.584 54.208 76.448 53.44 75.52C52.704 74.56 51.776 73.824 50.656 73.312C49.568 72.8 48.336 72.544 46.96 72.544C45.552 72.544 44.304 72.816 43.216 73.36C42.128 73.872 41.2 74.608 40.432 75.568C39.696 76.496 39.12 77.632 38.704 78.976C38.32 80.288 38.128 81.744 38.128 83.344ZM63.52 83.344C63.52 86.192 63.088 88.704 62.224 90.88C61.392 93.024 60.24 94.832 58.768 96.304C57.296 97.744 55.536 98.832 53.488 99.568C51.472 100.304 49.296 100.672 46.96 100.672C44.688 100.672 42.544 100.304 40.528 99.568C38.512 98.832 36.752 97.744 35.248 96.304C33.744 94.832 32.56 93.024 31.696 90.88C30.832 88.704 30.4 86.192 30.4 83.344C30.4 80.496 30.848 78 31.744 75.856C32.64 73.68 33.84 71.856 35.344 70.384C36.88 68.912 38.64 67.808 40.624 67.072C42.64 66.336 44.752 65.968 46.96 65.968C49.232 65.968 51.376 66.336 53.392 67.072C55.408 67.808 57.168 68.912 58.672 70.384C60.176 71.856 61.36 73.68 62.224 75.856C63.088 78 63.52 80.496 63.52 83.344ZM68.3219 100V66.736H90.5939V73.024H75.8099V79.984H88.9619V86.272H75.8099V100H68.3219ZM94.4444 100V66.736H116.716V73.024H101.932V79.984H115.084V86.272H101.932V100H94.4444Z" fill="white"></path>
                    </svg>
                    
                          </div>
                        </div>`}
                      </div>
                    </div>`
          : ``}


      ${hit.product_type !== "Model" &&
 !hit.collections.includes("lg-refrigerator-water-filters")
  ? html`
      <div class="percenttag">
        <svg xmlns="http://www.w3.org/2000/svg" width="147" height="160" viewBox="0 0 147 160" fill="none">
<path d="M0 0H147V98.2035C147 100.606 145.92 102.881 144.059 104.401L78.559 157.87C75.6146 160.274 71.3854 160.274 68.441 157.87L2.94099 104.401C1.07981 102.881 0 100.606 0 98.2035V0Z" fill="#CA1C00"/>
<path d="M30.2952 41.846V46H15.9422V24.517H20.7782V41.846H30.2952ZM35.9355 35.243C35.9355 36.297 36.0595 37.2477 36.3075 38.095C36.5762 38.9423 36.9482 39.676 37.4235 40.296C37.9195 40.8953 38.5188 41.3603 39.2215 41.691C39.9242 42.0217 40.7302 42.187 41.6395 42.187C42.5282 42.187 43.3238 42.0217 44.0265 41.691C44.7498 41.3603 45.3492 40.8953 45.8245 40.296C46.3205 39.676 46.6925 38.9423 46.9405 38.095C47.2092 37.2477 47.3435 36.297 47.3435 35.243C47.3435 34.189 47.2092 33.2383 46.9405 32.391C46.6925 31.523 46.3205 30.7893 45.8245 30.19C45.3492 29.57 44.7498 29.0947 44.0265 28.764C43.3238 28.4333 42.5282 28.268 41.6395 28.268C40.7302 28.268 39.9242 28.4437 39.2215 28.795C38.5188 29.1257 37.9195 29.601 37.4235 30.221C36.9482 30.8203 36.5762 31.554 36.3075 32.422C36.0595 33.2693 35.9355 34.2097 35.9355 35.243ZM52.3345 35.243C52.3345 37.0823 52.0555 38.7047 51.4975 40.11C50.9602 41.4947 50.2162 42.6623 49.2655 43.613C48.3148 44.543 47.1782 45.2457 45.8555 45.721C44.5535 46.1963 43.1482 46.434 41.6395 46.434C40.1722 46.434 38.7875 46.1963 37.4855 45.721C36.1835 45.2457 35.0468 44.543 34.0755 43.613C33.1042 42.6623 32.3395 41.4947 31.7815 40.11C31.2235 38.7047 30.9445 37.0823 30.9445 35.243C30.9445 33.4037 31.2338 31.7917 31.8125 30.407C32.3912 29.0017 33.1662 27.8237 34.1375 26.873C35.1295 25.9223 36.2662 25.2093 37.5475 24.734C38.8495 24.2587 40.2135 24.021 41.6395 24.021C43.1068 24.021 44.4915 24.2587 45.7935 24.734C47.0955 25.2093 48.2322 25.9223 49.2035 26.873C50.1748 27.8237 50.9395 29.0017 51.4975 30.407C52.0555 31.7917 52.3345 33.4037 52.3345 35.243ZM69.548 26.811C69.796 27.6583 70.0647 28.6193 70.354 29.694C70.664 30.748 70.9843 31.8433 71.315 32.98C71.6663 34.1167 72.0177 35.2533 72.369 36.39C72.7203 37.5267 73.0613 38.5807 73.392 39.552C73.6607 38.498 73.9293 37.351 74.198 36.111C74.4873 34.871 74.756 33.5897 75.004 32.267C75.252 30.9443 75.4897 29.632 75.717 28.33C75.965 27.0073 76.1923 25.7363 76.399 24.517H81.421C80.6977 28.113 79.8607 31.7607 78.91 35.46C77.98 39.1593 76.9673 42.6727 75.872 46H71.439C70.7157 44.016 70.013 41.939 69.331 39.769C68.649 37.5783 67.9773 35.3877 67.316 33.197C66.6547 35.3877 65.9933 37.5783 65.332 39.769C64.6707 41.939 63.9783 44.016 63.255 46H58.822C57.7267 42.6727 56.7037 39.1593 55.753 35.46C54.823 31.7607 53.9963 28.113 53.273 24.517H58.512C58.7187 25.7363 58.946 27.0073 59.194 28.33C59.442 29.632 59.7003 30.9443 59.969 32.267C60.2377 33.5897 60.5063 34.871 60.775 36.111C61.0643 37.351 61.3537 38.498 61.643 39.552C62.015 38.5393 62.3767 37.4647 62.728 36.328C63.0793 35.1913 63.4203 34.0547 63.751 32.918C64.0817 31.7813 64.3813 30.686 64.65 29.632C64.9393 28.578 65.1977 27.6377 65.425 26.811H69.548ZM83.5985 46V24.517H98.1065V28.578H88.4345V32.794H97.0215V36.762H88.4345V41.939H98.8195V46H83.5985ZM107.327 42.311C108.009 42.311 108.567 42.2593 109.001 42.156C109.456 42.032 109.818 41.877 110.086 41.691C110.355 41.4843 110.541 41.2467 110.644 40.978C110.748 40.7093 110.799 40.4097 110.799 40.079C110.799 39.3763 110.469 38.7977 109.807 38.343C109.146 37.8677 108.009 37.3613 106.397 36.824C105.695 36.576 104.992 36.297 104.289 35.987C103.587 35.6563 102.956 35.2533 102.398 34.778C101.84 34.282 101.386 33.693 101.034 33.011C100.683 32.3083 100.507 31.461 100.507 30.469C100.507 29.477 100.693 28.5883 101.065 27.803C101.437 26.997 101.964 26.315 102.646 25.757C103.328 25.199 104.155 24.7753 105.126 24.486C106.098 24.176 107.193 24.021 108.412 24.021C109.859 24.021 111.109 24.176 112.163 24.486C113.217 24.796 114.085 25.137 114.767 25.509L113.372 29.322C112.773 29.012 112.101 28.7433 111.357 28.516C110.634 28.268 109.756 28.144 108.722 28.144C107.565 28.144 106.728 28.3093 106.211 28.64C105.715 28.95 105.467 29.4357 105.467 30.097C105.467 30.4897 105.56 30.8203 105.746 31.089C105.932 31.3577 106.191 31.6057 106.521 31.833C106.873 32.0397 107.265 32.236 107.699 32.422C108.154 32.5873 108.65 32.763 109.187 32.949C110.303 33.3623 111.275 33.7757 112.101 34.189C112.928 34.5817 113.61 35.0467 114.147 35.584C114.705 36.1213 115.119 36.7517 115.387 37.475C115.656 38.1983 115.79 39.0767 115.79 40.11C115.79 42.1147 115.088 43.675 113.682 44.791C112.277 45.8863 110.159 46.434 107.327 46.434C106.377 46.434 105.519 46.372 104.754 46.248C103.99 46.1447 103.308 46.0103 102.708 45.845C102.13 45.6797 101.623 45.504 101.189 45.318C100.776 45.132 100.425 44.9563 100.135 44.791L101.499 40.947C102.14 41.2983 102.925 41.6187 103.855 41.908C104.806 42.1767 105.963 42.311 107.327 42.311ZM133.91 24.517V28.64H127.431V46H122.595V28.64H116.116V24.517H133.91ZM40.1195 55.269C43.3229 55.269 45.7822 55.8373 47.4975 56.974C49.2129 58.09 50.0705 59.9293 50.0705 62.492C50.0705 65.0753 49.2025 66.9457 47.4665 68.103C45.7305 69.2397 43.2505 69.808 40.0265 69.808H38.5075V77H33.6715V55.827C34.7255 55.6203 35.8415 55.4757 37.0195 55.393C38.1975 55.3103 39.2309 55.269 40.1195 55.269ZM40.4295 59.392C40.0782 59.392 39.7269 59.4023 39.3755 59.423C39.0449 59.4437 38.7555 59.4643 38.5075 59.485V65.685H40.0265C41.7005 65.685 42.9612 65.4577 43.8085 65.003C44.6559 64.5483 45.0795 63.701 45.0795 62.461C45.0795 61.8617 44.9659 61.3657 44.7385 60.973C44.5319 60.5803 44.2219 60.2703 43.8085 60.043C43.4159 59.795 42.9302 59.6297 42.3515 59.547C41.7729 59.4437 41.1322 59.392 40.4295 59.392ZM58.9847 55.269C62.2087 55.269 64.6784 55.8477 66.3937 57.005C68.1091 58.1417 68.9667 59.919 68.9667 62.337C68.9667 63.8457 68.6154 65.0753 67.9127 66.026C67.2307 66.956 66.2387 67.6897 64.9367 68.227C65.3707 68.7643 65.8254 69.3843 66.3007 70.087C66.7761 70.769 67.2411 71.4923 67.6957 72.257C68.1711 73.001 68.6257 73.7863 69.0597 74.613C69.4937 75.419 69.8967 76.2147 70.2687 77H64.8437C64.4511 76.2973 64.0481 75.5843 63.6347 74.861C63.2421 74.1377 62.8287 73.435 62.3947 72.753C61.9814 72.071 61.5681 71.4303 61.1547 70.831C60.7414 70.211 60.3281 69.653 59.9147 69.157H57.5277V77H52.6917V55.827C53.7457 55.6203 54.8307 55.4757 55.9467 55.393C57.0834 55.3103 58.0961 55.269 58.9847 55.269ZM59.2637 59.392C58.9124 59.392 58.5921 59.4023 58.3027 59.423C58.0341 59.4437 57.7757 59.4643 57.5277 59.485V65.313H58.8917C60.7104 65.313 62.0124 65.0857 62.7977 64.631C63.5831 64.1763 63.9757 63.4013 63.9757 62.306C63.9757 61.252 63.5727 60.508 62.7667 60.074C61.9814 59.6193 60.8137 59.392 59.2637 59.392ZM72.4385 55.517H77.2745V77H72.4385V55.517ZM91.1131 77.434C87.6204 77.434 84.9544 76.4627 83.1151 74.52C81.2964 72.5773 80.3871 69.8183 80.3871 66.243C80.3871 64.4657 80.6661 62.8847 81.2241 61.5C81.7821 60.0947 82.5468 58.9167 83.5181 57.966C84.4894 56.9947 85.6468 56.261 86.9901 55.765C88.3334 55.269 89.7904 55.021 91.3611 55.021C92.2704 55.021 93.0971 55.0933 93.8411 55.238C94.5851 55.362 95.2361 55.517 95.7941 55.703C96.3521 55.8683 96.8171 56.044 97.1891 56.23C97.5611 56.416 97.8298 56.5607 97.9951 56.664L96.6001 60.57C95.9388 60.2187 95.1638 59.919 94.2751 59.671C93.4071 59.423 92.4151 59.299 91.2991 59.299C90.5551 59.299 89.8214 59.423 89.0981 59.671C88.3954 59.919 87.7651 60.322 87.2071 60.88C86.6698 61.4173 86.2358 62.12 85.9051 62.988C85.5744 63.856 85.4091 64.91 85.4091 66.15C85.4091 67.142 85.5124 68.072 85.7191 68.94C85.9464 69.7873 86.2978 70.521 86.7731 71.141C87.2691 71.761 87.9098 72.257 88.6951 72.629C89.4804 72.9803 90.4311 73.156 91.5471 73.156C92.2498 73.156 92.8801 73.1147 93.4381 73.032C93.9961 72.9493 94.4921 72.8563 94.9261 72.753C95.3601 72.629 95.7424 72.4947 96.0731 72.35C96.4038 72.2053 96.7034 72.071 96.9721 71.947L98.3051 75.822C97.6231 76.2353 96.6621 76.6073 95.4221 76.938C94.1821 77.2687 92.7458 77.434 91.1131 77.434ZM100.489 77V55.517H114.997V59.578H105.325V63.794H113.912V67.762H105.325V72.939H115.71V77H100.489ZM37.3843 108V86.517H51.8923V90.578H42.2203V94.794H50.8073V98.762H42.2203V103.939H52.6053V108H37.3843ZM61.9731 108C61.1258 106.202 60.2888 104.332 59.4621 102.389C58.6354 100.446 57.8501 98.5243 57.1061 96.623C56.3621 94.7217 55.6698 92.903 55.0291 91.167C54.4091 89.431 53.8718 87.881 53.4171 86.517H58.7491C59.1624 87.757 59.6068 89.1003 60.0821 90.547C60.5781 91.973 61.0741 93.399 61.5701 94.825C62.0868 96.251 62.5828 97.615 63.0581 98.917C63.5334 100.219 63.9778 101.345 64.3911 102.296C64.7838 101.345 65.2178 100.219 65.6931 98.917C66.1891 97.615 66.6851 96.251 67.1811 94.825C67.6978 93.399 68.1938 91.973 68.6691 90.547C69.1651 89.1003 69.6198 87.757 70.0331 86.517H75.1791C74.7038 87.881 74.1561 89.431 73.5361 91.167C72.9161 92.903 72.2341 94.7217 71.4901 96.623C70.7461 98.5243 69.9608 100.446 69.1341 102.389C68.3074 104.332 67.4704 106.202 66.6231 108H61.9731ZM77.0292 108V86.517H91.5372V90.578H81.8652V94.794H90.4522V98.762H81.8652V103.939H92.2502V108H77.0292ZM101.192 86.269C104.416 86.269 106.886 86.8477 108.601 88.005C110.316 89.1417 111.174 90.919 111.174 93.337C111.174 94.8457 110.823 96.0753 110.12 97.026C109.438 97.956 108.446 98.6897 107.144 99.227C107.578 99.7643 108.033 100.384 108.508 101.087C108.983 101.769 109.448 102.492 109.903 103.257C110.378 104.001 110.833 104.786 111.267 105.613C111.701 106.419 112.104 107.215 112.476 108H107.051C106.658 107.297 106.255 106.584 105.842 105.861C105.449 105.138 105.036 104.435 104.602 103.753C104.189 103.071 103.775 102.43 103.362 101.831C102.949 101.211 102.535 100.653 102.122 100.157H99.735V108H94.899V86.827C95.953 86.6203 97.038 86.4757 98.154 86.393C99.2906 86.3103 100.303 86.269 101.192 86.269ZM101.471 90.392C101.12 90.392 100.799 90.4023 100.51 90.423C100.241 90.4437 99.983 90.4643 99.735 90.485V96.313H101.099C102.918 96.313 104.22 96.0857 105.005 95.631C105.79 95.1763 106.183 94.4013 106.183 93.306C106.183 92.252 105.78 91.508 104.974 91.074C104.189 90.6193 103.021 90.392 101.471 90.392Z" fill="white"/>
</svg>
      </div>
    `
  : html``}



      ${hit.tags == 'Top Selling'
       ? html`<img class="bestSeller" src="https://cdn.shopify.com/s/files/1/0700/0293/3937/files/Frame_1000002794.png?v=1747208208" alt="" />`
      : ``}
    
      
        <img
          class="ais-hit--picture got"
          src="${newImage}"
          alt="${hit.title} - ${hit.variant_title}"
          defaultImage="${hit.vendor}"
        />


        ${
          hit.sku?.trim() !== '' &&
            hit.sku?.replace(/[-_]/g, '').trim().toLowerCase() === inputValue1?.replace(/[-_]/g, '').trim().toLowerCase()
              ? html`<img
                  src="https://cdn.shopify.com/s/files/1/0700/0293/3937/files/exact-match.svg?v=1750412494"
                  alt="Exact Match"
                  class="exact-match-logo 1"
                />`
              : ''
          }
        

        <div class="ais-hit--details">
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              onclick="void(0)"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>
          <p
            class="ais-hit--subtitle gdgd2"
            title="${hit.product_type === 'NLA' ? 'Part' : hit.product_type}"
          >
            ${hit.product_type === 'NLA' ? 'Part' : hit.product_type}
          </p>

          
<div class="part-info-container-xyz">
          <div class="part-info-block-xyz">
              <p class="part-info-label-xyz  2">${hit.product_type == 'Part' || hit.product_type === 'NLA' ? 'Part':'Model' }  Number <span class="part-info-value-xyz">${hit.sku &&
                html`
                <span class="algolia-sku rrg">${components.Highlight({ attribute: 'sku', hit })}</span>
              `}</span></p>
          </div> 
          
          <div class="compatible-models-block-xyz">
  ${
    hit.product_type === 'Part' && hit.meta?.custom?.compmodelcount
      ? html`
          <p class="compatible-heading-xyz">Compatible Models</p>
          <a href="/products/${hit.handle}" class="view-models-btn-xyz">
            View All ${hit.meta?.custom?.compmodelcount} Models
          </a>
        `
      : hit.product_type === 'Part'
      ? html`
          <p class="compatible-heading-xyz">Compatible Models</p><p class="view-models-btn-xyz">N/A</p>
        `
      : ''
  }

  ${
    hit.product_type === 'Model' && hit.meta?.custom?.ari_id
      ? html`
          <p class="compatible-heading-xyz">Exploded View</p>
          <a
            href="/pages/exploded-views-assembly?ariId=${hit.meta?.custom?.ari_id}&mfg=${Brand_Line}"
            class="view-models-btn-xyz"
          >
            View
          </a>
        `
      : hit.product_type === 'Model'
      ? html`
          <p class="compatible-heading-xyz">Exploded View</p><p class="view-models-btn-xyz">N/A</p>
        `
      : ''
  }
</div>
  

            ${hit.product_type === 'Part' && hit.meta?.custom?.skilllevel
              ? (() => {
                  const level = parseInt(hit.meta.custom.skilllevel);
                  if (!level || level < 1 || level > 5) return ``;
            
                  const filledIcon = `https://cdn.shopify.com/s/files/1/0700/0293/3937/files/arcticons_samsung-self-repair-assistant.png?v=1745585321`;
                  const emptyIcon = `https://cdn.shopify.com/s/files/1/0700/0293/3937/files/arcticons_samsung-self-repair-assistant_1.png?v=1745585320`;
            
                  // Generate 5 icons: first `level` filled, rest empty
                  const icons = Array.from({ length: 5 }, (_, i) =>
                    html`<span class="repair-icon-xyz"><img src="${i < level ? filledIcon : emptyIcon}" /></span>`
                  );
            
                  return html`
                    <div class="repair-difficulty-block-xyz">
                      <p class="repair-heading-xyz">Repair Difficulty</p>
                      <div class="repair-icon-set-xyz">
                        ${icons}
                      </div>
                    </div>
                  `;
                })()
              : hit.product_type === 'Part'
                ? (() => {
              
                    return html`
                      <div class="repair-difficulty-block-xyz">
                        <p class="repair-heading-xyz">Repair Difficulty</p>
                        <div class="repair-icon-set-xyz">
                        N/A
                        </div>
                      </div>
                    `;
                  })()
                : ``}

        
    
</div>
 <div class="pdt-description">
     ${
    hit.body_html_safe
      ? html`
            <div class="pdt-headng">
              ${hit.product_type === 'Model' ? 'Model Description' : 'Part Description'}
            </div>
            <div class="readmore-desc">
              <p class="product-desct" id="productDesc">
                ${components.Highlight({ attribute: 'body_html_safe', hit })}
              </p>
            </div>
        `
      : html`
            <div class="pdt-headng">
              ${hit.product_type === 'Model' ? 'Model Description' : 'Part Description'}
            </div>
            <div class="readmore-desc">
              <p class="product-desct" id="productDesc">
                N/A
              </p>
            </div>
        `
  }

      </div><p class="ais-hit--price">
          <b class="alg_price" algoi_price="${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}">
            ${typecomponents.props.parts[0][0].value == 'Model'
              ? ''
              : typecomponents.props.parts[0][0].value == 'part' &&
                algoliaShopify.helpers.displayPrice(hit, hit._distinct) > '1.0'
              ? ''
              : algoliaShopify.helpers.displayPrice(hit, hit._distinct) !== '$0.00'
              ? algoliaShopify.helpers.displayPrice(hit, hit._distinct)
              : ''}
          </b>

            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-striked"
                  ><span
                    >${algoliaShopify.helpers.displayStrikedPrice(
                      hit.price,
                      hit.compare_at_price
                    )}</span
                  ></span
                >
              `}
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-discount"
                  >${algoliaShopify.helpers.displayDiscount(
                    hit.price,
                    hit.compare_at_price,
                    hit.price_ratio
                  )}</span
                >
              `}
              ${hit.product_type === 'Part' && parseFloat(hit.price) > 0 && (!hit.meta?.substitute_parts || hit.meta.substitute_parts === '')
                ? html`<div class="stock-status">Available</div>`
                : ``}

          </p>
          
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
           
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
              tag =>
                html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
            )}
          </p>
         
              <form
                id="algolia-add-to-cart-${hit.objectID}"
                style="display: none;"
                action="/cart/add"
                method="post"
                enctype="multipart/form-data"
              >
                <input type="hidden" name="id" value="${hit.objectID}" />
              </form>

              <p class="ais-hit--cart">
                ${typecomponents.props.parts[0][0].value === 'Part' && hit.price != 0
                ? html`<button
                          class="ais-hit--cart-button"
                          data-form-id="algolia-add-to-cart-${hit.objectID}"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                              <path d="M2.37813 8.44832C2.41635 7.97218 2.6325 7.52791 2.98354 7.20398C3.33459 6.88004 3.79477 6.70022 4.27243 6.70032H15.7275C16.2052 6.70022 16.6654 6.88004 17.0164 7.20398C17.3675 7.52791 17.5836 7.97218 17.6218 8.44832L18.3847 17.9483C18.4057 18.2097 18.3723 18.4727 18.2867 18.7206C18.201 18.9685 18.065 19.196 17.8872 19.3887C17.7093 19.5815 17.4935 19.7353 17.2533 19.8406C17.013 19.9459 16.7536 20.0002 16.4913 20.0003H3.50863C3.24636 20.0002 2.98694 19.9459 2.74671 19.8406C2.50648 19.7353 2.29065 19.5815 2.11279 19.3887C1.93494 19.196 1.79892 18.9685 1.71329 18.7206C1.62767 18.4727 1.5943 18.2097 1.61528 17.9483L2.37813 8.44832Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M13.8001 9.55024V4.80024C13.8001 3.79242 13.3998 2.82588 12.6871 2.11324C11.9745 1.4006 11.008 1.00024 10.0001 1.00024C8.99231 1.00024 8.02577 1.4006 7.31313 2.11324C6.60049 2.82588 6.20013 3.79242 6.20013 4.80024V9.55024" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          Add To Cart
                        </button>`
               : (typecomponents.props.parts[0][0].value === 'Part' && hit.price == 0) || typecomponents.props.parts[0][0].value === 'NLA'
                  ?
                 (hit.meta)  // (hit.id === 8329630154929)
                  ? html`<a class="ais-hit--support-button gethandleByClassname" data-sku="${hit.meta.substitute_parts}" role="button">
                      View Detail
                    </a>`
                  : html`<a class="ais-hit--support-button" href="/products/${hit.handle}">
                      View Detail
                    </a>`   

                   : ``
              }


                ${typecomponents.props.parts[0][0].value == 'Model'  
                  ? html`<a
                      class="ais-hit--view-button"
                      href="/products/${hit.handle}"
                    >
                          View Model
                    </a>
                  `
                    : ``
                }
              </p>

           
        </div>
      </div>${hit.product_type == 'Model'
       ? html`<span class="add_profile" data-customer-id="" data-barCode="${hit.barcode}" ><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
<path d="M9.28571 5.71429H5.71429V9.28571C5.71429 9.47515 5.63903 9.65684 5.50508 9.79079C5.37112 9.92475 5.18944 10 5 10C4.81056 10 4.62888 9.92475 4.49492 9.79079C4.36097 9.65684 4.28571 9.47515 4.28571 9.28571V5.71429H0.714286C0.524845 5.71429 0.343164 5.63903 0.20921 5.50508C0.075255 5.37112 0 5.18944 0 5C0 4.81056 0.075255 4.62888 0.20921 4.49492C0.343164 4.36097 0.524845 4.28571 0.714286 4.28571H4.28571V0.714286C4.28571 0.524845 4.36097 0.343164 4.49492 0.209209C4.62888 0.0752547 4.81056 0 5 0C5.18944 0 5.37112 0.0752547 5.50508 0.209209C5.63903 0.343164 5.71429 0.524845 5.71429 0.714286V4.28571H9.28571C9.47515 4.28571 9.65684 4.36097 9.79079 4.49492C9.92475 4.62888 10 4.81056 10 5C10 5.18944 9.92475 5.37112 9.79079 5.50508C9.65684 5.63903 9.47515 5.71429 9.28571 5.71429Z" fill="#474747"/>
</svg></span>`
      : ``}

      ${hit.product_type == 'Part' || hit.product_type == 'NLA'
       ? html`<span class="eye-icon-svg quickViewPopup" data-handle="${hit.handle}" >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
                  <path d="M1 7.6C1 7.6 4.2 1 9.8 1C15.4 1 18.6 7.6 18.6 7.6C18.6 7.6 15.4 14.2 9.8 14.2C4.2 14.2 1 7.6 1 7.6Z" stroke="#474747" stroke-width="0.8" stroke-linecap="round"></path>
                  <path d="M9.80059 9.79984C11.0156 9.79984 12.0006 8.81487 12.0006 7.59984C12.0006 6.38481 11.0156 5.39984 9.80059 5.39984C8.58556 5.39984 7.60059 6.38481 7.60059 7.59984C7.60059 8.81487 8.58556 9.79984 9.80059 9.79984Z" stroke="#474747" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg><span class="loader-quick-view"></span>
              </span>`
      : ``}
      
      `;

  });





// algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', function(_defaultTemplate, html) {
//     console.log("_defaultTemplate",_defaultTemplate)

//      setTimeout(function () {
//     if ($('.ais-hit-empty--title').length > 0) {
//       $('.ais-Pagination-list').hide();
//     } else {
//       $('.ais-Pagination-list').show(); // optional: show if not empty
//     }
//   }, 100); // timeout ensures DOM is updated

//   return html`
//       <div class="ais-hits-container ais-results-as-block">
//        <div class="ais-Hits ais-Hits--empty">
//         <div class="ais-hit-empty">
//           <div class="ais-hit-empty--title">No result found</div>
//           <div class="ais-hit-empty--clears">Try  <a class="ais-hit-empty--clear-filters ais-link">clearing the filters  </a>or 
//              <a class="ais-hit-empty--clear-input ais-link">changing your input</a>
//             </div>
//           </div>
//         </div>
//       </div>
//     `;
  
//  });

document.addEventListener('click', function (e) {
  const product = e.target.closest('.ais-hit.ais-product');
  if (!product) return;

  // Extract price from the .alg_price element
  const priceElement = product.querySelector('.alg_price');
  let priceValue = priceElement ? priceElement.getAttribute('algoi_price') || priceElement.textContent.trim() : '';
  
  // Remove $ sign and convert to number
  priceValue = parseFloat(priceValue.replace(/[^0-9.]/g, '')) || 0;

  // Extract all relevant data attributes
  const productData = {
    handle: product.dataset.handle || '',
    variant_id: product.dataset.variantId || '',
    distinct: product.dataset.distinct || '',
    product_id: product.dataset.productId || '',
    barcode: product.dataset.barcode || '',
    product_type: product.dataset.productType || '',
    vendor: product.dataset.vendor || '',
    collection_name: product.dataset.collectionName || '',
    value: priceValue,              // ← Top-level value (as number)
    price: priceValue,              // ← Top-level price (as number)
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname
  };

  // Publish Shopify Pixel event
  if (window.Shopify?.analytics?.publish) {
    Shopify.analytics.publish('View_item', {
      customData: productData
    });
  }
});


 $(document).on('click',".modellistpara,.add_to_cart_encompass",function(){

      handleClick(this);
             
  });

  $(document).ready(function() {
   setTimeout(() => { 
   if (window.customerLoggedIn) {
  // console.log("Customer is logged in:", window.customerData);
  // console.log("Customer ID:", window.customerData.id);
      const customerID = window.customerData.id; // Fixed typo: cutomerID → customerID
  $('.add_profile').attr('data-customer-id', customerID);
} else {
  // console.log("Customer is not logged in");
}

}, "2000");

  });
   setTimeout(function () {
    if ($('.ais-hit-empty--title').length > 0) {
      $('.ais-Pagination-list').hide();
    } else {
      $('.ais-Pagination-list').show(); // optional: show if not empty
    }
  }, 100); // timeout ensures DOM is updated


 const paginationCheck = setInterval(() => {
  const hitsLength = $('.ais-Hits-item').length;

  if (hitsLength > 0) {
    if (hitsLength >= 32) {
      $('.ais-Pagination-list').show();
    } else {
      $('.ais-Pagination-list').hide();
    }

    clearInterval(paginationCheck); // stop checking once done
  }
}, 300); // check every 300ms


  
$(document).on('click',".ais-page .ais-facet-dropdown-wrapper .ais-range-slider--header",function(){
  $(this).toggleClass('active');
});
//add js

  
  (function () {
    // Ensure Shopify's product object is available
    if (typeof Shopify === 'undefined' || typeof meta === 'undefined' || !meta.product) return;
 
    const product = meta.product;
 
    // Construct product object
    const currentProduct = {
      id: product.variants[0].id,
      title: product.title,
      price: product.price, // in cents
      image: product.featured_image, // fallback if featured image not available
      productType: product.type,
      url: window.location.href
    };
 
    const storageKey = 'recently_viewed';
    let viewed = JSON.parse(localStorage.getItem(storageKey)) || [];
 
    // Remove if product already exists
    viewed = viewed.filter(p => p.id !== currentProduct.id);
 
    // Add to beginning
    viewed.unshift(currentProduct);
 
    // Limit to 10
    if (viewed.length > 10) viewed = viewed.slice(0, 10);
 
    // Save back
    localStorage.setItem(storageKey, JSON.stringify(viewed));
  })();

  // Pixel event tracking for search - Wait for Algolia to load
// Debug - Find the actual search input
// Pixel event tracking for InstantSearch only
(function() {

  function waitForInput() {
    const searchInput = document.querySelector('.ais-SearchBox-input');

    if (!searchInput) {
      return setTimeout(waitForInput, 300);
    }

    let searchTimeout;
    let lastTrackedValue = '';

    searchInput.addEventListener('input', function(e) {
      const currentValue = e.target.value.trim();

      clearTimeout(searchTimeout);

      searchTimeout = setTimeout(() => {

        if (!currentValue || currentValue === lastTrackedValue) return;

        lastTrackedValue = currentValue;

        if (!window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;

        setTimeout(() => {
          const visibleResults = document.querySelectorAll('.ais-hit').length;

          const eventData = {
            customData: {
              search_term: currentValue,
              results_count: visibleResults,
              page_location: window.location.href,
              page_title: document.title,
              page_path: window.location.pathname,
              interaction_type: 'search'
            }
          };

          Shopify.analytics.publish('Search_Products', eventData);

        }, 300);

      }, 800);
    });
  }

  waitForInput();

})();


// Single PLP Interactions Event Tracker - Corrected Version
(function() {
  // console.log('📊 PLP Interactions tracking started');
  
  // Single function to publish all PLP events
  function trackPLPInteraction(interactionType, interactionData) {
    if (!window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) {
      // console.error('❌ Shopify analytics not available');
      return;
    }
    
    const eventData = {
      customData: {
        interaction_type: interactionType,
        ...interactionData,
        page_location: window.location.href,
        page_title: document.title,
        page_path: window.location.pathname,
        timestamp: new Date().toISOString()
      }
    };
    
    // console.log(`📤 PLP_Interaction (${interactionType}):`, eventData);
    
    try {
      Shopify.analytics.publish('PLP_Interaction', eventData);
      // console.log(`✅ PLP_Interaction published: ${interactionType}`);
    } catch (error) {
      // console.error(`❌ Error publishing PLP_Interaction:`, error);
    }
  }
  
  // Helper function to extract product data from card
  function getProductData(productCard) {
    if (!productCard) return null;
    
    // Extract title (from the link text, removing highlight spans)
    const titleLink = productCard.querySelector('.ais-hit--title a');
    const productTitle = titleLink?.textContent?.trim() || 'Unknown';
    
    // Extract price (from the b tag)
    const priceElement = productCard.querySelector('.ais-hit--price b.alg_price');
    const productPrice = priceElement?.textContent?.trim() || '0';
    
    // Extract SKU (from the highlight span inside algolia-sku)
    const skuElement = productCard.querySelector('.algolia-sku .ais-Highlight');
    const productSKU = skuElement?.textContent?.trim() || '';
    
    // Get data attributes
    const productHandle = productCard.dataset.handle || '';
    const productType = productCard.dataset.productType || '';
    const productPosition = productCard.dataset.algoliaPosition || '';
    const variantId = productCard.dataset.variantId || '';
    const productId = productCard.dataset.productId || '';
    const barcode = productCard.dataset.barcode || '';
    const vendor = productCard.dataset.vendor || '';
    
    return {
      product_title: productTitle,
      product_price: productPrice,
      product_sku: productSKU,
      product_handle: productHandle,
      product_type: productType,
      product_position: productPosition,
      variant_id: variantId,
      product_id: productId,
      barcode: barcode,
      vendor: vendor
    };
  }
  
  setTimeout(() => {
    
    // Track ALL click interactions
    document.addEventListener('click', function(e) {
      
      // 1. QUICK VIEW EYE ICON
      const quickViewIcon = e.target.closest('.quickViewPopup, .eye-icon-svg');
      if (quickViewIcon) {
        const productHandle = quickViewIcon.dataset.handle || quickViewIcon.getAttribute('data-handle');
        const productCard = quickViewIcon.closest('.ais-hit, .ais-product');
        const productData = getProductData(productCard);
        
        // console.log('👁️ Quick view clicked:', productHandle);
        
        trackPLPInteraction('quick_view', {
          product_handle: productHandle,
          ...productData
        });
        return;
      }
      
      // 2. CUSTOM FILTER BUTTONS (All, Parts, Models)
      const customFilterBtn = e.target.closest('.custom-filter-button');
      if (customFilterBtn) {
        const filterValue = customFilterBtn.textContent.trim();
        // console.log('🔘 Custom filter clicked:', filterValue);
        
        trackPLPInteraction('filter_click', {
          filter_type: 'Product Type (Custom)',
          filter_value: filterValue,
          action: 'select'
        });
        return;
      }
      
      // 3. REGULAR FILTERS - Click on the checkbox input or label
      const filterCheckbox = e.target.closest('input[type="checkbox"]');
      const filterLabelClick = e.target.closest('.ais-RefinementList-label');
      
      if (filterCheckbox && filterCheckbox.closest('.ais-RefinementList-item')) {
        const filterItem = filterCheckbox.closest('.ais-RefinementList-item');
        const filterLabel = filterItem.querySelector('.ais-RefinementList-label');
        const filterText = filterLabel?.textContent.replace(/\d+/g, '').trim() || 'Unknown';
        const filterContainer = filterCheckbox.closest('.ais-facet-dropdown-wrapper');
        const filterType = filterContainer?.querySelector('.ais-facet--header')?.textContent?.trim() || 'Unknown';
        const isChecked = filterCheckbox.checked;
        
        // console.log('☑️ Filter checkbox clicked:', filterType, '-', filterText, isChecked ? 'checked' : 'unchecked');
        
        trackPLPInteraction('filter_click', {
          filter_type: filterType,
          filter_value: filterText,
          action: isChecked ? 'select' : 'deselect'
        });
        return;
      }
      
      if (filterLabelClick && filterLabelClick.closest('.ais-RefinementList-item')) {
        const filterText = filterLabelClick.textContent.replace(/\d+/g, '').trim();
        const filterContainer = filterLabelClick.closest('.ais-facet-dropdown-wrapper');
        const filterType = filterContainer?.querySelector('.ais-facet--header')?.textContent?.trim() || 'Unknown';
        
        // console.log('🔘 Filter label clicked:', filterType, '-', filterText);
        
        trackPLPInteraction('filter_click', {
          filter_type: filterType,
          filter_value: filterText,
          action: 'toggle'
        });
        return;
      }
      
      // 4. CLEAR FILTERS BUTTON
      const clearBtn = e.target.closest('.ais-ClearRefinements-button');
      if (clearBtn && !clearBtn.disabled) {
        // console.log('🗑️ Clear filters clicked');
        
        trackPLPInteraction('clear_filters', {
          action: 'clear_all'
        });
        return;
      }
      
      // 5. PRODUCT CLICKS (but not quick view or add to cart)
      const productLink = e.target.closest('.ais-hit--title a');
      if (productLink && !e.target.closest('.quickViewPopup') && !e.target.closest('.ais-hit--cart-button')) {
        const productCard = productLink.closest('.ais-hit, .ais-product');
        const productData = getProductData(productCard);
        
        // console.log('🖱️ Product clicked:', productData);
        
        trackPLPInteraction('product_click', productData);
        return;
      }
      
      // 6. ADD TO CART FROM PLP
      const addToCartBtn = e.target.closest('.ais-hit--cart-button');
      if (addToCartBtn) {
        const productCard = addToCartBtn.closest('.ais-hit, .ais-product');
        const productData = getProductData(productCard);
        
        // console.log('🛒 Add to cart clicked:', productData);
        
        trackPLPInteraction('add_to_cart', productData);
        return;
      }
      
      // 7. PAGINATION CLICKS
      const paginationLink = e.target.closest('.ais-Pagination-link');
      if (paginationLink) {
        const pageNumber = paginationLink.textContent.trim();
        const isNext = paginationLink.classList.contains('ais-Pagination-link--next');
        const isPrev = paginationLink.classList.contains('ais-Pagination-link--previous');
        
        // console.log('📄 Pagination clicked:', pageNumber);
        
        trackPLPInteraction('pagination_click', {
          page_number: isNext ? 'next' : isPrev ? 'previous' : pageNumber,
          action: isNext ? 'next_page' : isPrev ? 'previous_page' : 'specific_page'
        });
        return;
      }
      
      // 8. VIEW TOGGLE (Grid/List)
      const viewToggle = e.target.closest('.ais-change-display span');
      if (viewToggle) {
        const viewType = viewToggle.classList.contains('ais-change-display-block') ? 'grid' : 'list';
        
        // console.log('👁️ View toggle clicked:', viewType);
        
        trackPLPInteraction('view_toggle', {
          view_type: viewType
        });
        return;
      }
      
      // 9. FILTER DROPDOWN HEADERS (Expand/Collapse)
      const filterHeader = e.target.closest('label.ais-facet--header');
      if (filterHeader) {
        const filterName = filterHeader.textContent.trim();
        const isActive = filterHeader.classList.contains('active');
        
        // console.log('📂 Filter dropdown toggled:', filterName, isActive ? 'closing' : 'opening');
        
        trackPLPInteraction('filter_dropdown_toggle', {
          filter_name: filterName,
          action: isActive ? 'close' : 'open'
        });
        return;
      }
      
    }, true); // Use capture phase
    
    
    // 10. SORT CHANGES
    const sortSelect = document.querySelector('.ais-sort-orders-container select, .ais-SortBy-select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function(e) {
        const sortValue = e.target.value;
        const sortText = e.target.options[e.target.selectedIndex]?.text || sortValue;
        
        // console.log('⬇️ Sort changed:', sortText);
        
        trackPLPInteraction('sort_change', {
          sort_option: sortText,
          sort_value: sortValue
        });
      });
      // console.log('✅ Sort tracking attached');
    }
    
    
    // console.log('🎉 PLP Interactions tracking initialized');
    // console.log('✅ All product data will be extracted correctly');
    
  }, 2000);
  
})();
// var metafield_Model = "{{ collection.metafields.custom.brand_title }}";
// console.log("metafield_Model",metafield_Model)
  
// var storefrontAccessToken = "ad652a74eb9b4c8cc3d7c521feaa9e06"; 
//   async function searchProDetails() {
//   console.log("userInput inside the function api ")
//   // console.log("search_tag inside the function api ", search_tag);

//   const response = fetch(
//     "https://grp-site.myshopify.com/api/2023-04/graphql.json",
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
//       },

//       body: JSON.stringify({
//         query: `{
//                   products(first: 50 query: "sku:*VR65704LVM* ") {
//                     nodes {
//                       handle
//                       variants(first: 50) {
//                         nodes {
//                           sku
//                           id
//                         }
//                       }
//                     }
//                   }
//                 }
//                                             `,
//       }),
//     }
//   )
//     // console.log("response",response)

//     // const result = await response.json();
//     .then((response) => response.json()) // Resolving the JSON promise
//     .then((data) => {
//       console.log("response444>>>>>>", data);
      
//     })
//     .catch((error) => {
//       console.error("Error:", error);
//     });


// }
// searchProDetails()
//  $( document ).ready(function() {
//     console.log( "ready!" );
//     var currentUrl = window.location.href;

// // Check if the URL contains the term 'accessories'
// if (currentUrl.includes('accessories')) {
//     $('.Product_type_check').css('display','none')
// }
// // if (currentUrl.includes('Adaptor & Charger')) {
// //     $('.Product_type_check').css('display','none')
// // }  
  
// if(brandTitle == 'remote-control' || brandTitle == 'ice-maker' || brandTitle == 'water-filters' || brandTitle == 'waste-disposer' || brandTitle == 'batteries' || brandTitle == 'adaptor-charger' ){
//   // console.log("display None Button ")
//   $('.Product_type_check').css('display','none')
// }
  
//   function relocate(id){
//     console.log("id>>>",id)
    
//     var finalPath,currentUrl = window.location,
//         PathUrl = currentUrl.origin + currentUrl.pathname,
//         SUrl ="?refinementList%5Bproduct_type%5D%5B0%5D=";
//         $(".Product_type_check label.ais-RefinementList-label").removeClass('active');
    
//     // for onload add class
//     if(id =="Null"){
//         if(currentUrl.search == SUrl+"Part"){
//           // console.log("part url ")
//           window.location.href =  currentUrl+'&sortBy=shopifyps_products_recently_ordered_count_desc';
//           $("#Part").addClass("active")
//         }else if(currentUrl.search == SUrl+"Model"){
//           $("#Model").addClass("active")
//         }else{
//           $("#All").addClass("active")
//         }
// // console.log("currentUrl.search",currentUrl.search)
//       if(currentUrl.search == '?refinementList%5Bproduct_type%5D%5B0%5D=Part&sortBy=shopifyps_products_recently_ordered_count_desc' ){
//         $("#Part").addClass("active")
//         $("#All").removeClass('active');
//       }
  
//     }  

//     // when click add class and relocate 
//     if(id != "Null"){
      
//         if(id == 'Part' || id == 'Model'){
//            $("#"+id).addClass("active")
//            finalPath = PathUrl + SUrl + id
//          // console.log(id, finalPath)
//            window.location.replace(finalPath)
//         }
//         else if(id == 'All'){
//           $("#"+id).addClass("active")
//           // console.log(id, PathUrl)
//           window.location.replace(PathUrl)
//         }
//     }
//   }

//   relocate('Null');
// });


  // algoliaShopify.hooks.registerHook('beforeAutocompleteSuggestionsTemplate', function(_defaultTemplate, templateOptions) {
  //   console.log("templateOptions",templateOptions)
  //   const { html, state } = templateOptions;
  //   console.log("html:",html,"state:",state)
  //   return html`
  //     <a
  //       class="aa-ItemLink aa-ItemWrapper"
  //       href="${window.Shopify.routes.root}search?q=${item.query}"
  //     >
  //       <div class="aa-ItemContent">
  //         <div class="aa-ItemIcon aa-ItemIcon--noBorder">
  //           <svg viewBox="0 0 24 24" fill="currentColor">
  //             <path d="M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z" />
  //           </svg>
  //         </div>
  //         <div class="aa-ItemContentBody">
  //           <div class="aa-ItemContentTitle">
  //             ${components.Highlight({ hit: item, attribute: 'query' })}
  //           </div>
  //         </div>
  //       </div>
  //       <div class="aa-ItemActions">
  //         <button
  //           class="aa-ItemActionButton"
  //           title={"Fill query with ${item.query}"}
  //         >
  //           <svg viewBox="0 0 24 24" fill="currentColor">
  //             <path d="M8 17v-7.586l8.293 8.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-8.293-8.293h7.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-10c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1z" />
  //           </svg>
  //         </button>
  //       </div>
  //     </a>
  //   `;
  // });


// algoliaShopify.hooks.registerHook('beforeAutocompleteMainProductsTemplate', function(_defaultTemplate, templateOptions, elements) {
//   console.log("elements",elements.products)
//     const { html } = templateOptions;
//     return html`
//       <div class="aa-PanelLayout aa-Panel--scrollable">
//         <div class="aa-PanelSection">
//           ${elements.products}
//         </div>
//       </div>
//     `;
//   });




});





